function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_10458_6632)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1920,
  height: 1080,
  fill: "white"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_dddd_10458_6632)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M956.699 543.7H949.699L946.199 537.7L949.699 531.7H956.699L960.099 537.7L956.699 543.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M943.599 551.3H936.699L933.199 545.2L936.699 539.2H943.599L947.099 545.2L943.599 551.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M956.699 558.8H949.699L946.199 552.8L949.699 546.7H956.699L960.099 552.8L956.699 558.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M969.701 551.3H962.801L959.301 545.2L962.801 539.2H969.701L973.201 545.2L969.701 551.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M969.701 536.2H962.801L959.301 530.2L962.801 524.1H969.701L973.201 530.2L969.701 536.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M956.699 528.7H949.699L946.199 522.6L949.699 516.6H956.699L960.099 522.6L956.699 528.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M943.599 536.2H936.699L933.199 530.2L936.699 524.1H943.599L947.099 530.2L943.599 536.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M930.602 558.8H923.602L920.102 552.8L923.602 546.7H930.602L934.002 552.8L930.602 558.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M943.599 566.3H936.699L933.199 560.3L936.699 554.3H943.599L947.099 560.3L943.599 566.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M956.699 573.9H949.699L946.199 567.8L949.699 561.8H956.699L960.099 567.8L956.699 573.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M969.701 566.3H962.801L959.301 560.3L962.801 554.3H969.701L973.201 560.3L969.701 566.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M982.801 558.8H975.801L972.301 552.8L975.801 546.7H982.801L986.301 552.8L982.801 558.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M982.801 543.7H975.801L972.301 537.7L975.801 531.7H982.801L986.301 537.7L982.801 543.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M982.801 528.7H975.801L972.301 522.6L975.801 516.6H982.801L986.301 522.6L982.801 528.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M969.701 521.1H962.801L959.301 515.1L962.801 509.1H969.701L973.201 515.1L969.701 521.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M956.699 513.6H949.699L946.199 507.6L949.699 501.5H956.699L960.099 507.6L956.699 513.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M943.599 521.1H936.699L933.199 515.1L936.699 509.1H943.599L947.099 515.1L943.599 521.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M930.602 528.7H923.602L920.102 522.6L923.602 516.6H930.602L934.002 522.6L930.602 528.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M930.602 543.7H923.602L920.102 537.7L923.602 531.7H930.602L934.002 537.7L930.602 543.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M917.502 566.3H910.602L907.102 560.3L910.602 554.3H917.502L921.002 560.3L917.502 566.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M930.602 573.9H923.602L920.102 567.8L923.602 561.8H930.602L934.002 567.8L930.602 573.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M943.599 581.4H936.699L933.199 575.4L936.699 569.4H943.599L947.099 575.4L943.599 581.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M956.699 588.9H949.699L946.199 582.9L949.699 576.9H956.699L960.099 582.9L956.699 588.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M969.701 581.4H962.801L959.301 575.4L962.801 569.4H969.701L973.201 575.4L969.701 581.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M982.801 573.9H975.801L972.301 567.8L975.801 561.8H982.801L986.301 567.8L982.801 573.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M995.798 566.3H988.898L985.398 560.3L988.898 554.3H995.798L999.298 560.3L995.798 566.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M995.798 551.3H988.898L985.398 545.2L988.898 539.2H995.798L999.298 545.2L995.798 551.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M995.798 536.2H988.898L985.398 530.2L988.898 524.1H995.798L999.298 530.2L995.798 536.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M995.798 521.1H988.898L985.398 515.1L988.898 509.1H995.798L999.298 515.1L995.798 521.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M982.801 513.6H975.801L972.301 507.6L975.801 501.5H982.801L986.301 507.6L982.801 513.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M969.701 506.1H962.801L959.301 500L962.801 494H969.701L973.201 500L969.701 506.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M956.699 498.5H949.699L946.199 492.5L949.699 486.5H956.699L960.099 492.5L956.699 498.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M943.599 506.1H936.699L933.199 500L936.699 494H943.599L947.099 500L943.599 506.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M930.602 513.6H923.602L920.102 507.6L923.602 501.5H930.602L934.002 507.6L930.602 513.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M917.502 521.1H910.602L907.102 515.1L910.602 509.1H917.502L921.002 515.1L917.502 521.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M917.502 536.2H910.602L907.102 530.2L910.602 524.1H917.502L921.002 530.2L917.502 536.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M917.502 551.3H910.602L907.102 545.2L910.602 539.2H917.502L921.002 545.2L917.502 551.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M904.5 573.9H897.5L894 567.8L897.5 561.8H904.5L907.9 567.8L904.5 573.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M917.502 581.4H910.602L907.102 575.4L910.602 569.4H917.502L921.002 575.4L917.502 581.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M930.602 588.9H923.602L920.102 582.9L923.602 576.9H930.602L934.002 582.9L930.602 588.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M943.599 596.5H936.699L933.199 590.5L936.699 584.4H943.599L947.099 590.5L943.599 596.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M956.699 604H949.699L946.199 598L949.699 592H956.699L960.099 598L956.699 604Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M969.701 596.5H962.801L959.301 590.5L962.801 584.4H969.701L973.201 590.5L969.701 596.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M982.801 588.9H975.801L972.301 582.9L975.801 576.9H982.801L986.301 582.9L982.801 588.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M995.798 581.4H988.898L985.398 575.4L988.898 569.4H995.798L999.298 575.4L995.798 581.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.9 573.9H1001.9L998.398 567.8L1001.9 561.8H1008.9L1012.4 567.8L1008.9 573.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.9 558.8H1001.9L998.398 552.8L1001.9 546.7H1008.9L1012.4 552.8L1008.9 558.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.9 543.7H1001.9L998.398 537.7L1001.9 531.7H1008.9L1012.4 537.7L1008.9 543.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.9 528.7H1001.9L998.398 522.6L1001.9 516.6H1008.9L1012.4 522.6L1008.9 528.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.9 513.6H1001.9L998.398 507.6L1001.9 501.5H1008.9L1012.4 507.6L1008.9 513.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M995.798 506.1H988.898L985.398 500L988.898 494H995.798L999.298 500L995.798 506.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M982.798 498.5H975.798L972.398 492.5L975.798 486.5H982.798L986.198 492.5L982.798 498.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M969.698 490.9H962.798L959.398 485L962.798 479H969.698L973.098 485L969.698 490.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M956.699 483.4H949.699L946.199 477.4L949.699 471.4H956.699L960.099 477.4L956.699 483.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M943.599 491H936.699L933.199 485L936.699 478.9H943.599L947.099 485L943.599 491Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M930.602 498.5H923.602L920.102 492.5L923.602 486.5H930.602L934.002 492.5L930.602 498.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M917.502 506.1H910.602L907.102 500L910.602 494H917.502L921.002 500L917.502 506.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M904.5 513.6H897.5L894 507.6L897.5 501.5H904.5L907.9 507.6L904.5 513.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M904.5 528.7H897.5L894 522.6L897.5 516.6H904.5L907.9 522.6L904.5 528.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M904.5 543.7H897.5L894 537.7L897.5 531.7H904.5L907.9 537.7L904.5 543.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M904.5 558.8H897.5L894 552.8L897.5 546.7H904.5L907.9 552.8L904.5 558.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M891.4 581.4H884.4L881 575.4L884.4 569.4H891.4L894.9 575.4L891.4 581.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M904.5 588.9H897.5L894 582.9L897.5 576.9H904.5L907.9 582.9L904.5 588.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M917.502 596.5H910.602L907.102 590.5L910.602 584.4H917.502L921.002 590.5L917.502 596.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M930.602 604H923.602L920.102 598L923.602 592H930.602L934.002 598L930.602 604Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M943.599 611.6H936.699L933.199 605.5L936.699 599.5H943.599L947.099 605.5L943.599 611.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M956.699 619.1H949.699L946.199 613.1L949.699 607H956.699L960.099 613.1L956.699 619.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M969.701 611.6H962.801L959.301 605.5L962.801 599.5H969.701L973.201 605.5L969.701 611.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M982.801 604H975.801L972.301 598L975.801 592H982.801L986.301 598L982.801 604Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M995.798 596.5H988.898L985.398 590.5L988.898 584.4H995.798L999.298 590.5L995.798 596.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.9 588.9H1001.9L998.398 582.9L1001.9 576.9H1008.9L1012.4 582.9L1008.9 588.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.9 581.4H1015L1011.5 575.4L1015 569.4H1021.9L1025.4 575.4L1021.9 581.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.9 566.3H1015L1011.5 560.3L1015 554.3H1021.9L1025.4 560.3L1021.9 566.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.9 551.3H1015L1011.5 545.2L1015 539.2H1021.9L1025.4 545.2L1021.9 551.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.9 536.2H1015L1011.5 530.2L1015 524.1H1021.9L1025.4 530.2L1021.9 536.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.9 521.1H1015L1011.5 515.1L1015 509.1H1021.9L1025.4 515.1L1021.9 521.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.9 506.1H1015L1011.5 500L1015 494H1021.9L1025.4 500L1021.9 506.1Z",
  fill: "#AF6AF4",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.5 498H1002.2L999.102 492.5L1002.2 487H1008.5L1011.7 492.5L1008.5 498Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M967.201 471.6H965.301L964.301 469.9L965.301 468.2H967.201L968.201 469.9L967.201 471.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M955.298 466.1H950.998L948.898 462.4L950.998 458.6H955.298L957.498 462.4L955.298 466.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M943.498 475.7H936.798L933.398 469.9L936.798 464.1H943.498L946.798 469.9L943.498 475.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M930.602 483.4H923.602L920.102 477.4L923.602 471.4H930.602L934.002 477.4L930.602 483.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M917.502 491H910.602L907.102 485L910.602 478.9H917.502L921.002 485L917.502 491Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M904.5 498.5H897.5L894 492.5L897.5 486.5H904.5L907.9 492.5L904.5 498.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M891.4 506.1H884.4L881 500L884.4 494H891.4L894.9 500L891.4 506.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M891.4 521.1H884.4L881 515.1L884.4 509.1H891.4L894.9 515.1L891.4 521.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M891.4 536.2H884.4L881 530.2L884.4 524.1H891.4L894.9 530.2L891.4 536.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M891.4 551.3H884.4L881 545.2L884.4 539.2H891.4L894.9 545.2L891.4 551.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M891.4 566.3H884.4L881 560.3L884.4 554.3H891.4L894.9 560.3L891.4 566.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M878.398 588.9H871.398L867.898 582.9L871.398 576.9H878.398L881.798 582.9L878.398 588.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M891.4 596.5H884.4L881 590.5L884.4 584.4H891.4L894.9 590.5L891.4 596.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M904.5 604H897.5L894 598L897.5 592H904.5L907.9 598L904.5 604Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M917.502 611.6H910.602L907.102 605.5L910.602 599.5H917.502L921.002 605.5L917.502 611.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M930.602 619.1H923.602L920.102 613.1L923.602 607H930.602L934.002 613.1L930.602 619.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M943.599 626.6H936.699L933.199 620.6L936.699 614.6H943.599L947.099 620.6L943.599 626.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M954.8 630.9H951.6L950 628.1L951.6 625.3H954.8L956.4 628.1L954.8 630.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M969.701 626.6H962.801L959.301 620.6L962.801 614.6H969.701L973.201 620.6L969.701 626.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M982.801 619.1H975.801L972.301 613.1L975.801 607H982.801L986.301 613.1L982.801 619.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M995.798 611.6H988.898L985.398 605.5L988.898 599.5H995.798L999.298 605.5L995.798 611.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.9 604H1001.9L998.398 598L1001.9 592H1008.9L1012.4 598L1008.9 604Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.9 596.5H1015L1011.5 590.5L1015 584.4H1021.9L1025.4 590.5L1021.9 596.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1035 588.9H1028L1024.5 582.9L1028 576.9H1035L1038.5 582.9L1035 588.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1035 573.9H1028L1024.5 567.8L1028 561.8H1035L1038.5 567.8L1035 573.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1035 558.8H1028L1024.5 552.8L1028 546.7H1035L1038.5 552.8L1035 558.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1035 543.7H1028L1024.5 537.7L1028 531.7H1035L1038.5 537.7L1035 543.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1035 528.7H1028L1024.5 522.6L1028 516.6H1035L1038.5 522.6L1035 528.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1035 513.6H1028L1024.5 507.6L1028 501.5H1035L1038.5 507.6L1035 513.6Z",
  fill: "#AF6AF4",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M1034.8 498.2H1028.2L1024.9 492.5L1028.2 486.7H1034.8L1038.1 492.5L1034.8 498.2Z",
  fill: "#AF6AF4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1020 487.7H1016.9L1015.3 485L1016.9 482.2H1020L1021.6 485L1020 487.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M980.198 464H978.398L977.398 462.4L978.398 460.7H980.198L981.098 462.4L980.198 464Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M955.098 450.6H951.298L949.398 447.3L951.298 444H955.098L956.998 447.3L955.098 450.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M916.898 474.8H911.198L908.398 469.9L911.198 465H916.898L919.698 469.9L916.898 474.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M904.402 483.4H897.502L894.102 477.4L897.502 471.5H904.402L907.902 477.4L904.402 483.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M891.4 491H884.4L881 485L884.4 478.9H891.4L894.9 485L891.4 491Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M876.999 496.1H872.799L870.699 492.5L872.799 488.9H876.999L878.999 492.5L876.999 496.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M878.302 513.4H871.502L868.102 507.6L871.502 501.7H878.302L881.602 507.6L878.302 513.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M878.398 528.7H871.398L867.898 522.6L871.398 516.6H878.398L881.798 522.6L878.398 528.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M878.398 543.7H871.398L867.898 537.7L871.398 531.7H878.398L881.798 537.7L878.398 543.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M878.398 558.8H871.398L867.898 552.8L871.398 546.7H878.398L881.798 552.8L878.398 558.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M878.398 573.9H871.398L867.898 567.8L871.398 561.8H878.398L881.798 567.8L878.398 573.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M865.298 596.5H858.298L854.898 590.5L858.298 584.4H865.298L868.798 590.5L865.298 596.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M878.398 604H871.398L867.898 598L871.398 592H878.398L881.798 598L878.398 604Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M891.4 611.6H884.4L881 605.5L884.4 599.5H891.4L894.9 605.5L891.4 611.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M904.5 619.1H897.5L894 613.1L897.5 607H904.5L907.9 613.1L904.5 619.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M917.098 625.9H910.898L907.898 620.6L910.898 615.3H917.098L920.198 620.6L917.098 625.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M928.102 629.9H926.102L925.102 628.1L926.102 626.4H928.102L929.102 628.1L928.102 629.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M954.502 645.4H951.902L950.602 643.2L951.902 641H954.502L955.802 643.2L954.502 645.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M969.701 641.7H962.801L959.301 635.7L962.801 629.6H969.701L973.201 635.7L969.701 641.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M982.801 634.2H975.801L972.301 628.1L975.801 622.1H982.801L986.301 628.1L982.801 634.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M995.798 626.6H988.898L985.398 620.6L988.898 614.6H995.798L999.298 620.6L995.798 626.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.9 619.1H1001.9L998.398 613.1L1001.9 607H1008.9L1012.4 613.1L1008.9 619.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.9 611.6H1015L1011.5 605.5L1015 599.5H1021.9L1025.4 605.5L1021.9 611.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1035 604H1028L1024.5 598L1028 592H1035L1038.5 598L1035 604Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1048 596.5H1041.1L1037.6 590.5L1041.1 584.4H1048L1051.5 590.5L1048 596.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1048 581.4H1041.1L1037.6 575.4L1041.1 569.4H1048L1051.5 575.4L1048 581.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1048 566.3H1041.1L1037.6 560.3L1041.1 554.3H1048L1051.5 560.3L1048 566.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1048 551.3H1041.1L1037.6 545.2L1041.1 539.2H1048L1051.5 545.2L1048 551.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1048 536.2H1041.1L1037.6 530.2L1041.1 524.1H1048L1051.5 530.2L1048 536.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1048 521.1H1041.1L1037.6 515.1L1041.1 509.1H1048L1051.5 515.1L1048 521.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1048 506.1H1041.1L1037.6 500L1041.1 494H1048L1051.5 500L1048 506.1Z",
  fill: "#AF6AF4",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M1020.6 473.7H1016.3L1014.1 469.9L1016.3 466.1H1020.6L1022.8 469.9L1020.6 473.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1007.5 466.1H1003.3L1001.1 462.4L1003.3 458.6H1007.5L1009.7 462.4L1007.5 466.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M980.399 449.1H978.199L977.199 447.3L978.199 445.4H980.399L981.399 447.3L980.399 449.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M967.199 441.5H965.199L964.199 439.7L965.199 438H967.199L968.299 439.7L967.199 441.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M955.699 436.5H950.699L948.199 432.2L950.699 427.9H955.699L958.199 432.2L955.699 436.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M917.3 460.5H910.8L907.5 454.8L910.8 449.2H917.3L920.6 454.8L917.3 460.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M903.599 466.9H898.299L895.699 462.4L898.299 457.8H903.599L906.299 462.4L903.599 466.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M888.602 471.1H887.202L886.602 469.9L887.202 468.7H888.602L889.302 469.9L888.602 471.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M863.798 518.5H859.898L857.898 515.1L859.898 511.7H863.798L865.698 515.1L863.798 518.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M865.298 536.2H858.298L854.898 530.2L858.298 524.1H865.298L868.798 530.2L865.298 536.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M865.298 551.3H858.298L854.898 545.2L858.298 539.2H865.298L868.798 545.2L865.298 551.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M865.298 566.3H858.298L854.898 560.3L858.298 554.3H865.298L868.798 560.3L865.298 566.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M865.298 581.4H858.298L854.898 575.4L858.298 569.4H865.298L868.798 575.4L865.298 581.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M849.498 599.2H848.098L847.398 598L848.098 596.8H849.498L850.098 598L849.498 599.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M865.3 611.5H858.4L855 605.5L858.4 599.6H865.3L868.7 605.5L865.3 611.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M878.398 619.1H871.398L867.898 613.1L871.398 607H878.398L881.798 613.1L878.398 619.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M891.4 626.6H884.4L881 620.6L884.4 614.6H891.4L894.9 620.6L891.4 626.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M903.402 632.3H898.602L896.102 628.1L898.602 623.9H903.402L905.802 628.1L903.402 632.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M956.098 663.3H950.298L947.398 658.3L950.298 653.3H956.098L958.998 658.3L956.098 663.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M969.701 656.8H962.801L959.301 650.7L962.801 644.7H969.701L973.201 650.7L969.701 656.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M982.801 649.2H975.801L972.301 643.2L975.801 637.2H982.801L986.301 643.2L982.801 649.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M995.798 641.7H988.898L985.398 635.7L988.898 629.6H995.798L999.298 635.7L995.798 641.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.9 634.2H1001.9L998.398 628.1L1001.9 622.1H1008.9L1012.4 628.1L1008.9 634.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.9 626.6H1015L1011.5 620.6L1015 614.6H1021.9L1025.4 620.6L1021.9 626.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1035 619.1H1028L1024.5 613.1L1028 607H1035L1038.5 613.1L1035 619.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1048 611.6H1041.1L1037.6 605.5L1041.1 599.5H1048L1051.5 605.5L1048 611.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1061.1 604H1054.1L1050.6 598L1054.1 592H1061.1L1064.6 598L1061.1 604Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1061.1 588.9H1054.1L1050.6 582.9L1054.1 576.9H1061.1L1064.6 582.9L1061.1 588.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1061.1 573.9H1054.1L1050.6 567.8L1054.1 561.8H1061.1L1064.6 567.8L1061.1 573.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1061.1 558.8H1054.1L1050.6 552.8L1054.1 546.7H1061.1L1064.6 552.8L1061.1 558.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1061.1 543.7H1054.1L1050.6 537.7L1054.1 531.7H1061.1L1064.6 537.7L1061.1 543.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1061.1 528.7H1054.1L1050.6 522.6L1054.1 516.6H1061.1L1064.6 522.6L1061.1 528.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1061.1 513.6H1054.1L1050.6 507.6L1054.1 501.5H1061.1L1064.6 507.6L1061.1 513.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1060 496.7H1055.2L1052.7 492.5L1055.2 488.3H1060L1062.5 492.5L1060 496.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1058.2 478.4H1057L1056.5 477.4L1057 476.4H1058.2L1058.7 477.4L1058.2 478.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1046.4 473H1042.7L1040.9 469.9L1042.7 466.7H1046.4L1048.2 469.9L1046.4 473Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1034.8 468.1H1028.2L1024.9 462.4L1028.2 456.6H1034.8L1038.1 462.4L1034.8 468.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1019.7 457H1017.2L1015.9 454.8L1017.2 452.6H1019.7L1021 454.8L1019.7 457Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.8 453.1H1002L998.699 447.3L1002 441.4H1008.8L1012.1 447.3L1008.8 453.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M994.399 443.3H990.299L988.199 439.7L990.299 436.2H994.399L996.399 439.7L994.399 443.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M980.998 435.1H977.598L975.898 432.2L977.598 429.3H980.998L982.598 432.2L980.998 435.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M969.701 430.7H962.801L959.301 424.7L962.801 418.6H969.701L973.201 424.7L969.701 430.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M956.699 423.2H949.699L946.199 417.1L949.699 411.1H956.699L960.099 417.1L956.699 423.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M943 429.6H937.3L934.5 424.7L937.3 419.8H943L945.8 424.7L943 429.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M929.698 436.7H924.498L921.898 432.2L924.498 427.7H929.698L932.198 432.2L929.698 436.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M917.502 445.8H910.602L907.102 439.7L910.602 433.7H917.502L921.002 439.7L917.502 445.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M904.5 453.3H897.5L894 447.3L897.5 441.3H904.5L907.9 447.3L904.5 453.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M891.4 460.8H884.4L881 454.8L884.4 448.8H891.4L894.9 454.8L891.4 460.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M850.198 540.2H847.298L845.898 537.7L847.298 535.2H850.198L851.698 537.7L850.198 540.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M851.898 558.3H845.598L842.398 552.8L845.598 547.3H851.898L855.098 552.8L851.898 558.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M851.898 573.3H845.598L842.398 567.8L845.598 562.4H851.898L855.098 567.8L851.898 573.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M851.898 588.4H845.598L842.398 582.9L845.598 577.4H851.898L855.098 582.9L851.898 588.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M862.399 621.6H861.299L860.699 620.6L861.299 619.6H862.399L862.999 620.6L862.399 621.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M876.1 630.2H873.7L872.5 628.1L873.7 626H876.1L877.3 628.1L876.1 630.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M969.701 671.8H962.801L959.301 665.8L962.801 659.8H969.701L973.201 665.8L969.701 671.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M982.801 664.3H975.801L972.301 658.3L975.801 652.2H982.801L986.301 658.3L982.801 664.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M995.798 656.8H988.898L985.398 650.7L988.898 644.7H995.798L999.298 650.7L995.798 656.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.9 649.2H1001.9L998.398 643.2L1001.9 637.2H1008.9L1012.4 643.2L1008.9 649.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.9 641.7H1015L1011.5 635.7L1015 629.6H1021.9L1025.4 635.7L1021.9 641.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1035 634.2H1028L1024.5 628.1L1028 622.1H1035L1038.5 628.1L1035 634.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1048 626.6H1041.1L1037.6 620.6L1041.1 614.6H1048L1051.5 620.6L1048 626.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1061.1 619.1H1054.1L1050.6 613.1L1054.1 607H1061.1L1064.6 613.1L1061.1 619.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1074.1 611.6H1067.2L1063.7 605.5L1067.2 599.5H1074.1L1077.6 605.5L1074.1 611.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1074.1 596.5H1067.2L1063.7 590.5L1067.2 584.4H1074.1L1077.6 590.5L1074.1 596.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1074.1 581.4H1067.2L1063.7 575.4L1067.2 569.4H1074.1L1077.6 575.4L1074.1 581.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1074.1 566.3H1067.2L1063.7 560.3L1067.2 554.3H1074.1L1077.6 560.3L1074.1 566.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1074.1 551.1H1067.2L1063.8 545.2L1067.2 539.3H1074.1L1077.5 545.2L1074.1 551.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1071.8 532.1H1069.5L1068.4 530.2L1069.5 528.2H1071.8L1072.9 530.2L1071.8 532.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1074.1 521.1H1067.2L1063.7 515.1L1067.2 509.1H1074.1L1077.6 515.1L1074.1 521.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1074.1 506.1H1067.2L1063.7 500L1067.2 494H1074.1L1077.6 500L1074.1 506.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1074.1 491H1067.2L1063.7 485L1067.2 478.9H1074.1L1077.6 485L1074.1 491Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1074.1 475.9H1067.2L1063.7 469.9L1067.2 463.9H1074.1L1077.6 469.9L1074.1 475.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1061 468.3H1054.2L1050.8 462.4L1054.2 456.4H1061L1064.4 462.4L1061 468.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1048 460.8H1041.1L1037.6 454.8L1041.1 448.8H1048L1051.5 454.8L1048 460.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1035 453.3H1028L1024.5 447.3L1028 441.3H1035L1038.5 447.3L1035 453.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.8 445.6H1015.1L1011.7 439.7L1015.1 433.9H1021.8L1025.2 439.7L1021.8 445.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.9 438.2H1001.9L998.398 432.2L1001.9 426.2H1008.9L1012.4 432.2L1008.9 438.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M995.798 430.7H988.898L985.398 424.7L988.898 418.6H995.798L999.298 424.7L995.798 430.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M982.602 422.9H975.902L972.602 417.1L975.902 411.3H982.602L986.002 417.1L982.602 422.9Z",
  fill: "#AF6AF4",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M969.701 415.6H962.801L959.301 409.6L962.801 403.6H969.701L973.201 409.6L969.701 415.6Z",
  fill: "#AF6AF4",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M956.699 408.1H949.699L946.199 402.1L949.699 396H956.699L960.099 402.1L956.699 408.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M943.599 415.6H936.699L933.199 409.6L936.699 403.6H943.599L947.099 409.6L943.599 415.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M930.602 423.2H923.602L920.102 417.1L923.602 411.1H930.602L934.002 417.1L930.602 423.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M917.202 430.2H910.802L907.602 424.7L910.802 419.1H917.202L920.402 424.7L917.202 430.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M904.5 438.2H897.5L894 432.2L897.5 426.2H904.5L907.9 432.2L904.5 438.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M891.4 445.8H884.4L881 439.7L884.4 433.7H891.4L894.9 439.7L891.4 445.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M969.398 686.4H963.098L959.898 680.9L963.098 675.4H969.398L972.598 680.9L969.398 686.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M982.801 679.4H975.801L972.301 673.3L975.801 667.3H982.801L986.301 673.3L982.801 679.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M995.798 671.8H988.898L985.398 665.8L988.898 659.8H995.798L999.298 665.8L995.798 671.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.9 664.3H1001.9L998.398 658.3L1001.9 652.2H1008.9L1012.4 658.3L1008.9 664.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.9 656.8H1015L1011.5 650.7L1015 644.7H1021.9L1025.4 650.7L1021.9 656.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1035 649.2H1028L1024.5 643.2L1028 637.2H1035L1038.5 643.2L1035 649.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1048 641.7H1041.1L1037.6 635.7L1041.1 629.6H1048L1051.5 635.7L1048 641.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1061.1 634.2H1054.1L1050.6 628.1L1054.1 622.1H1061.1L1064.6 628.1L1061.1 634.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1074.1 626.6H1067.2L1063.7 620.6L1067.2 614.6H1074.1L1077.6 620.6L1074.1 626.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1087.2 619.1H1080.2L1076.7 613.1L1080.2 607H1087.2L1090.7 613.1L1087.2 619.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1087.2 604H1080.2L1076.7 598L1080.2 592H1087.2L1090.7 598L1087.2 604Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1087.2 588.9H1080.2L1076.7 582.9L1080.2 576.9H1087.2L1090.7 582.9L1087.2 588.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1086.1 572H1081.3L1078.9 567.8L1081.3 563.7H1086.1L1088.5 567.8L1086.1 572Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1084.4 553.9H1083L1082.4 552.8L1083 551.6H1084.4L1085 552.8L1084.4 553.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1087.2 543.7H1080.2L1076.8 537.7L1080.2 531.7H1087.2L1090.6 537.7L1087.2 543.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1087.2 528.7H1080.2L1076.7 522.6L1080.2 516.6H1087.2L1090.7 522.6L1087.2 528.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1087.2 513.6H1080.2L1076.7 507.6L1080.2 501.5H1087.2L1090.7 507.6L1087.2 513.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1087.2 498.5H1080.2L1076.7 492.5L1080.2 486.5H1087.2L1090.7 492.5L1087.2 498.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1087.2 483.4H1080.2L1076.7 477.4L1080.2 471.4H1087.2L1090.7 477.4L1087.2 483.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1087.2 468.4H1080.2L1076.7 462.4L1080.2 456.3H1087.2L1090.7 462.4L1087.2 468.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1074.1 460.8H1067.2L1063.7 454.8L1067.2 448.8H1074.1L1077.6 454.8L1074.1 460.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1061.1 453.3H1054.1L1050.6 447.3L1054.1 441.3H1061.1L1064.6 447.3L1061.1 453.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1048 445.8H1041.1L1037.6 439.7L1041.1 433.7H1048L1051.5 439.7L1048 445.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1035 438.2H1028L1024.5 432.2L1028 426.2H1035L1038.5 432.2L1035 438.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.9 430.7H1015L1011.5 424.7L1015 418.6H1021.9L1025.4 424.7L1021.9 430.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.9 423.2H1001.9L998.398 417.1L1001.9 411.1H1008.9L1012.4 417.1L1008.9 423.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M995.798 415.6H988.898L985.398 409.6L988.898 403.6H995.798L999.298 409.6L995.798 415.6Z",
  fill: "#AF6AF4",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M982.801 408.1H975.801L972.301 402.1L975.801 396H982.801L986.301 402.1L982.801 408.1Z",
  fill: "#AF6AF4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M969.701 400.6H962.801L959.301 394.5L962.801 388.5H969.701L973.201 394.5L969.701 400.6Z",
  fill: "#AF6AF4",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M956.699 393H949.699L946.199 387L949.699 381H956.699L960.099 387L956.699 393Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M943.599 400.6H936.699L933.199 394.5L936.699 388.5H943.599L947.099 394.5L943.599 400.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M930.602 408.1H923.602L920.102 402.1L923.602 396H930.602L934.002 402.1L930.602 408.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M917.401 415.4H910.701L907.301 409.6L910.701 403.8H917.401L920.701 409.6L917.401 415.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M888.9 426.3H887L886 424.7L887 423H888.9L889.8 424.7L888.9 426.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M823.3 568.9H822.1L821.5 567.8L822.1 566.8H823.3L823.9 567.8L823.3 568.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M968.499 699.9H963.999L961.699 695.9L963.999 692H968.499L970.799 695.9L968.499 699.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M982.801 694.4H975.801L972.301 688.4L975.801 682.4H982.801L986.301 688.4L982.801 694.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M995.798 686.9H988.898L985.398 680.9L988.898 674.8H995.798L999.298 680.9L995.798 686.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.9 679.4H1001.9L998.398 673.3L1001.9 667.3H1008.9L1012.4 673.3L1008.9 679.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.9 671.8H1015L1011.5 665.8L1015 659.8H1021.9L1025.4 665.8L1021.9 671.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1035 664.3H1028L1024.5 658.3L1028 652.2H1035L1038.5 658.3L1035 664.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1048 656.8H1041.1L1037.6 650.7L1041.1 644.7H1048L1051.5 650.7L1048 656.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1061.1 649.2H1054.1L1050.6 643.2L1054.1 637.2H1061.1L1064.6 643.2L1061.1 649.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1074.1 641.7H1067.2L1063.7 635.7L1067.2 629.6H1074.1L1077.6 635.7L1074.1 641.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1087.2 634.2H1080.2L1076.7 628.1L1080.2 622.1H1087.2L1090.7 628.1L1087.2 634.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1100.2 626.6H1093.3L1089.8 620.6L1093.3 614.6H1100.2L1103.7 620.6L1100.2 626.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1100.2 611.6H1093.3L1089.8 605.5L1093.3 599.5H1100.2L1103.7 605.5L1100.2 611.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1100.2 596.4H1093.3L1089.9 590.5L1093.3 584.5H1100.2L1103.6 590.5L1100.2 596.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1097.9 577.4H1095.6L1094.4 575.4L1095.6 573.3H1097.9L1099.1 575.4L1097.9 577.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1099.9 565.7H1093.7L1090.6 560.3L1093.7 554.9H1099.9L1103 560.3L1099.9 565.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1100.2 551.3H1093.3L1089.8 545.2L1093.3 539.2H1100.2L1103.7 545.2L1100.2 551.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1100.2 536.2H1093.3L1089.8 530.2L1093.3 524.1H1100.2L1103.7 530.2L1100.2 536.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1100.2 521.1H1093.3L1089.8 515.1L1093.3 509.1H1100.2L1103.7 515.1L1100.2 521.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1100.2 506.1H1093.3L1089.8 500L1093.3 494H1100.2L1103.7 500L1100.2 506.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1100.2 491H1093.3L1089.8 485L1093.3 478.9H1100.2L1103.7 485L1100.2 491Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1100.2 475.9H1093.3L1089.8 469.9L1093.3 463.9H1100.2L1103.7 469.9L1100.2 475.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1100.2 460.8H1093.3L1089.8 454.8L1093.3 448.8H1100.2L1103.7 454.8L1100.2 460.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1087.2 453.3H1080.2L1076.7 447.3L1080.2 441.3H1087.2L1090.7 447.3L1087.2 453.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1074.1 445.8H1067.2L1063.7 439.7L1067.2 433.7H1074.1L1077.6 439.7L1074.1 445.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1061.1 438.2H1054.1L1050.6 432.2L1054.1 426.2H1061.1L1064.6 432.2L1061.1 438.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1048 430.7H1041.1L1037.6 424.7L1041.1 418.6H1048L1051.5 424.7L1048 430.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1035 423.2H1028L1024.5 417.1L1028 411.1H1035L1038.5 417.1L1035 423.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.9 415.6H1015L1011.5 409.6L1015 403.6H1021.9L1025.4 409.6L1021.9 415.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.9 408.1H1001.9L998.398 402.1L1001.9 396H1008.9L1012.4 402.1L1008.9 408.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M995.798 400.6H988.898L985.398 394.5L988.898 388.5H995.798L999.298 394.5L995.798 400.6Z",
  fill: "#AF6AF4",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M982.801 393H975.801L972.301 387L975.801 381H982.801L986.301 387L982.801 393Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M969.701 385.5H962.801L959.301 379.5L962.801 373.4H969.701L973.201 379.5L969.701 385.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M956.699 378H949.699L946.199 371.9L949.699 365.9H956.699L960.099 371.9L956.699 378Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M943.599 385.5H936.699L933.199 379.5L936.699 373.4H943.599L947.099 379.5L943.599 385.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M930.602 393H923.602L920.102 387L923.602 381H930.602L934.002 387L930.602 393Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M917.502 400.5H910.602L907.102 394.5L910.602 388.6H917.502L920.902 394.5L917.502 400.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M904 407.3H898L895 402.1L898 396.9H904L907 402.1L904 407.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M982.801 709.5H975.801L972.301 703.5L975.801 697.5H982.801L986.301 703.5L982.801 709.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M995.798 702H988.898L985.398 695.9L988.898 689.9H995.798L999.298 695.9L995.798 702Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.9 694.4H1001.9L998.398 688.4L1001.9 682.4H1008.9L1012.4 688.4L1008.9 694.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.9 686.9H1015L1011.5 680.9L1015 674.8H1021.9L1025.4 680.9L1021.9 686.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1035 679.4H1028L1024.5 673.3L1028 667.3H1035L1038.5 673.3L1035 679.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1048 671.8H1041.1L1037.6 665.8L1041.1 659.8H1048L1051.5 665.8L1048 671.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1061.1 664.3H1054.1L1050.6 658.3L1054.1 652.2H1061.1L1064.6 658.3L1061.1 664.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1074.1 656.8H1067.2L1063.7 650.7L1067.2 644.7H1074.1L1077.6 650.7L1074.1 656.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1087.2 649.2H1080.2L1076.7 643.2L1080.2 637.2H1087.2L1090.7 643.2L1087.2 649.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1100.2 641.7H1093.3L1089.8 635.7L1093.3 629.6H1100.2L1103.7 635.7L1100.2 641.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1113.3 634.2H1106.3L1102.8 628.1L1106.3 622.1H1113.3L1116.8 628.1L1113.3 634.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1113.3 619.1H1106.3L1102.8 613.1L1106.3 607H1113.3L1116.8 613.1L1113.3 619.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1113.3 604H1106.3L1102.9 598L1106.3 592H1113.3L1116.7 598L1113.3 604Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1113 588.5H1106.6L1103.3 582.9L1106.6 577.3H1113L1116.3 582.9L1113 588.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1113.3 573.9H1106.3L1102.8 567.8L1106.3 561.8H1113.3L1116.8 567.8L1113.3 573.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1113.3 558.8H1106.3L1102.8 552.8L1106.3 546.7H1113.3L1116.8 552.8L1113.3 558.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1113.3 543.7H1106.3L1102.8 537.7L1106.3 531.7H1113.3L1116.8 537.7L1113.3 543.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1113.3 528.7H1106.3L1102.8 522.6L1106.3 516.6H1113.3L1116.8 522.6L1113.3 528.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1113.3 513.6H1106.3L1102.8 507.6L1106.3 501.5H1113.3L1116.8 507.6L1113.3 513.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1113.3 498.5H1106.3L1102.8 492.5L1106.3 486.5H1113.3L1116.8 492.5L1113.3 498.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1113.3 483.4H1106.3L1102.8 477.4L1106.3 471.4H1113.3L1116.8 477.4L1113.3 483.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1113.3 468.4H1106.3L1102.8 462.4L1106.3 456.3H1113.3L1116.8 462.4L1113.3 468.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1113.3 453.3H1106.3L1102.8 447.3L1106.3 441.3H1113.3L1116.8 447.3L1113.3 453.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1100.2 445.8H1093.3L1089.8 439.7L1093.3 433.7H1100.2L1103.7 439.7L1100.2 445.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1087.2 438.2H1080.2L1076.7 432.2L1080.2 426.2H1087.2L1090.7 432.2L1087.2 438.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1074.1 430.7H1067.2L1063.7 424.7L1067.2 418.6H1074.1L1077.6 424.7L1074.1 430.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1061.1 423.2H1054.1L1050.6 417.1L1054.1 411.1H1061.1L1064.6 417.1L1061.1 423.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1048 415.6H1041.1L1037.6 409.6L1041.1 403.6H1048L1051.5 409.6L1048 415.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1035 408.1H1028L1024.5 402.1L1028 396H1035L1038.5 402.1L1035 408.1Z",
  fill: "#AF6AF4",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.9 400.6H1015L1011.5 394.5L1015 388.5H1021.9L1025.4 394.5L1021.9 400.6Z",
  fill: "#AF6AF4",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.9 393H1001.9L998.398 387L1001.9 381H1008.9L1012.4 387L1008.9 393Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M995.798 385.5H988.898L985.398 379.5L988.898 373.4H995.798L999.298 379.5L995.798 385.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M982.801 378H975.801L972.301 371.9L975.801 365.9H982.801L986.301 371.9L982.801 378Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M969.701 370.4H962.801L959.301 364.4L962.801 358.4H969.701L973.201 364.4L969.701 370.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M956.399 362.4H949.999L946.699 356.9L949.999 351.3H956.399L959.599 356.9L956.399 362.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M941.998 367.7H938.298L936.398 364.4L938.298 361.1H941.998L943.898 364.4L941.998 367.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M927.6 372.9H926.5L926 371.9L926.5 371H927.6L928.2 371.9L927.6 372.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M917.502 385.4H910.602L907.102 379.5L910.602 373.5H917.502L920.902 379.5L917.502 385.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M901.7 388.2H900.3L899.5 387L900.3 385.7H901.7L902.4 387L901.7 388.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M968.302 729.7H964.202L962.102 726.1L964.202 722.5H968.302L970.402 726.1L968.302 729.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M982.801 724.6H975.801L972.301 718.6L975.801 712.5H982.801L986.301 718.6L982.801 724.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M995.798 717H988.898L985.398 711L988.898 705H995.798L999.298 711L995.798 717Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.9 709.5H1001.9L998.398 703.5L1001.9 697.5H1008.9L1012.4 703.5L1008.9 709.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.9 702H1015L1011.5 695.9L1015 689.9H1021.9L1025.4 695.9L1021.9 702Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1035 694.4H1028L1024.5 688.4L1028 682.4H1035L1038.5 688.4L1035 694.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1048 686.9H1041.1L1037.6 680.9L1041.1 674.8H1048L1051.5 680.9L1048 686.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1061.1 679.4H1054.1L1050.6 673.3L1054.1 667.3H1061.1L1064.6 673.3L1061.1 679.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1074.1 671.8H1067.2L1063.7 665.8L1067.2 659.8H1074.1L1077.6 665.8L1074.1 671.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1087.2 664.3H1080.2L1076.7 658.3L1080.2 652.2H1087.2L1090.7 658.3L1087.2 664.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1100 656.4H1093.5L1090.3 650.7L1093.5 645.1H1100L1103.3 650.7L1100 656.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1111.7 646.6H1107.9L1105.9 643.2L1107.9 639.8H1111.7L1113.7 643.2L1111.7 646.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1125.9 625.8H1119.9L1116.9 620.6L1119.9 615.4H1125.9L1128.9 620.6L1125.9 625.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1126.3 611.6H1119.4L1115.9 605.5L1119.4 599.5H1126.3L1129.8 605.5L1126.3 611.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1124.4 593.1H1121.3L1119.8 590.5L1121.3 587.8H1124.4L1125.9 590.5L1124.4 593.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1126.3 581.4H1119.4L1116 575.4L1119.4 569.4H1126.3L1129.8 575.4L1126.3 581.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1126.3 566.3H1119.4L1115.9 560.3L1119.4 554.3H1126.3L1129.8 560.3L1126.3 566.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1126.3 551.3H1119.4L1115.9 545.2L1119.4 539.2H1126.3L1129.8 545.2L1126.3 551.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1126.3 536.2H1119.4L1115.9 530.2L1119.4 524.1H1126.3L1129.8 530.2L1126.3 536.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1126.3 521.1H1119.4L1115.9 515.1L1119.4 509.1H1126.3L1129.8 515.1L1126.3 521.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1126.3 506.1H1119.4L1115.9 500L1119.4 494H1126.3L1129.8 500L1126.3 506.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1126.3 491H1119.4L1115.9 485L1119.4 478.9H1126.3L1129.8 485L1126.3 491Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1126.3 475.9H1119.4L1115.9 469.9L1119.4 463.9H1126.3L1129.8 469.9L1126.3 475.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1126.3 460.8H1119.4L1115.9 454.8L1119.4 448.8H1126.3L1129.8 454.8L1126.3 460.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1126.3 445.8H1119.4L1115.9 439.7L1119.4 433.7H1126.3L1129.8 439.7L1126.3 445.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1113.3 438.2H1106.3L1102.8 432.2L1106.3 426.2H1113.3L1116.8 432.2L1113.3 438.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1100.2 430.7H1093.3L1089.8 424.7L1093.3 418.6H1100.2L1103.7 424.7L1100.2 430.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1087.2 423.2H1080.2L1076.7 417.1L1080.2 411.1H1087.2L1090.7 417.1L1087.2 423.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1074.1 415.6H1067.2L1063.7 409.6L1067.2 403.6H1074.1L1077.6 409.6L1074.1 415.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1061.1 408.1H1054.1L1050.6 402.1L1054.1 396H1061.1L1064.6 402.1L1061.1 408.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1048 400.6H1041.1L1037.6 394.5L1041.1 388.5H1048L1051.5 394.5L1048 400.6Z",
  fill: "#AF6AF4",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M1035 393H1028L1024.5 387L1028 381H1035L1038.5 387L1035 393Z",
  fill: "#AF6AF4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.9 385.5H1015L1011.5 379.5L1015 373.4H1021.9L1025.4 379.5L1021.9 385.5Z",
  fill: "#AF6AF4",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.9 378H1001.9L998.398 371.9L1001.9 365.9H1008.9L1012.4 371.9L1008.9 378Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M995.798 370.4H988.898L985.398 364.4L988.898 358.4H995.798L999.298 364.4L995.798 370.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M981.602 360.9H977.002L974.602 356.9L977.002 352.8H981.602L984.002 356.9L981.602 360.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M968.002 352.4H964.402L962.602 349.3L964.402 346.2H968.002L969.802 349.3L968.002 352.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M955.401 345.5H951.001L948.801 341.8L951.001 338H955.401L957.501 341.8L955.401 345.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M917.502 370.4H910.602L907.102 364.4L910.602 358.4H917.502L921.002 364.4L917.502 370.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M904.5 378H897.5L894 371.9L897.5 365.9H904.5L907.9 371.9L904.5 378Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M969.4 746.6H963.1L960 741.2L963.1 735.8H969.4L972.5 741.2L969.4 746.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M982.801 739.7H975.801L972.301 733.6L975.801 727.6H982.801L986.301 733.6L982.801 739.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M995.798 732.1H988.898L985.398 726.1L988.898 720.1H995.798L999.298 726.1L995.798 732.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.9 724.6H1001.9L998.398 718.6L1001.9 712.5H1008.9L1012.4 718.6L1008.9 724.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.9 717H1015L1011.5 711L1015 705H1021.9L1025.4 711L1021.9 717Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1035 709.5H1028L1024.5 703.5L1028 697.5H1035L1038.5 703.5L1035 709.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1048 702H1041.1L1037.6 695.9L1041.1 689.9H1048L1051.5 695.9L1048 702Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1061.1 694.4H1054.1L1050.6 688.4L1054.1 682.4H1061.1L1064.6 688.4L1061.1 694.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1074.1 686.9H1067.2L1063.7 680.9L1067.2 674.8H1074.1L1077.6 680.9L1074.1 686.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1087.1 679.3H1080.3L1076.9 673.3L1080.3 667.4H1087.1L1090.6 673.3L1087.1 679.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1137.6 600.9H1134.2L1132.6 598L1134.2 595.1H1137.6L1139.3 598L1137.6 600.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1139.4 573.9H1132.4L1129 567.8L1132.4 561.8H1139.4L1142.9 567.8L1139.4 573.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1139.4 558.8H1132.4L1129 552.8L1132.4 546.7H1139.4L1142.9 552.8L1139.4 558.8Z",
  fill: "#AF6AF4",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M1139.4 543.7H1132.4L1129 537.7L1132.4 531.7H1139.4L1142.9 537.7L1139.4 543.7Z",
  fill: "#AF6AF4",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M1139.4 528.6H1132.4L1129 522.6L1132.4 516.6H1139.4L1142.8 522.6L1139.4 528.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1136.9 509.2H1135L1134 507.6L1135 505.9H1136.9L1137.8 507.6L1136.9 509.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1139.4 498.5H1132.4L1129 492.5L1132.4 486.5H1139.4L1142.9 492.5L1139.4 498.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1139.4 483.4H1132.4L1129 477.4L1132.4 471.4H1139.4L1142.9 477.4L1139.4 483.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1139.4 468.4H1132.4L1129 462.4L1132.4 456.3H1139.4L1142.9 462.4L1139.4 468.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1139.4 453.3H1132.4L1129 447.3L1132.4 441.3H1139.4L1142.9 447.3L1139.4 453.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1139.4 438.2H1132.4L1129 432.2L1132.4 426.2H1139.4L1142.9 432.2L1139.4 438.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1126.3 430.7H1119.4L1115.9 424.7L1119.4 418.6H1126.3L1129.8 424.7L1126.3 430.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1113.3 423.2H1106.3L1102.8 417.1L1106.3 411.1H1113.3L1116.8 417.1L1113.3 423.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1100.2 415.6H1093.3L1089.8 409.6L1093.3 403.6H1100.2L1103.7 409.6L1100.2 415.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1087.2 408.1H1080.2L1076.7 402.1L1080.2 396H1087.2L1090.7 402.1L1087.2 408.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1074.1 400.6H1067.2L1063.7 394.5L1067.2 388.5H1074.1L1077.6 394.5L1074.1 400.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1061.1 393H1054.1L1050.6 387L1054.1 381H1061.1L1064.6 387L1061.1 393Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1048 385.5H1041.1L1037.6 379.5L1041.1 373.4H1048L1051.5 379.5L1048 385.5Z",
  fill: "#AF6AF4",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M1035 378H1028L1024.5 371.9L1028 365.9H1035L1038.5 371.9L1035 378Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.9 370.4H1015L1011.5 364.4L1015 358.4H1021.9L1025.4 364.4L1021.9 370.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.9 362.9H1001.9L998.398 356.9L1001.9 350.8H1008.9L1012.4 356.9L1008.9 362.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M982.798 347.8H975.798L972.398 341.8L975.798 335.8H982.798L986.198 341.8L982.798 347.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M969.698 340.2H962.798L959.398 334.2L962.798 328.3H969.698L973.098 334.2L969.698 340.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M956.699 332.7H949.699L946.199 326.7L949.699 320.7H956.699L960.099 326.7L956.699 332.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M941.399 336.4H938.899L937.699 334.2L938.899 332.1H941.399L942.599 334.2L941.399 336.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M916.101 353H911.901L909.801 349.3L911.901 345.7H916.101L918.201 349.3L916.101 353Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M902.902 360.2H899.102L897.102 356.9L899.102 353.5H902.902L904.802 356.9L902.902 360.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M890.902 369.5H885.002L882.102 364.4L885.002 359.3H890.902L893.802 364.4L890.902 369.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M876.302 374.4H873.502L872.102 371.9L873.502 369.5H876.302L877.702 371.9L876.302 374.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M982.801 754.7H975.801L972.301 748.7L975.801 742.7H982.801L986.301 748.7L982.801 754.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M995.798 747.2H988.898L985.398 741.2L988.898 735.1H995.798L999.298 741.2L995.798 747.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.9 739.7H1001.9L998.398 733.6L1001.9 727.6H1008.9L1012.4 733.6L1008.9 739.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.9 732.1H1015L1011.5 726.1L1015 720.1H1021.9L1025.4 726.1L1021.9 732.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1035 724.6H1028L1024.5 718.6L1028 712.5H1035L1038.5 718.6L1035 724.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1048 717H1041.1L1037.6 711L1041.1 705H1048L1051.5 711L1048 717Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1061.1 709.5H1054.1L1050.6 703.5L1054.1 697.5H1061.1L1064.6 703.5L1061.1 709.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1074.1 702H1067.2L1063.7 695.9L1067.2 689.9H1074.1L1077.6 695.9L1074.1 702Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1087.1 694.4H1080.3L1076.8 688.4L1080.3 682.5H1087.1L1090.6 688.4L1087.1 694.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1152.3 566.2H1145.6L1142.2 560.3L1145.6 554.4H1152.3L1155.7 560.3L1152.3 566.2Z",
  fill: "#AF6AF4",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M1152.4 551.3H1145.5L1142 545.2L1145.5 539.2H1152.4L1155.9 545.2L1152.4 551.3Z",
  fill: "#AF6AF4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1152.3 536H1145.6L1142.2 530.2L1145.6 524.3H1152.3L1155.7 530.2L1152.3 536Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1151.8 520H1146.1L1143.3 515.1L1146.1 510.2H1151.8L1154.6 515.1L1151.8 520Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1152.4 506.1H1145.5L1142 500L1145.5 494H1152.4L1155.9 500L1152.4 506.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1152.4 491H1145.5L1142 485L1145.5 478.9H1152.4L1155.9 485L1152.4 491Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1152.4 475.9H1145.5L1142 469.9L1145.5 463.9H1152.4L1155.9 469.9L1152.4 475.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1152.4 460.8H1145.5L1142 454.8L1145.5 448.8H1152.4L1155.9 454.8L1152.4 460.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1152.4 445.8H1145.5L1142 439.7L1145.5 433.7H1152.4L1155.9 439.7L1152.4 445.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1152.4 430.7H1145.5L1142 424.7L1145.5 418.6H1152.4L1155.9 424.7L1152.4 430.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1139.4 423.2H1132.4L1129 417.1L1132.4 411.1H1139.4L1142.9 417.1L1139.4 423.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1126.3 415.6H1119.4L1115.9 409.6L1119.4 403.6H1126.3L1129.8 409.6L1126.3 415.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1113.3 408.1H1106.3L1102.8 402.1L1106.3 396H1113.3L1116.8 402.1L1113.3 408.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1100.2 400.6H1093.3L1089.8 394.5L1093.3 388.5H1100.2L1103.7 394.5L1100.2 400.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1087.2 393H1080.2L1076.7 387L1080.2 381H1087.2L1090.7 387L1087.2 393Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1074.1 385.5H1067.2L1063.7 379.5L1067.2 373.4H1074.1L1077.6 379.5L1074.1 385.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1061.1 378H1054.1L1050.6 371.9L1054.1 365.9H1061.1L1064.6 371.9L1061.1 378Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1048 370.4H1041.1L1037.6 364.4L1041.1 358.4H1048L1051.5 364.4L1048 370.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1035 362.9H1028L1024.5 356.9L1028 350.8H1035L1038.5 356.9L1035 362.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.9 355.3H1015L1011.5 349.3L1015 343.3H1021.9L1025.4 349.3L1021.9 355.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.7 347.5H1002.1L998.801 341.8L1002.1 336.1H1008.7L1012 341.8L1008.7 347.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M993 335.4H991.7L991 334.2L991.7 333.1H993L993.7 334.2L993 335.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M982.801 332.7H975.801L972.301 326.7L975.801 320.7H982.801L986.301 326.7L982.801 332.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M969.701 325.2H962.801L959.301 319.2L962.801 313.1H969.701L973.201 319.2L969.701 325.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M956.699 317.7H949.699L946.199 311.6L949.699 305.6H956.699L960.099 311.6L956.699 317.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M943.099 324.3H937.199L934.199 319.2L937.199 314.1H943.099L945.999 319.2L943.099 324.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M904.402 347.7H897.502L894.102 341.8L897.502 335.8H904.402L907.902 341.8L904.402 347.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M758.698 668H756.098L754.898 665.8L756.098 663.6H758.698L759.998 665.8L758.698 668Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M982.7 769.7H975.9L972.5 763.8L975.9 757.9H982.7L986.1 763.8L982.7 769.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M995.798 762.3H988.898L985.398 756.2L988.898 750.2H995.798L999.298 756.2L995.798 762.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.9 754.7H1001.9L998.398 748.7L1001.9 742.7H1008.9L1012.4 748.7L1008.9 754.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.9 747.2H1015L1011.5 741.2L1015 735.1H1021.9L1025.4 741.2L1021.9 747.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1035 739.7H1028L1024.5 733.6L1028 727.6H1035L1038.5 733.6L1035 739.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1048 732.1H1041.1L1037.6 726.1L1041.1 720.1H1048L1051.5 726.1L1048 732.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1061.1 724.6H1054.1L1050.6 718.6L1054.1 712.5H1061.1L1064.6 718.6L1061.1 724.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1074.1 717H1067.2L1063.7 711L1067.2 705H1074.1L1077.6 711L1074.1 717Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1087.2 709.5H1080.2L1076.7 703.5L1080.2 697.5H1087.2L1090.7 703.5L1087.2 709.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1165.2 558.2H1158.9L1155.7 552.8L1158.9 547.3H1165.2L1168.3 552.8L1165.2 558.2Z",
  fill: "#AF6AF4",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M1165.1 543.1H1158.9L1155.8 537.7L1158.9 532.3H1165.1L1168.2 537.7L1165.1 543.1Z",
  fill: "#AF6AF4",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M1164.8 527.5H1159.2L1156.4 522.6L1159.2 517.8H1164.8L1167.6 522.6L1164.8 527.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1165.5 513.6H1158.5L1155.1 507.6L1158.5 501.5H1165.5L1169 507.6L1165.5 513.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1165.5 498.5H1158.5L1155.1 492.5L1158.5 486.5H1165.5L1169 492.5L1165.5 498.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1165.5 483.4H1158.5L1155.1 477.4L1158.5 471.4H1165.5L1169 477.4L1165.5 483.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1165.5 468.4H1158.5L1155.1 462.4L1158.5 456.3H1165.5L1169 462.4L1165.5 468.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1165.5 453.3H1158.5L1155.1 447.3L1158.5 441.3H1165.5L1169 447.3L1165.5 453.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1165.5 438.2H1158.5L1155.1 432.2L1158.5 426.2H1165.5L1169 432.2L1165.5 438.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1165.5 423.2H1158.5L1155.1 417.1L1158.5 411.1H1165.5L1169 417.1L1165.5 423.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1152.4 415.6H1145.5L1142 409.6L1145.5 403.6H1152.4L1155.9 409.6L1152.4 415.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1139.4 408.1H1132.4L1129 402.1L1132.4 396H1139.4L1142.9 402.1L1139.4 408.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1126.3 400.6H1119.4L1115.9 394.5L1119.4 388.5H1126.3L1129.8 394.5L1126.3 400.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1113.3 393H1106.3L1102.8 387L1106.3 381H1113.3L1116.8 387L1113.3 393Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1100.2 385.5H1093.3L1089.8 379.5L1093.3 373.4H1100.2L1103.7 379.5L1100.2 385.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1087.2 378H1080.2L1076.7 371.9L1080.2 365.9H1087.2L1090.7 371.9L1087.2 378Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1074.1 370.4H1067.2L1063.7 364.4L1067.2 358.4H1074.1L1077.6 364.4L1074.1 370.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1061.1 362.9H1054.1L1050.6 356.9L1054.1 350.8H1061.1L1064.6 356.9L1061.1 362.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1048 355.3H1041.1L1037.6 349.3L1041.1 343.3H1048L1051.5 349.3L1048 355.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1035 347.8H1028L1024.5 341.8L1028 335.8H1035L1038.5 341.8L1035 347.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.9 340.3H1015L1011.5 334.2L1015 328.2H1021.9L1025.4 334.2L1021.9 340.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M982.801 317.7H975.801L972.301 311.6L975.801 305.6H982.801L986.301 311.6L982.801 317.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M969.701 310.1H962.801L959.301 304.1L962.801 298.1H969.701L973.201 304.1L969.701 310.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M955.702 301H950.602L948.102 296.6L950.602 292.2H955.702L958.302 296.6L955.702 301Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M940.801 305.3H939.501L938.801 304.1L939.501 302.9H940.801L941.501 304.1L940.801 305.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M901.702 327.9H900.302L899.602 326.7L900.302 325.5H901.702L902.302 326.7L901.702 327.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M734.801 671.8H727.801L724.301 665.8L727.801 659.8H734.801L738.301 665.8L734.801 671.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M747.798 679.4H740.898L737.398 673.3L740.898 667.3H747.798L751.298 673.3L747.798 679.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M760.9 686.9H753.9L750.5 680.9L753.9 674.8H760.9L764.4 680.9L760.9 686.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M982.001 783.6H976.501L973.801 778.8L976.501 774.1H982.001L984.801 778.8L982.001 783.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M995.798 777.3H988.898L985.398 771.3L988.898 765.3H995.798L999.298 771.3L995.798 777.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.9 769.8H1001.9L998.398 763.8L1001.9 757.7H1008.9L1012.4 763.8L1008.9 769.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.9 762.3H1015L1011.5 756.2L1015 750.2H1021.9L1025.4 756.2L1021.9 762.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1035 754.7H1028L1024.5 748.7L1028 742.7H1035L1038.5 748.7L1035 754.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1048 747.2H1041.1L1037.6 741.2L1041.1 735.1H1048L1051.5 741.2L1048 747.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1061.1 739.7H1054.1L1050.6 733.6L1054.1 727.6H1061.1L1064.6 733.6L1061.1 739.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1074.1 732.1H1067.2L1063.7 726.1L1067.2 720.1H1074.1L1077.6 726.1L1074.1 732.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1087.2 724.5H1080.3L1076.8 718.6L1080.3 712.6H1087.2L1090.6 718.6L1087.2 724.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1176.1 531.9H1174.1L1173 530.2L1174.1 528.4H1176.1L1177.1 530.2L1176.1 531.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1178.5 521.1H1171.6L1168.1 515.1L1171.6 509.1H1178.5L1182 515.1L1178.5 521.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1178.5 506.1H1171.6L1168.1 500L1171.6 494H1178.5L1182 500L1178.5 506.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1178.5 491H1171.6L1168.1 485L1171.6 478.9H1178.5L1182 485L1178.5 491Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1178.5 475.9H1171.6L1168.1 469.9L1171.6 463.9H1178.5L1182 469.9L1178.5 475.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1178.5 460.8H1171.6L1168.1 454.8L1171.6 448.8H1178.5L1182 454.8L1178.5 460.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1178.5 445.8H1171.6L1168.1 439.7L1171.6 433.7H1178.5L1182 439.7L1178.5 445.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1178.5 430.7H1171.6L1168.1 424.7L1171.6 418.6H1178.5L1182 424.7L1178.5 430.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1178.5 415.6H1171.6L1168.1 409.6L1171.6 403.6H1178.5L1182 409.6L1178.5 415.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1165.5 408.1H1158.5L1155.1 402.1L1158.5 396H1165.5L1169 402.1L1165.5 408.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1152.4 400.6H1145.5L1142 394.5L1145.5 388.5H1152.4L1155.9 394.5L1152.4 400.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1139.4 393H1132.4L1129 387L1132.4 381H1139.4L1142.9 387L1139.4 393Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1126.3 385.5H1119.4L1115.9 379.5L1119.4 373.4H1126.3L1129.8 379.5L1126.3 385.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1113.3 378H1106.3L1102.8 371.9L1106.3 365.9H1113.3L1116.8 371.9L1113.3 378Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1100.2 370.4H1093.3L1089.8 364.4L1093.3 358.4H1100.2L1103.7 364.4L1100.2 370.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1087.2 362.9H1080.2L1076.7 356.9L1080.2 350.8H1087.2L1090.7 356.9L1087.2 362.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1074.1 355.3H1067.2L1063.7 349.3L1067.2 343.3H1074.1L1077.6 349.3L1074.1 355.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1061.1 347.8H1054.1L1050.6 341.8L1054.1 335.8H1061.1L1064.6 341.8L1061.1 347.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1048 340.3H1041.1L1037.6 334.2L1041.1 328.2H1048L1051.5 334.2L1048 340.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1034.9 332.6H1028.1L1024.6 326.7L1028.1 320.8H1034.9L1038.3 326.7L1034.9 332.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.9 325.1H1015L1011.6 319.2L1015 313.2H1021.9L1025.3 319.2L1021.9 325.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.9 317.7H1001.9L998.398 311.6L1001.9 305.6H1008.9L1012.4 311.6L1008.9 317.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M994.298 307.5H990.398L988.398 304.1L990.398 300.7H994.298L996.298 304.1L994.298 307.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M982.801 302.6H975.801L972.301 296.6L975.801 290.5H982.801L986.301 296.6L982.801 302.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M969.502 294.8H962.902L959.602 289L962.902 283.3H969.502L972.802 289L969.502 294.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M721.701 679.4H714.801L711.301 673.3L714.801 667.3H721.701L725.201 673.3L721.701 679.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M734.801 686.9H727.801L724.301 680.9L727.801 674.8H734.801L738.301 680.9L734.801 686.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M747.798 694.4H740.898L737.398 688.4L740.898 682.4H747.798L751.298 688.4L747.798 694.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M760.598 701.6H754.198L750.898 695.9L754.198 690.3H760.598L763.898 695.9L760.598 701.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M980.501 796.1H978.001L976.801 793.9L978.001 791.8H980.501L981.801 793.9L980.501 796.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M995.798 792.4H988.898L985.398 786.4L988.898 780.3H995.798L999.298 786.4L995.798 792.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.9 784.9H1001.9L998.398 778.8L1001.9 772.8H1008.9L1012.4 778.8L1008.9 784.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.9 777.3H1015L1011.5 771.3L1015 765.3H1021.9L1025.4 771.3L1021.9 777.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1035 769.8H1028L1024.5 763.8L1028 757.7H1035L1038.5 763.8L1035 769.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1048 762.3H1041.1L1037.6 756.2L1041.1 750.2H1048L1051.5 756.2L1048 762.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1061.1 754.7H1054.1L1050.6 748.7L1054.1 742.7H1061.1L1064.6 748.7L1061.1 754.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1073.5 746H1067.9L1065.1 741.2L1067.9 736.3H1073.5L1076.2 741.2L1073.5 746Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1084.7 735.3H1082.7L1081.7 733.6L1082.7 731.9H1084.7L1085.7 733.6L1084.7 735.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1125.8 716.1H1119.9L1116.9 711L1119.9 705.9H1125.8L1128.8 711L1125.8 716.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1191.6 528.6H1184.7L1181.2 522.6L1184.7 516.6H1191.6L1195.1 522.6L1191.6 528.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1191.6 513.6H1184.6L1181.2 507.6L1184.6 501.5H1191.6L1195.1 507.6L1191.6 513.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1191.6 498.5H1184.6L1181.2 492.5L1184.6 486.5H1191.6L1195.1 492.5L1191.6 498.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1191.6 483.4H1184.6L1181.2 477.4L1184.6 471.4H1191.6L1195.1 477.4L1191.6 483.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1191.6 468.4H1184.6L1181.2 462.4L1184.6 456.3H1191.6L1195.1 462.4L1191.6 468.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1191.6 453.3H1184.6L1181.2 447.3L1184.6 441.3H1191.6L1195.1 447.3L1191.6 453.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1191.6 438.2H1184.6L1181.2 432.2L1184.6 426.2H1191.6L1195.1 432.2L1191.6 438.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1191.6 423.2H1184.6L1181.2 417.1L1184.6 411.1H1191.6L1195.1 417.1L1191.6 423.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1191.6 408.1H1184.6L1181.2 402.1L1184.6 396H1191.6L1195.1 402.1L1191.6 408.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1178.5 400.6H1171.6L1168.1 394.5L1171.6 388.5H1178.5L1182 394.5L1178.5 400.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1165.5 393H1158.5L1155.1 387L1158.5 381H1165.5L1169 387L1165.5 393Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1152.4 385.5H1145.5L1142 379.5L1145.5 373.4H1152.4L1155.9 379.5L1152.4 385.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1139.4 378H1132.4L1129 371.9L1132.4 365.9H1139.4L1142.9 371.9L1139.4 378Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1126.3 370.4H1119.4L1115.9 364.4L1119.4 358.4H1126.3L1129.8 364.4L1126.3 370.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1113.3 362.9H1106.3L1102.8 356.9L1106.3 350.8H1113.3L1116.8 356.9L1113.3 362.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1100.2 355.3H1093.3L1089.8 349.3L1093.3 343.3H1100.2L1103.7 349.3L1100.2 355.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1087.2 347.8H1080.2L1076.7 341.8L1080.2 335.8H1087.2L1090.7 341.8L1087.2 347.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1074.1 340.3H1067.2L1063.7 334.2L1067.2 328.2H1074.1L1077.6 334.2L1074.1 340.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1061.1 332.7H1054.1L1050.6 326.7L1054.1 320.7H1061.1L1064.6 326.7L1061.1 332.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1048 325.2H1041.1L1037.6 319.2L1041.1 313.1H1048L1051.5 319.2L1048 325.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1035 317.7H1028L1024.5 311.6L1028 305.6H1035L1038.5 311.6L1035 317.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.9 310.1H1015L1011.5 304.1L1015 298.1H1021.9L1025.4 304.1L1021.9 310.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1007.1 299.6H1003.6L1001.9 296.6L1003.6 293.5H1007.1L1008.9 296.6L1007.1 299.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M995.798 295.1H988.898L985.398 289L988.898 283H995.798L999.298 289L995.798 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M982.801 287.5H975.801L972.301 281.5L975.801 275.5H982.801L986.301 281.5L982.801 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M721.102 663.2H715.402L712.602 658.3L715.402 653.4H721.102L723.902 658.3L721.102 663.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M708.699 686.9H701.699L698.199 680.9L701.699 674.8H708.699L712.199 680.9L708.699 686.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M721.701 694.4H714.801L711.301 688.4L714.801 682.4H721.701L725.201 688.4L721.701 694.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M734.801 702H727.801L724.301 695.9L727.801 689.9H734.801L738.301 695.9L734.801 702Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M747.798 709.5H740.898L737.398 703.5L740.898 697.5H747.798L751.298 703.5L747.798 709.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M995.798 807.5H988.898L985.398 801.4L988.898 795.4H995.798L999.298 801.4L995.798 807.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.9 799.9H1001.9L998.398 793.9L1001.9 787.9H1008.9L1012.4 793.9L1008.9 799.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.9 792.4H1015L1011.5 786.4L1015 780.3H1021.9L1025.4 786.4L1021.9 792.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1035 784.9H1028L1024.5 778.8L1028 772.8H1035L1038.5 778.8L1035 784.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1048 777.3H1041.1L1037.6 771.3L1041.1 765.3H1048L1051.5 771.3L1048 777.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1061.1 769.8H1054.1L1050.6 763.8L1054.1 757.7H1061.1L1064.6 763.8L1061.1 769.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1071.2 757.2H1070.1L1069.6 756.2L1070.1 755.3H1071.2L1071.7 756.2L1071.2 757.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1113.3 739.7H1106.3L1102.8 733.6L1106.3 727.6H1113.3L1116.8 733.6L1113.3 739.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1126.3 732.1H1119.4L1115.9 726.1L1119.4 720.1H1126.3L1129.8 726.1L1126.3 732.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1203.4 534.1H1198.9L1196.6 530.2L1198.9 526.2H1203.4L1205.7 530.2L1203.4 534.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1204.7 521.1H1197.7L1194.2 515.1L1197.7 509.1H1204.7L1208.1 515.1L1204.7 521.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1204.7 506.1H1197.7L1194.2 500L1197.7 494H1204.7L1208.1 500L1204.7 506.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1204.7 491H1197.7L1194.2 485L1197.7 478.9H1204.7L1208.1 485L1204.7 491Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1204.7 475.9H1197.7L1194.2 469.9L1197.7 463.9H1204.7L1208.1 469.9L1204.7 475.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1204.7 460.8H1197.7L1194.2 454.8L1197.7 448.8H1204.7L1208.1 454.8L1204.7 460.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1204.7 445.8H1197.7L1194.2 439.7L1197.7 433.7H1204.7L1208.1 439.7L1204.7 445.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1204.7 430.7H1197.7L1194.2 424.7L1197.7 418.6H1204.7L1208.1 424.7L1204.7 430.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1204.7 415.6H1197.7L1194.2 409.6L1197.7 403.6H1204.7L1208.1 409.6L1204.7 415.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1204.7 400.6H1197.7L1194.2 394.5L1197.7 388.5H1204.7L1208.1 394.5L1204.7 400.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1191.6 393H1184.6L1181.2 387L1184.6 381H1191.6L1195.1 387L1191.6 393Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1178.5 385.5H1171.6L1168.1 379.5L1171.6 373.4H1178.5L1182 379.5L1178.5 385.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1165.5 378H1158.5L1155.1 371.9L1158.5 365.9H1165.5L1169 371.9L1165.5 378Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1152.4 370.4H1145.5L1142 364.4L1145.5 358.4H1152.4L1155.9 364.4L1152.4 370.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1139.4 362.9H1132.4L1129 356.9L1132.4 350.8H1139.4L1142.9 356.9L1139.4 362.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1126.3 355.3H1119.4L1115.9 349.3L1119.4 343.3H1126.3L1129.8 349.3L1126.3 355.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1113.3 347.8H1106.3L1102.8 341.8L1106.3 335.8H1113.3L1116.8 341.8L1113.3 347.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1100.2 340.3H1093.3L1089.8 334.2L1093.3 328.2H1100.2L1103.7 334.2L1100.2 340.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1087.2 332.7H1080.2L1076.7 326.7L1080.2 320.7H1087.2L1090.7 326.7L1087.2 332.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1074.1 325.2H1067.2L1063.7 319.2L1067.2 313.1H1074.1L1077.6 319.2L1074.1 325.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1061.1 317.7H1054.1L1050.6 311.6L1054.1 305.6H1061.1L1064.6 311.6L1061.1 317.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1048 310.1H1041.1L1037.6 304.1L1041.1 298.1H1048L1051.5 304.1L1048 310.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1035 302.6H1028L1024.5 296.6L1028 290.5H1035L1038.5 296.6L1035 302.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.9 295.1H1015L1011.5 289L1015 283H1021.9L1025.4 289L1021.9 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.8 287.5H1002L998.5 281.5L1002 275.5H1008.8L1012.3 281.5L1008.8 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M995.798 280H988.898L985.398 274L988.898 267.9H995.798L999.298 274L995.798 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M982 271H976.6L974 266.4L976.6 261.8H982L984.6 266.4L982 271Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M707.3 654.4H703.1L701 650.7L703.1 647.1H707.3L709.4 650.7L707.3 654.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M708.699 671.8H701.699L698.199 665.8L701.699 659.8H708.699L712.199 665.8L708.699 671.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M695.599 694.4H688.699L685.199 688.4L688.699 682.4H695.599L699.099 688.4L695.599 694.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M708.699 702H701.699L698.199 695.9L701.699 689.9H708.699L712.199 695.9L708.699 702Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M721.701 709.5H714.801L711.301 703.5L714.801 697.5H721.701L725.201 703.5L721.701 709.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M734.801 717H727.801L724.301 711L727.801 705H734.801L738.301 711L734.801 717Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M747.202 723.5H741.502L738.602 718.6L741.502 713.6H747.202L750.102 718.6L747.202 723.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M995.401 821.7H989.301L986.301 816.5L989.301 811.3H995.401L998.401 816.5L995.401 821.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.9 815H1001.9L998.398 809L1001.9 803H1008.9L1012.4 809L1008.9 815Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.9 807.5H1015L1011.5 801.4L1015 795.4H1021.9L1025.4 801.4L1021.9 807.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1035 799.9H1028L1024.5 793.9L1028 787.9H1035L1038.5 793.9L1035 799.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1048 792.4H1041.1L1037.6 786.4L1041.1 780.3H1048L1051.5 786.4L1048 792.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1058.2 779.9H1057L1056.3 778.8L1057 777.7H1058.2L1058.9 778.8L1058.2 779.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1098.1 758.5H1095.4L1094.1 756.2L1095.4 754H1098.1L1099.4 756.2L1098.1 758.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1113.3 754.7H1106.3L1102.8 748.7L1106.3 742.7H1113.3L1116.8 748.7L1113.3 754.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1126.1 746.8H1119.6L1116.4 741.2L1119.6 735.5H1126.1L1129.4 741.2L1126.1 746.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1217.5 543.4H1210.9L1207.6 537.7L1210.9 532H1217.5L1220.8 537.7L1217.5 543.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1217.7 528.7H1210.7L1207.3 522.6L1210.7 516.6H1217.7L1221.2 522.6L1217.7 528.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1217.7 513.6H1210.7L1207.3 507.6L1210.7 501.5H1217.7L1221.2 507.6L1217.7 513.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1217.7 498.5H1210.7L1207.3 492.5L1210.7 486.5H1217.7L1221.2 492.5L1217.7 498.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1217.7 483.4H1210.7L1207.3 477.4L1210.7 471.4H1217.7L1221.2 477.4L1217.7 483.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1217.7 468.4H1210.7L1207.3 462.4L1210.7 456.3H1217.7L1221.2 462.4L1217.7 468.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1217.7 453.3H1210.7L1207.3 447.3L1210.7 441.3H1217.7L1221.2 447.3L1217.7 453.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1217.7 438.2H1210.7L1207.3 432.2L1210.7 426.2H1217.7L1221.2 432.2L1217.7 438.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1217.7 423.2H1210.7L1207.3 417.1L1210.7 411.1H1217.7L1221.2 417.1L1217.7 423.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1217.7 408.1H1210.7L1207.3 402.1L1210.7 396H1217.7L1221.2 402.1L1217.7 408.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1217.7 393H1210.7L1207.3 387L1210.7 381H1217.7L1221.2 387L1217.7 393Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1204.7 385.5H1197.7L1194.2 379.5L1197.7 373.4H1204.7L1208.1 379.5L1204.7 385.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1191.6 378H1184.6L1181.2 371.9L1184.6 365.9H1191.6L1195.1 371.9L1191.6 378Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1178.5 370.4H1171.6L1168.1 364.4L1171.6 358.4H1178.5L1182 364.4L1178.5 370.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1165.5 362.9H1158.5L1155.1 356.9L1158.5 350.8H1165.5L1169 356.9L1165.5 362.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1152.4 355.3H1145.5L1142 349.3L1145.5 343.3H1152.4L1155.9 349.3L1152.4 355.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1139.4 347.8H1132.4L1129 341.8L1132.4 335.8H1139.4L1142.9 341.8L1139.4 347.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1126.3 340.3H1119.4L1115.9 334.2L1119.4 328.2H1126.3L1129.8 334.2L1126.3 340.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1113.3 332.7H1106.3L1102.8 326.7L1106.3 320.7H1113.3L1116.8 326.7L1113.3 332.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1100.2 325.2H1093.3L1089.8 319.2L1093.3 313.1H1100.2L1103.7 319.2L1100.2 325.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1087.2 317.7H1080.2L1076.7 311.6L1080.2 305.6H1087.2L1090.7 311.6L1087.2 317.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1074.1 310.1H1067.2L1063.7 304.1L1067.2 298.1H1074.1L1077.6 304.1L1074.1 310.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1060.3 301.3H1054.9L1052.1 296.6L1054.9 291.8H1060.3L1063.1 296.6L1060.3 301.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1048 295.1H1041.1L1037.6 289L1041.1 283H1048L1051.5 289L1048 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1035 287.5H1028L1024.5 281.5L1028 275.5H1035L1038.5 281.5L1035 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.9 280H1015L1011.5 274L1015 267.9H1021.9L1025.4 274L1021.9 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.9 272.5H1001.9L998.398 266.4L1001.9 260.4H1008.9L1012.4 266.4L1008.9 272.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M995.399 264.2H989.299L986.199 258.9L989.299 253.6H995.399L998.499 258.9L995.399 264.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M864.8 294.1H858.9L856 289L858.9 284H864.8L867.7 289L864.8 294.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M851.9 302H845.6L842.5 296.6L845.6 291.1H851.9L855.1 296.6L851.9 302Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M695.498 407.9H688.798L685.398 402.1L688.798 396.2H695.498L698.898 402.1L695.498 407.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M694.402 632H689.902L687.602 628.1L689.902 624.2H694.402L696.702 628.1L694.402 632Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M695.498 649H688.798L685.398 643.2L688.798 637.4H695.498L698.898 643.2L695.498 649Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M695.599 664.3H688.699L685.199 658.3L688.699 652.2H695.599L699.099 658.3L695.599 664.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M695.599 679.4H688.699L685.199 673.3L688.699 667.3H695.599L699.099 673.3L695.599 679.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M682.602 702H675.602L672.102 695.9L675.602 689.9H682.602L686.102 695.9L682.602 702Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M695.599 709.5H688.699L685.199 703.5L688.699 697.5H695.599L699.099 703.5L695.599 709.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M708.699 717H701.699L698.199 711L701.699 705H708.699L712.199 711L708.699 717Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M721.701 724.6H714.801L711.301 718.6L714.801 712.5H721.701L725.201 718.6L721.701 724.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M734.801 732.1H727.801L724.301 726.1L727.801 720.1H734.801L738.301 726.1L734.801 732.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M745.201 735H743.601L742.801 733.6L743.601 732.3H745.201L745.901 733.6L745.201 735Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1007.3 827.3H1003.5L1001.6 824L1003.5 820.8H1007.3L1009.2 824L1007.3 827.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.2 821.2H1015.7L1013 816.5L1015.7 811.8H1021.2L1023.9 816.5L1021.2 821.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1034.9 814.8H1028.1L1024.7 809L1028.1 803.1H1034.9L1038.3 809L1034.9 814.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1045.2 802.5H1043.9L1043.3 801.4L1043.9 800.4H1045.2L1045.8 801.4L1045.2 802.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1098 773.5H1095.5L1094.2 771.3L1095.5 769.1H1098L1099.3 771.3L1098 773.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1113.3 769.8H1106.3L1102.8 763.8L1106.3 757.7H1113.3L1116.8 763.8L1113.3 769.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1125 760H1120.7L1118.5 756.2L1120.7 752.5H1125L1127.2 756.2L1125 760Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1228.3 577.2H1226.2L1225.1 575.4L1226.2 573.5H1228.3L1229.4 575.4L1228.3 577.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1230.6 566H1224L1220.7 560.3L1224 554.6H1230.6L1233.9 560.3L1230.6 566Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1230.8 551.3H1223.8L1220.3 545.2L1223.8 539.2H1230.8L1234.2 545.2L1230.8 551.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1230.8 536.2H1223.8L1220.3 530.2L1223.8 524.1H1230.8L1234.2 530.2L1230.8 536.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1230.8 521.1H1223.8L1220.3 515.1L1223.8 509.1H1230.8L1234.2 515.1L1230.8 521.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1230.8 506.1H1223.8L1220.3 500L1223.8 494H1230.8L1234.2 500L1230.8 506.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1230.8 491H1223.8L1220.3 485L1223.8 478.9H1230.8L1234.2 485L1230.8 491Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1230.8 475.9H1223.8L1220.3 469.9L1223.8 463.9H1230.8L1234.2 469.9L1230.8 475.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1230.8 460.8H1223.8L1220.3 454.8L1223.8 448.8H1230.8L1234.2 454.8L1230.8 460.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1230.8 445.8H1223.8L1220.3 439.7L1223.8 433.7H1230.8L1234.2 439.7L1230.8 445.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1230.8 430.7H1223.8L1220.3 424.7L1223.8 418.6H1230.8L1234.2 424.7L1230.8 430.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1230.8 415.6H1223.8L1220.3 409.6L1223.8 403.6H1230.8L1234.2 409.6L1230.8 415.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1230.8 400.6H1223.8L1220.3 394.5L1223.8 388.5H1230.8L1234.2 394.5L1230.8 400.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1230.8 385.5H1223.8L1220.3 379.5L1223.8 373.4H1230.8L1234.2 379.5L1230.8 385.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1217.7 378H1210.7L1207.3 371.9L1210.7 365.9H1217.7L1221.2 371.9L1217.7 378Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1204.7 370.4H1197.7L1194.2 364.4L1197.7 358.4H1204.7L1208.1 364.4L1204.7 370.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1191.6 362.9H1184.6L1181.2 356.9L1184.6 350.8H1191.6L1195.1 356.9L1191.6 362.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1178.5 355.3H1171.6L1168.1 349.3L1171.6 343.3H1178.5L1182 349.3L1178.5 355.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1165.5 347.8H1158.5L1155.1 341.8L1158.5 335.8H1165.5L1169 341.8L1165.5 347.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1152.4 340.3H1145.5L1142 334.2L1145.5 328.2H1152.4L1155.9 334.2L1152.4 340.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1139.4 332.7H1132.4L1129 326.7L1132.4 320.7H1139.4L1142.9 326.7L1139.4 332.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1126.3 325.2H1119.4L1115.9 319.2L1119.4 313.1H1126.3L1129.8 319.2L1126.3 325.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1113.3 317.7H1106.3L1102.8 311.6L1106.3 305.6H1113.3L1116.8 311.6L1113.3 317.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1100.2 310.1H1093.3L1089.8 304.1L1093.3 298.1H1100.2L1103.7 304.1L1100.2 310.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1087.2 302.6H1080.2L1076.7 296.6L1080.2 290.5H1087.2L1090.7 296.6L1087.2 302.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1073.9 294.7H1067.4L1064.2 289L1067.4 283.4H1073.9L1077.2 289L1073.9 294.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1048 280H1041.1L1037.6 274L1041.1 268H1048L1051.5 274L1048 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1035 272.5H1028L1024.5 266.4L1028 260.4H1035L1038.5 266.4L1035 272.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.9 264.9H1015L1011.5 258.9L1015 252.9H1021.9L1025.4 258.9L1021.9 264.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.4 256.6H1002.4L999.398 251.4L1002.4 246.1H1008.4L1011.4 251.4L1008.4 256.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M851.801 286.7H845.801L842.801 281.5L845.801 276.3H851.801L854.801 281.5L851.801 286.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M839.098 295H832.298L828.898 289L832.298 283.1H839.098L842.598 289L839.098 295Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M682.198 384.8H675.998L672.898 379.5L675.998 374.1H682.198L685.298 379.5L682.198 384.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M681.602 398.9H676.602L674.102 394.5L676.602 390.2H681.602L684.102 394.5L681.602 398.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M680.998 623.8H677.198L675.398 620.6L677.198 617.4H680.998L682.798 620.6L680.998 623.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M682.602 641.7H675.602L672.102 635.7L675.602 629.6H682.602L686.102 635.7L682.602 641.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M682.602 656.8H675.602L672.102 650.7L675.602 644.7H682.602L686.102 650.7L682.602 656.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M682.602 671.8H675.602L672.102 665.8L675.602 659.8H682.602L686.102 665.8L682.602 671.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M682.602 686.9H675.602L672.102 680.9L675.602 674.8H682.602L686.102 680.9L682.602 686.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M669.502 709.5H662.602L659.102 703.5L662.602 697.5H669.502L673.002 703.5L669.502 709.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M682.602 717H675.602L672.102 711L675.602 705H682.602L686.102 711L682.602 717Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M695.599 724.6H688.699L685.199 718.6L688.699 712.5H695.599L699.099 718.6L695.599 724.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M708.699 732.1H701.699L698.199 726.1L701.699 720.1H708.699L712.199 726.1L708.699 732.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M721.701 739.7H714.801L711.301 733.6L714.801 727.6H721.701L725.201 733.6L721.701 739.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M734.801 747.2H727.801L724.301 741.2L727.801 735.1H734.801L738.301 741.2L734.801 747.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1111.4 781.5H1108.3L1106.7 778.8L1108.3 776.2H1111.4L1112.9 778.8L1111.4 781.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1241.8 600.5H1238.9L1237.4 598L1238.9 595.5H1241.8L1243.2 598L1241.8 600.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1243.8 588.9H1236.9L1233.4 582.9L1236.9 576.9H1243.8L1247.3 582.9L1243.8 588.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1243.8 573.9H1236.8L1233.4 567.8L1236.8 561.8H1243.8L1247.3 567.8L1243.8 573.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1243.8 558.8H1236.8L1233.4 552.8L1236.8 546.7H1243.8L1247.3 552.8L1243.8 558.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1243.8 543.7H1236.8L1233.4 537.7L1236.8 531.7H1243.8L1247.3 537.7L1243.8 543.7Z",
  fill: "#AF6AF4",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M1243.8 528.7H1236.8L1233.4 522.6L1236.8 516.6H1243.8L1247.3 522.6L1243.8 528.7Z",
  fill: "#AF6AF4",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M1243.8 513.6H1236.8L1233.4 507.6L1236.8 501.5H1243.8L1247.3 507.6L1243.8 513.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1243.8 498.5H1236.8L1233.4 492.5L1236.8 486.5H1243.8L1247.3 492.5L1243.8 498.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1243.8 483.4H1236.8L1233.4 477.4L1236.8 471.4H1243.8L1247.3 477.4L1243.8 483.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1243.8 468.4H1236.8L1233.4 462.4L1236.8 456.3H1243.8L1247.3 462.4L1243.8 468.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1243.8 453.3H1236.8L1233.4 447.3L1236.8 441.3H1243.8L1247.3 447.3L1243.8 453.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1243.8 438.2H1236.8L1233.4 432.2L1236.8 426.2H1243.8L1247.3 432.2L1243.8 438.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1243.8 423.2H1236.8L1233.4 417.1L1236.8 411.1H1243.8L1247.3 417.1L1243.8 423.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1243.8 408.1H1236.8L1233.4 402.1L1236.8 396H1243.8L1247.3 402.1L1243.8 408.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1243.8 393H1236.8L1233.4 387L1236.8 381H1243.8L1247.3 387L1243.8 393Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1243.8 378H1236.8L1233.4 371.9L1236.8 365.9H1243.8L1247.3 371.9L1243.8 378Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1230.8 370.4H1223.8L1220.3 364.4L1223.8 358.4H1230.8L1234.2 364.4L1230.8 370.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1217.7 362.9H1210.7L1207.3 356.9L1210.7 350.8H1217.7L1221.2 356.9L1217.7 362.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1204.7 355.3H1197.7L1194.2 349.3L1197.7 343.3H1204.7L1208.1 349.3L1204.7 355.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1191.6 347.8H1184.6L1181.2 341.8L1184.6 335.8H1191.6L1195.1 341.8L1191.6 347.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1178.5 340.3H1171.6L1168.1 334.2L1171.6 328.2H1178.5L1182 334.2L1178.5 340.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1165.5 332.7H1158.5L1155.1 326.7L1158.5 320.7H1165.5L1169 326.7L1165.5 332.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1152.4 325.2H1145.5L1142 319.2L1145.5 313.1H1152.4L1155.9 319.2L1152.4 325.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1139.4 317.7H1132.4L1129 311.6L1132.4 305.6H1139.4L1142.9 311.6L1139.4 317.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1126.3 310.1H1119.4L1115.9 304.1L1119.4 298.1H1126.3L1129.8 304.1L1126.3 310.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1113.3 302.6H1106.3L1102.8 296.6L1106.3 290.5H1113.3L1116.8 296.6L1113.3 302.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1100.2 295.1H1093.3L1089.8 289L1093.3 283H1100.2L1103.7 289L1100.2 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1087.1 287.4H1080.3L1076.9 281.5L1080.3 275.6H1087.1L1090.5 281.5L1087.1 287.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1073.9 279.6H1067.4L1064.1 274L1067.4 268.3H1073.9L1077.2 274L1073.9 279.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1060.9 272.2H1054.3L1051 266.4L1054.3 260.7H1060.9L1064.2 266.4L1060.9 272.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1047.3 263.7H1041.8L1039 258.9L1041.8 254H1047.3L1050.1 258.9L1047.3 263.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1034.3 256.2H1028.7L1025.9 251.4L1028.7 246.5H1034.3L1037.1 251.4L1034.3 256.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1020.5 247.4H1016.4L1014.3 243.8L1016.4 240.2H1020.5L1022.6 243.8L1020.5 247.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M837.398 276.9H833.998L832.398 274L833.998 271.1H837.398L839.098 274L837.398 276.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M745.898 329.3H742.898L741.398 326.7L742.898 324.1H745.898L747.398 326.7L745.898 329.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M681.398 368.5H676.798L674.398 364.4L676.798 360.3H681.398L683.798 364.4L681.398 368.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M669.502 378H662.602L659.102 371.9L662.602 365.9H669.502L673.002 371.9L669.502 378Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M667.999 390.4H664.099L662.199 387L664.099 383.6H667.999L669.899 387L667.999 390.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M667.302 615.2H664.802L663.602 613.1L664.802 610.9H667.302L668.502 613.1L667.302 615.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M669.502 634.2H662.602L659.102 628.1L662.602 622.1H669.502L673.002 628.1L669.502 634.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M669.502 649.2H662.602L659.102 643.2L662.602 637.2H669.502L673.002 643.2L669.502 649.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M669.502 664.3H662.602L659.102 658.3L662.602 652.2H669.502L673.002 658.3L669.502 664.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M669.502 679.4H662.602L659.102 673.3L662.602 667.3H669.502L673.002 673.3L669.502 679.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M669.502 694.4H662.602L659.102 688.4L662.602 682.4H669.502L673.002 688.4L669.502 694.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M656.5 717H649.5L646 711L649.5 705H656.5L660 711L656.5 717Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M669.502 724.6H662.602L659.102 718.6L662.602 712.5H669.502L673.002 718.6L669.502 724.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M682.602 732.1H675.602L672.102 726.1L675.602 720.1H682.602L686.102 726.1L682.602 732.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M695.599 739.7H688.699L685.199 733.6L688.699 727.6H695.599L699.099 733.6L695.599 739.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M708.699 747.2H701.699L698.199 741.2L701.699 735.1H708.699L712.199 741.2L708.699 747.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M721.701 754.7H714.801L711.301 748.7L714.801 742.7H721.701L725.201 748.7L721.701 754.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M734.801 762.3H727.801L724.301 756.2L727.801 750.2H734.801L738.301 756.2L734.801 762.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1255.9 609.9H1250.8L1248.3 605.5L1250.8 601.1H1255.9L1258.5 605.5L1255.9 609.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1256.9 596.5H1249.9L1246.4 590.5L1249.9 584.4H1256.9L1260.3 590.5L1256.9 596.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1256.9 581.4H1249.9L1246.4 575.4L1249.9 569.4H1256.9L1260.3 575.4L1256.9 581.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1256.9 566.3H1249.9L1246.4 560.3L1249.9 554.3H1256.9L1260.3 560.3L1256.9 566.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1256.9 551.3H1249.9L1246.4 545.2L1249.9 539.2H1256.9L1260.3 545.2L1256.9 551.3Z",
  fill: "#AF6AF4",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M1256.9 536.2H1249.9L1246.4 530.2L1249.9 524.1H1256.9L1260.3 530.2L1256.9 536.2Z",
  fill: "#AF6AF4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1256.9 521.1H1249.9L1246.4 515.1L1249.9 509.1H1256.9L1260.3 515.1L1256.9 521.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1256.9 506.1H1249.9L1246.4 500L1249.9 494H1256.9L1260.3 500L1256.9 506.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1256.9 491H1249.9L1246.4 485L1249.9 478.9H1256.9L1260.3 485L1256.9 491Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1256.9 475.9H1249.9L1246.4 469.9L1249.9 463.9H1256.9L1260.3 469.9L1256.9 475.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1256.9 460.8H1249.9L1246.4 454.8L1249.9 448.8H1256.9L1260.3 454.8L1256.9 460.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1256.9 445.8H1249.9L1246.4 439.7L1249.9 433.7H1256.9L1260.3 439.7L1256.9 445.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1256.9 430.7H1249.9L1246.4 424.7L1249.9 418.6H1256.9L1260.3 424.7L1256.9 430.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1256.9 415.6H1249.9L1246.4 409.6L1249.9 403.6H1256.9L1260.3 409.6L1256.9 415.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1256.9 400.6H1249.9L1246.4 394.5L1249.9 388.5H1256.9L1260.3 394.5L1256.9 400.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1256.9 385.5H1249.9L1246.4 379.5L1249.9 373.4H1256.9L1260.3 379.5L1256.9 385.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1256.9 370.4H1249.9L1246.4 364.4L1249.9 358.4H1256.9L1260.3 364.4L1256.9 370.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1243.8 362.9H1236.8L1233.4 356.9L1236.8 350.8H1243.8L1247.3 356.9L1243.8 362.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1230.8 355.3H1223.8L1220.3 349.3L1223.8 343.3H1230.8L1234.2 349.3L1230.8 355.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1217.7 347.8H1210.7L1207.3 341.8L1210.7 335.8H1217.7L1221.2 341.8L1217.7 347.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1204.7 340.3H1197.7L1194.2 334.2L1197.7 328.2H1204.7L1208.1 334.2L1204.7 340.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1191.6 332.7H1184.6L1181.2 326.7L1184.6 320.7H1191.6L1195.1 326.7L1191.6 332.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1178.5 325.2H1171.6L1168.1 319.2L1171.6 313.1H1178.5L1182 319.2L1178.5 325.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1165.5 317.7H1158.5L1155.1 311.6L1158.5 305.6H1165.5L1169 311.6L1165.5 317.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1152.4 310.1H1145.5L1142 304.1L1145.5 298.1H1152.4L1155.9 304.1L1152.4 310.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1139.4 302.6H1132.4L1129 296.6L1132.4 290.5H1139.4L1142.9 296.6L1139.4 302.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1126.3 295.1H1119.4L1115.9 289L1119.4 283H1126.3L1129.8 289L1126.3 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1113.3 287.5H1106.3L1102.8 281.5L1106.3 275.5H1113.3L1116.8 281.5L1113.3 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1099 277.8H1094.5L1092.3 274L1094.5 270.1H1099L1101.2 274L1099 277.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1086.7 271.6H1080.7L1077.8 266.4L1080.7 261.3H1086.7L1089.7 266.4L1086.7 271.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M982.798 212.2H975.798L972.398 206.1L975.798 200.1H982.798L986.198 206.1L982.798 212.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M968.398 202.3H964.098L961.898 198.6L964.098 194.9H968.398L970.598 198.6L968.398 202.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M954.699 193.7H951.699L950.199 191.1L951.699 188.5H954.699L956.199 191.1L954.699 193.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M758.198 305.5H756.598L755.898 304.1L756.598 302.8H758.198L758.998 304.1L758.198 305.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M747.798 317.7H740.898L737.398 311.6L740.898 305.6H747.798L751.298 311.6L747.798 317.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M734.402 324.5H728.202L725.102 319.2L728.202 313.8H734.402L737.502 319.2L734.402 324.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M669.502 362.9H662.602L659.102 356.9L662.602 350.8H669.502L673.002 356.9L669.502 362.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M656.5 370.4H649.5L646 364.4L649.5 358.4H656.5L660 364.4L656.5 370.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M656.5 385.5H649.5L646 379.5L649.5 373.4H656.5L660 379.5L656.5 385.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M656.402 400.5H649.602L646.102 394.5L649.602 388.6H656.402L659.902 394.5L656.402 400.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M656 414.8H650L647 409.6L650 404.4H656L658.9 409.6L656 414.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M656.298 611.2H649.698L646.398 605.5L649.698 599.8H656.298L659.598 605.5L656.298 611.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M656.5 626.6H649.5L646 620.6L649.5 614.6H656.5L660 620.6L656.5 626.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M656.5 641.7H649.5L646 635.7L649.5 629.6H656.5L660 635.7L656.5 641.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M656.5 656.8H649.5L646 650.7L649.5 644.7H656.5L660 650.7L656.5 656.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M656.5 671.8H649.5L646 665.8L649.5 659.8H656.5L660 665.8L656.5 671.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M656.5 686.9H649.5L646 680.9L649.5 674.8H656.5L660 680.9L656.5 686.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M656.5 702H649.5L646 695.9L649.5 689.9H656.5L660 695.9L656.5 702Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.4 724.6H636.5L633 718.6L636.5 712.5H643.4L646.9 718.6L643.4 724.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M656.5 732.1H649.5L646 726.1L649.5 720.1H656.5L660 726.1L656.5 732.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M669.502 739.7H662.602L659.102 733.6L662.602 727.6H669.502L673.002 733.6L669.502 739.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M682.602 747.2H675.602L672.102 741.2L675.602 735.1H682.602L686.102 741.2L682.602 747.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M695.599 754.7H688.699L685.199 748.7L688.699 742.7H695.599L699.099 748.7L695.599 754.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M708.699 762.3H701.699L698.199 756.2L701.699 750.2H708.699L712.199 756.2L708.699 762.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M721.701 769.8H714.801L711.301 763.8L714.801 757.8H721.701L725.201 763.8L721.701 769.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1268.9 617.3H1264L1261.5 613.1L1264 608.8H1268.9L1271.4 613.1L1268.9 617.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1269.4 573H1263.4L1260.5 567.8L1263.4 562.7H1269.4L1272.4 567.8L1269.4 573Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1269.9 558.8H1262.9L1259.5 552.8L1262.9 546.7H1269.9L1273.4 552.8L1269.9 558.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1269.9 543.7H1262.9L1259.5 537.7L1262.9 531.7H1269.9L1273.4 537.7L1269.9 543.7Z",
  fill: "#AF6AF4",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M1269.9 528.7H1262.9L1259.5 522.6L1262.9 516.6H1269.9L1273.4 522.6L1269.9 528.7Z",
  fill: "#AF6AF4",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M1269.9 513.6H1262.9L1259.5 507.6L1262.9 501.5H1269.9L1273.4 507.6L1269.9 513.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1269.9 498.5H1262.9L1259.5 492.5L1262.9 486.5H1269.9L1273.4 492.5L1269.9 498.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1269.9 483.4H1262.9L1259.5 477.4L1262.9 471.4H1269.9L1273.4 477.4L1269.9 483.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1269.9 468.4H1262.9L1259.5 462.4L1262.9 456.3H1269.9L1273.4 462.4L1269.9 468.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1269.9 453.3H1262.9L1259.5 447.3L1262.9 441.3H1269.9L1273.4 447.3L1269.9 453.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1269.9 438.2H1262.9L1259.5 432.2L1262.9 426.2H1269.9L1273.4 432.2L1269.9 438.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1269.9 423.2H1262.9L1259.5 417.1L1262.9 411.1H1269.9L1273.4 417.1L1269.9 423.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1269.9 408.1H1262.9L1259.5 402.1L1262.9 396H1269.9L1273.4 402.1L1269.9 408.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1269.9 393H1262.9L1259.5 387L1262.9 381H1269.9L1273.4 387L1269.9 393Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1269.9 378H1262.9L1259.5 371.9L1262.9 365.9H1269.9L1273.4 371.9L1269.9 378Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1269.9 362.9H1262.9L1259.5 356.9L1262.9 350.8H1269.9L1273.4 356.9L1269.9 362.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1256.9 355.3H1249.9L1246.4 349.3L1249.9 343.3H1256.9L1260.3 349.3L1256.9 355.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1243.8 347.8H1236.8L1233.4 341.8L1236.8 335.8H1243.8L1247.3 341.8L1243.8 347.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1230.8 340.3H1223.8L1220.3 334.2L1223.8 328.2H1230.8L1234.2 334.2L1230.8 340.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1217.7 332.7H1210.7L1207.3 326.7L1210.7 320.7H1217.7L1221.2 326.7L1217.7 332.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1204.7 325.2H1197.7L1194.2 319.2L1197.7 313.1H1204.7L1208.1 319.2L1204.7 325.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1191.6 317.7H1184.6L1181.2 311.6L1184.6 305.6H1191.6L1195.1 311.6L1191.6 317.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1178.5 310.1H1171.6L1168.1 304.1L1171.6 298.1H1178.5L1182 304.1L1178.5 310.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1165.5 302.6H1158.5L1155.1 296.6L1158.5 290.5H1165.5L1169 296.6L1165.5 302.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1152.4 295.1H1145.5L1142 289L1145.5 283H1152.4L1155.9 289L1152.4 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1139.4 287.5H1132.4L1129 281.5L1132.4 275.5H1139.4L1142.9 281.5L1139.4 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1126.3 280H1119.4L1115.9 274L1119.4 267.9H1126.3L1129.8 274L1126.3 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1112.2 270.5H1107.5L1105.1 266.4L1107.5 262.4H1112.2L1114.5 266.4L1112.2 270.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1006.1 207.3H1004.7L1004 206.1L1004.7 205H1006.1L1006.8 206.1L1006.1 207.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M993.7 201H990.9L989.5 198.6L990.9 196.2H993.7L995.2 198.6L993.7 201Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M982.801 197.1H975.801L972.301 191.1L975.801 185H982.801L986.301 191.1L982.801 197.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M969.701 189.6H962.801L959.301 183.5L962.801 177.5H969.701L973.201 183.5L969.701 189.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M956.699 182H949.699L946.199 176L949.699 170H956.699L960.099 176L956.699 182Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M836.999 246H834.499L833.199 243.8L834.499 241.6H836.999L838.199 243.8L836.999 246Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M824.798 255H820.598L818.398 251.4L820.598 247.7H824.798L826.898 251.4L824.798 255Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M813.099 264.9H806.199L802.699 258.9L806.199 252.9H813.099L816.499 258.9L813.099 264.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M800.002 272.5H793.102L789.602 266.4L793.102 260.4H800.002L803.502 266.4L800.002 272.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M787.002 280H780.002L776.602 274L780.002 268H787.002L790.402 274L787.002 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M773.7 287.1H767.3L764 281.5L767.3 275.9H773.7L776.9 281.5L773.7 287.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M760.499 294.4H754.299L751.199 289L754.299 283.6H760.499L763.699 289L760.499 294.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M747.798 302.6H740.898L737.398 296.6L740.898 290.5H747.798L751.298 296.6L747.798 302.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M734.801 310.1H727.801L724.301 304.1L727.801 298.1H734.801L738.301 304.1L734.801 310.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M720.9 316.2H715.6L713 311.6L715.6 307.1H720.9L723.5 311.6L720.9 316.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M669.401 347.6H662.701L659.301 341.8L662.701 336H669.401L672.801 341.8L669.401 347.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M656.5 355.3H649.5L646 349.3L649.5 343.3H656.5L660 349.3L656.5 355.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.4 362.9H636.5L633 356.9L636.5 350.8H643.4L646.9 356.9L643.4 362.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.4 378H636.5L633 371.9L636.5 365.9H643.4L646.9 371.9L643.4 378Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.4 393H636.5L633 387L636.5 381H643.4L646.9 387L643.4 393Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.4 408.1H636.5L633 402.1L636.5 396H643.4L646.9 402.1L643.4 408.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M642.2 421H637.7L635.5 417.1L637.7 413.3H642.2L644.4 417.1L642.2 421Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M642.799 603H637.099L634.199 598L637.099 593H642.799L645.699 598L642.799 603Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.4 619.1H636.5L633 613.1L636.5 607H643.4L646.9 613.1L643.4 619.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.4 634.2H636.5L633 628.1L636.5 622.1H643.4L646.9 628.1L643.4 634.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.4 649.2H636.5L633 643.2L636.5 637.2H643.4L646.9 643.2L643.4 649.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.4 664.3H636.5L633 658.3L636.5 652.2H643.4L646.9 658.3L643.4 664.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.4 679.4H636.5L633 673.3L636.5 667.3H643.4L646.9 673.3L643.4 679.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.4 694.4H636.5L633 688.4L636.5 682.4H643.4L646.9 688.4L643.4 694.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.4 709.5H636.5L633 703.5L636.5 697.5H643.4L646.9 703.5L643.4 709.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M630.398 732.1H623.398L619.898 726.1L623.398 720.1H630.398L633.898 726.1L630.398 732.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.4 739.7H636.5L633 733.6L636.5 727.6H643.4L646.9 733.6L643.4 739.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M656.5 747.2H649.5L646 741.2L649.5 735.1H656.5L660 741.2L656.5 747.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M669.502 754.7H662.602L659.102 748.7L662.602 742.7H669.502L673.002 748.7L669.502 754.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M682.602 762.3H675.602L672.102 756.2L675.602 750.2H682.602L686.102 756.2L682.602 762.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M695.599 769.8H688.699L685.199 763.8L688.699 757.7H695.599L699.099 763.8L695.599 769.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M708.699 777.3H701.699L698.199 771.3L701.699 765.3H708.699L712.199 771.3L708.699 777.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1280.7 562.4H1278.3L1277.1 560.3L1278.3 558.2H1280.7L1281.9 560.3L1280.7 562.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1283 551.3H1276L1272.5 545.2L1276 539.2H1283L1286.4 545.2L1283 551.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1283 536.2H1276L1272.5 530.2L1276 524.1H1283L1286.4 530.2L1283 536.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1283 521.1H1276L1272.5 515.1L1276 509.1H1283L1286.4 515.1L1283 521.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1283 506.1H1276L1272.5 500L1276 494H1283L1286.4 500L1283 506.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1283 491H1276L1272.5 485L1276 478.9H1283L1286.4 485L1283 491Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1283 475.9H1276L1272.5 469.9L1276 463.9H1283L1286.4 469.9L1283 475.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1283 460.8H1276L1272.5 454.8L1276 448.8H1283L1286.4 454.8L1283 460.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1283 445.8H1276L1272.5 439.7L1276 433.7H1283L1286.4 439.7L1283 445.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1283 430.7H1276L1272.5 424.7L1276 418.6H1283L1286.4 424.7L1283 430.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1283 415.6H1276L1272.5 409.6L1276 403.6H1283L1286.4 409.6L1283 415.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1283 400.6H1276L1272.5 394.5L1276 388.5H1283L1286.4 394.5L1283 400.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1283 385.5H1276L1272.5 379.5L1276 373.4H1283L1286.4 379.5L1283 385.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1283 370.4H1276L1272.5 364.4L1276 358.4H1283L1286.4 364.4L1283 370.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1283 355.3H1276L1272.5 349.3L1276 343.3H1283L1286.4 349.3L1283 355.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1269.9 347.8H1262.9L1259.5 341.8L1262.9 335.8H1269.9L1273.4 341.8L1269.9 347.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1256.9 340.3H1249.9L1246.4 334.2L1249.9 328.2H1256.9L1260.3 334.2L1256.9 340.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1243.8 332.7H1236.8L1233.4 326.7L1236.8 320.7H1243.8L1247.3 326.7L1243.8 332.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1230.8 325.2H1223.8L1220.3 319.2L1223.8 313.1H1230.8L1234.2 319.2L1230.8 325.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1217.7 317.7H1210.7L1207.3 311.6L1210.7 305.6H1217.7L1221.2 311.6L1217.7 317.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1204.7 310.1H1197.7L1194.2 304.1L1197.7 298.1H1204.7L1208.1 304.1L1204.7 310.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1191.6 302.6H1184.6L1181.2 296.6L1184.6 290.5H1191.6L1195.1 296.6L1191.6 302.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1178.5 295.1H1171.6L1168.1 289L1171.6 283H1178.5L1182 289L1178.5 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1165.5 287.5H1158.5L1155.1 281.5L1158.5 275.5H1165.5L1169 281.5L1165.5 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1152.4 280H1145.5L1142 274L1145.5 267.9H1152.4L1155.9 274L1152.4 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1139.4 272.5H1132.4L1129 266.4L1132.4 260.4H1139.4L1142.9 266.4L1139.4 272.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1123.9 260.8H1121.8L1120.7 258.9L1121.8 257H1123.9L1125 258.9L1123.9 260.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1006.7 193.3H1004.1L1002.9 191.1L1004.1 188.9H1006.7L1007.9 191.1L1006.7 193.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M994.699 187.6H989.999L987.699 183.5L989.999 179.5H994.699L996.999 183.5L994.699 187.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M981.001 179H977.501L975.801 176L977.501 173H981.001L982.801 176L981.001 179Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M967.001 169.7H965.501L964.801 168.5L965.501 167.2H967.001L967.701 168.5L967.001 169.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M839.1 234.6H832.4L829 228.8L832.4 222.9H839.1L842.4 228.8L839.1 234.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M825.002 240.3H820.402L818.102 236.3L820.402 232.3H825.002L827.302 236.3L825.002 240.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M812.299 248.5H806.899L804.199 243.8L806.899 239.1H812.299L815.099 243.8L812.299 248.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M800.002 257.4H793.102L789.602 251.4L793.102 245.3H800.002L803.502 251.4L800.002 257.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M787.002 264.9H780.002L776.602 258.9L780.002 252.9H787.002L790.502 258.9L787.002 264.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M773.9 272.5H767L763.5 266.4L767 260.4H773.9L777.4 266.4L773.9 272.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M760.9 280H753.9L750.5 274L753.9 267.9H760.9L764.4 274L760.9 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M747.798 287.5H740.898L737.398 281.5L740.898 275.5H747.798L751.298 281.5L747.798 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M734.801 295.1H727.801L724.301 289L727.801 283H734.801L738.301 289L734.801 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M721.102 301.5H715.402L712.602 296.6L715.402 291.7H721.102L723.902 296.6L721.102 301.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M666.598 327.7H665.498L664.898 326.7L665.498 325.7H666.598L667.198 326.7L666.598 327.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M656 339.4H650L647 334.2L650 329.1H656L658.9 334.2L656 339.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.4 347.8H636.5L633 341.8L636.5 335.8H643.4L646.9 341.8L643.4 347.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M630.398 355.3H623.398L619.898 349.3L623.398 343.3H630.398L633.898 349.3L630.398 355.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M630.398 370.4H623.398L619.898 364.4L623.398 358.4H630.398L633.898 364.4L630.398 370.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M630.398 385.5H623.398L619.898 379.5L623.398 373.4H630.398L633.898 379.5L630.398 385.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M630.398 400.6H623.398L619.898 394.5L623.398 388.5H630.398L633.898 394.5L630.398 400.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M630.398 415.6H623.398L619.898 409.6L623.398 403.6H630.398L633.898 409.6L630.398 415.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M628.502 427.5H625.302L623.602 424.7L625.302 421.8H628.502L630.202 424.7L628.502 427.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M627.6 440.9H626.2L625.5 439.7L626.2 438.6H627.6L628.3 439.7L627.6 440.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M628.898 563.8H624.898L622.898 560.3L624.898 556.8H628.898L630.898 560.3L628.898 563.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M627.9 592.1H625.9L625 590.5L625.9 588.8H627.9L628.8 590.5L627.9 592.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M630.398 611.6H623.398L619.898 605.5L623.398 599.5H630.398L633.898 605.5L630.398 611.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M630.398 626.6H623.398L619.898 620.6L623.398 614.6H630.398L633.898 620.6L630.398 626.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M630.398 641.7H623.398L619.898 635.7L623.398 629.6H630.398L633.898 635.7L630.398 641.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M630.398 656.8H623.398L619.898 650.7L623.398 644.7H630.398L633.898 650.7L630.398 656.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M630.398 671.8H623.398L619.898 665.8L623.398 659.8H630.398L633.898 665.8L630.398 671.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M630.398 686.9H623.398L619.898 680.9L623.398 674.8H630.398L633.898 680.9L630.398 686.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M630.398 702H623.398L619.898 695.9L623.398 689.9H630.398L633.898 695.9L630.398 702Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M630.398 717H623.398L619.898 711L623.398 705H630.398L633.898 711L630.398 717Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M617.298 739.7H610.398L606.898 733.6L610.398 727.6H617.298L620.798 733.6L617.298 739.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M630.398 747.2H623.398L619.898 741.2L623.398 735.1H630.398L633.898 741.2L630.398 747.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.4 754.7H636.5L633 748.7L636.5 742.7H643.4L646.9 748.7L643.4 754.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M656.5 762.3H649.5L646 756.2L649.5 750.2H656.5L660 756.2L656.5 762.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M669.502 769.8H662.602L659.102 763.8L662.602 757.7H669.502L673.002 763.8L669.502 769.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M682.602 777.3H675.602L672.102 771.3L675.602 765.3H682.602L686.102 771.3L682.602 777.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M695.599 784.9H688.699L685.199 778.8L688.699 772.8H695.599L699.099 778.8L695.599 784.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M708.699 792.4H701.699L698.199 786.4L701.699 780.3H708.699L712.199 786.4L708.699 792.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1296 543.7H1289.1L1285.6 537.7L1289.1 531.7H1296L1299.5 537.7L1296 543.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1296 528.7H1289.1L1285.6 522.6L1289.1 516.6H1296L1299.5 522.6L1296 528.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1296 513.6H1289.1L1285.6 507.6L1289.1 501.5H1296L1299.5 507.6L1296 513.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1296 498.5H1289.1L1285.6 492.5L1289.1 486.5H1296L1299.5 492.5L1296 498.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1296 483.4H1289.1L1285.6 477.4L1289.1 471.4H1296L1299.5 477.4L1296 483.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1296 468.4H1289.1L1285.6 462.4L1289.1 456.3H1296L1299.5 462.4L1296 468.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1296 453.3H1289.1L1285.6 447.3L1289.1 441.3H1296L1299.5 447.3L1296 453.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1296 438.2H1289.1L1285.6 432.2L1289.1 426.2H1296L1299.5 432.2L1296 438.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1296 423.2H1289.1L1285.6 417.1L1289.1 411.1H1296L1299.5 417.1L1296 423.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1296 408.1H1289.1L1285.6 402.1L1289.1 396H1296L1299.5 402.1L1296 408.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1296 393H1289.1L1285.6 387L1289.1 381H1296L1299.5 387L1296 393Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1296 378H1289.1L1285.6 371.9L1289.1 365.9H1296L1299.5 371.9L1296 378Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1296 362.9H1289.1L1285.6 356.9L1289.1 350.8H1296L1299.5 356.9L1296 362.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1296 347.8H1289.1L1285.6 341.8L1289.1 335.8H1296L1299.5 341.8L1296 347.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1283 340.3H1276L1272.5 334.2L1276 328.2H1283L1286.4 334.2L1283 340.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1269.9 332.7H1262.9L1259.5 326.7L1262.9 320.7H1269.9L1273.4 326.7L1269.9 332.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1256.9 325.2H1249.9L1246.4 319.2L1249.9 313.1H1256.9L1260.3 319.2L1256.9 325.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1243.8 317.7H1236.8L1233.4 311.6L1236.8 305.6H1243.8L1247.3 311.6L1243.8 317.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1230.8 310.1H1223.8L1220.3 304.1L1223.8 298.1H1230.8L1234.2 304.1L1230.8 310.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1217.7 302.6H1210.7L1207.3 296.6L1210.7 290.5H1217.7L1221.2 296.6L1217.7 302.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1204.7 295.1H1197.7L1194.2 289L1197.7 283H1204.7L1208.1 289L1204.7 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1191.6 287.5H1184.6L1181.2 281.5L1184.6 275.5H1191.6L1195.1 281.5L1191.6 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1178.5 280H1171.6L1168.1 274L1171.6 267.9H1178.5L1182 274L1178.5 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1165.5 272.5H1158.5L1155.1 266.4L1158.5 260.4H1165.5L1169 266.4L1165.5 272.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1152.4 264.9H1145.5L1142 258.9L1145.5 252.9H1152.4L1155.9 258.9L1152.4 264.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1136.8 253H1135L1134.1 251.4L1135 249.8H1136.8L1137.8 251.4L1136.8 253Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1125.8 249H1119.9L1116.9 243.8L1119.9 238.7H1125.8L1128.8 243.8L1125.8 249Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1110.9 238.1H1108.7L1107.7 236.3L1108.7 234.4H1110.9L1111.9 236.3L1110.9 238.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.3 181H1002.5L999.602 176L1002.5 171H1008.3L1011.2 176L1008.3 181Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M995.298 173.6H989.398L986.398 168.5L989.398 163.4H995.298L998.198 168.5L995.298 173.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M849.501 207.4H848.001L847.301 206.1L848.001 204.8H849.501L850.301 206.1L849.501 207.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M839.201 219.6H832.301L828.801 213.7L832.301 207.7H839.201L842.601 213.7L839.201 219.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M826.199 227.2H819.199L815.699 221.2L819.199 215.2H826.199L829.599 221.2L826.199 227.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M813.099 234.8H806.099L802.699 228.8L806.099 222.7H813.099L816.599 228.8L813.099 234.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M800.002 242.3H793.102L789.602 236.3L793.102 230.3H800.002L803.502 236.3L800.002 242.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M787.002 249.9H780.002L776.602 243.8L780.002 237.8H787.002L790.502 243.8L787.002 249.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M773.9 257.4H767L763.5 251.4L767 245.3H773.9L777.4 251.4L773.9 257.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M760.9 264.9H753.9L750.5 258.9L753.9 252.9H760.9L764.4 258.9L760.9 264.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M747.798 272.5H740.898L737.398 266.4L740.898 260.4H747.798L751.298 266.4L747.798 272.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M734.801 280H727.801L724.301 274L727.801 267.9H734.801L738.301 274L734.801 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M721.701 287.5H714.801L711.301 281.5L714.801 275.5H721.701L725.201 281.5L721.701 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M642.998 331.9H636.898L633.898 326.7L636.898 321.5H642.998L645.998 326.7L642.998 331.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M630.398 340.3H623.398L619.898 334.2L623.398 328.2H630.398L633.898 334.2L630.398 340.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M617.298 347.8H610.398L606.898 341.8L610.398 335.8H617.298L620.798 341.8L617.298 347.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M617.298 362.9H610.398L606.898 356.9L610.398 350.8H617.298L620.798 356.9L617.298 362.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M617.298 378H610.398L606.898 371.9L610.398 365.9H617.298L620.798 371.9L617.298 378Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M617.298 393H610.398L606.898 387L610.398 381H617.298L620.798 387L617.298 393Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M617.298 408.1H610.398L606.898 402.1L610.398 396H617.298L620.798 402.1L617.298 408.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M617.298 423.2H610.398L606.898 417.1L610.398 411.1H617.298L620.798 417.1L617.298 423.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M617.298 438.2H610.398L606.898 432.2L610.398 426.2H617.298L620.798 432.2L617.298 438.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M614.901 539.5H612.801L611.801 537.7L612.801 535.9H614.901L615.901 537.7L614.901 539.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M616.899 558.1H610.799L607.699 552.8L610.799 547.4H616.899L619.999 552.8L616.899 558.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M617.298 604H610.398L606.898 598L610.398 592H617.298L620.798 598L617.298 604Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M617.298 619.1H610.398L606.898 613.1L610.398 607H617.298L620.798 613.1L617.298 619.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M617.298 634.2H610.398L606.898 628.1L610.398 622.1H617.298L620.798 628.1L617.298 634.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M617.298 649.2H610.398L606.898 643.2L610.398 637.2H617.298L620.798 643.2L617.298 649.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M617.298 664.3H610.398L606.898 658.3L610.398 652.2H617.298L620.798 658.3L617.298 664.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M617.298 679.4H610.398L606.898 673.3L610.398 667.3H617.298L620.798 673.3L617.298 679.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M617.298 694.4H610.398L606.898 688.4L610.398 682.4H617.298L620.798 688.4L617.298 694.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M617.298 709.5H610.398L606.898 703.5L610.398 697.5H617.298L620.798 703.5L617.298 709.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M617.298 724.6H610.398L606.898 718.6L610.398 712.5H617.298L620.798 718.6L617.298 724.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M616.901 753.9H610.801L607.801 748.7L610.801 743.5H616.901L619.901 748.7L616.901 753.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M630.398 762.3H623.398L619.898 756.2L623.398 750.2H630.398L633.898 756.2L630.398 762.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.4 769.8H636.5L633 763.8L636.5 757.7H643.4L646.9 763.8L643.4 769.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M656.5 777.3H649.5L646 771.3L649.5 765.3H656.5L660 771.3L656.5 777.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M669.502 784.9H662.602L659.102 778.8L662.602 772.8H669.502L673.002 778.8L669.502 784.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M682.602 792.4H675.602L672.102 786.4L675.602 780.3H682.602L686.102 786.4L682.602 792.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M695.599 799.9H688.699L685.199 793.9L688.699 787.9H695.599L699.099 793.9L695.599 799.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M706.699 804H703.699L702.199 801.4L703.699 798.8H706.699L708.199 801.4L706.699 804Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1307.7 549H1303.4L1301.3 545.2L1303.4 541.5H1307.7L1309.9 545.2L1307.7 549Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1309.1 536.2H1302.1L1298.6 530.2L1302.1 524.1H1309.1L1312.5 530.2L1309.1 536.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1309.1 521.1H1302.1L1298.6 515.1L1302.1 509.1H1309.1L1312.5 515.1L1309.1 521.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1309.1 506.1H1302.1L1298.6 500L1302.1 494H1309.1L1312.5 500L1309.1 506.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1309.1 491H1302.1L1298.6 485L1302.1 478.9H1309.1L1312.5 485L1309.1 491Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1309.1 475.9H1302.1L1298.6 469.9L1302.1 463.9H1309.1L1312.5 469.9L1309.1 475.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1309.1 460.8H1302.1L1298.6 454.8L1302.1 448.8H1309.1L1312.5 454.8L1309.1 460.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1309.1 445.8H1302.1L1298.6 439.7L1302.1 433.7H1309.1L1312.5 439.7L1309.1 445.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1309.1 430.7H1302.1L1298.6 424.7L1302.1 418.6H1309.1L1312.5 424.7L1309.1 430.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1309.1 415.6H1302.1L1298.6 409.6L1302.1 403.6H1309.1L1312.5 409.6L1309.1 415.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1309.1 400.6H1302.1L1298.6 394.5L1302.1 388.5H1309.1L1312.5 394.5L1309.1 400.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1309.1 385.5H1302.1L1298.6 379.5L1302.1 373.4H1309.1L1312.5 379.5L1309.1 385.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1309.1 370.4H1302.1L1298.6 364.4L1302.1 358.4H1309.1L1312.5 364.4L1309.1 370.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1309.1 355.3H1302.1L1298.6 349.3L1302.1 343.3H1309.1L1312.5 349.3L1309.1 355.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1309.1 340.3H1302.1L1298.6 334.2L1302.1 328.2H1309.1L1312.5 334.2L1309.1 340.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1296 332.7H1289.1L1285.6 326.7L1289.1 320.7H1296L1299.5 326.7L1296 332.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1283 325.2H1276L1272.5 319.2L1276 313.1H1283L1286.4 319.2L1283 325.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1269.9 317.7H1262.9L1259.5 311.6L1262.9 305.6H1269.9L1273.4 311.6L1269.9 317.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1256.9 310.1H1249.9L1246.4 304.1L1249.9 298.1H1256.9L1260.3 304.1L1256.9 310.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1243.8 302.6H1236.8L1233.4 296.6L1236.8 290.5H1243.8L1247.3 296.6L1243.8 302.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1230.8 295.1H1223.8L1220.3 289L1223.8 283H1230.8L1234.2 289L1230.8 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1217.7 287.5H1210.7L1207.3 281.5L1210.7 275.5H1217.7L1221.2 281.5L1217.7 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1204.7 280H1197.7L1194.2 274L1197.7 267.9H1204.7L1208.1 274L1204.7 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1191.6 272.5H1184.6L1181.2 266.4L1184.6 260.4H1191.6L1195.1 266.4L1191.6 272.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1178.5 264.9H1171.6L1168.1 258.9L1171.6 252.9H1178.5L1182 258.9L1178.5 264.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1163.6 254.1H1160.4L1158.8 251.4L1160.4 248.6H1163.6L1165.2 251.4L1163.6 254.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1125.2 232.7H1120.6L1118.2 228.8L1120.6 224.8H1125.2L1127.5 228.8L1125.2 232.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1032.3 177.4H1030.7L1029.9 176L1030.7 174.6H1032.3L1033.1 176L1032.3 177.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1021.5 173.8H1015.4L1012.3 168.5L1015.4 163.1H1021.5L1024.6 168.5L1021.5 173.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1006.2 162.3H1004.6L1003.8 160.9L1004.6 159.5H1006.2L1007 160.9L1006.2 162.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M849.799 192.9H847.699L846.699 191.1L847.699 189.3H849.799L850.899 191.1L849.799 192.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M839.201 204.6H832.201L828.801 198.6L832.201 192.6H839.201L842.701 198.6L839.201 204.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M826.199 212.2H819.199L815.699 206.1L819.199 200.1H826.199L829.599 206.1L826.199 212.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M813.099 219.7H806.099L802.699 213.7L806.099 207.7H813.099L816.599 213.7L813.099 219.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M800.002 227.2H793.102L789.602 221.2L793.102 215.2H800.002L803.502 221.2L800.002 227.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M787.002 234.8H780.002L776.602 228.8L780.002 222.7H787.002L790.502 228.8L787.002 234.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M773.9 242.3H767L763.5 236.3L767 230.3H773.9L777.4 236.3L773.9 242.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M760.9 249.9H753.9L750.5 243.8L753.9 237.8H760.9L764.4 243.8L760.9 249.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M747.798 257.4H740.898L737.398 251.4L740.898 245.3H747.798L751.298 251.4L747.798 257.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M734.801 264.9H727.801L724.301 258.9L727.801 252.9H734.801L738.301 258.9L734.801 264.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M720.398 270.2H716.098L713.898 266.4L716.098 262.7H720.398L722.598 266.4L720.398 270.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M666.898 298H665.198L664.398 296.6L665.198 295.2H666.898L667.698 296.6L666.898 298Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M656.5 310.1H649.5L646 304.1L649.5 298.1H656.5L660 304.1L656.5 310.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M641.301 313.9H638.601L637.301 311.6L638.601 309.4H641.301L642.601 311.6L641.301 313.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M630.398 325.2H623.398L619.898 319.2L623.398 313.1H630.398L633.898 319.2L630.398 325.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M617.298 332.7H610.398L606.898 326.7L610.398 320.7H617.298L620.798 326.7L617.298 332.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M603.198 353.5H598.398L595.898 349.3L598.398 345.1H603.198L605.698 349.3L603.198 353.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M604.099 370.1H597.499L594.199 364.4L597.499 358.7H604.099L607.399 364.4L604.099 370.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M604.301 385.5H597.301L593.801 379.5L597.301 373.4H604.301L607.801 379.5L604.301 385.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M604.301 400.6H597.301L593.801 394.5L597.301 388.5H604.301L607.801 394.5L604.301 400.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M604.301 415.6H597.301L593.801 409.6L597.301 403.6H604.301L607.801 409.6L604.301 415.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M604.301 430.7H597.301L593.801 424.7L597.301 418.6H604.301L607.801 424.7L604.301 430.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M604.301 445.8H597.301L593.801 439.7L597.301 433.7H604.301L607.801 439.7L604.301 445.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M604.2 460.7H597.4L594 454.8L597.4 449H604.2L607.5 454.8L604.2 460.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M601.402 470.9H600.202L599.602 469.9L600.202 468.9H601.402L602.002 469.9L601.402 470.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M602.099 532.4H599.499L598.199 530.2L599.499 527.9H602.099L603.399 530.2L602.099 532.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M601.698 546.9H599.798L598.898 545.2L599.798 543.6H601.698L602.698 545.2L601.698 546.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M602.698 563.7H598.898L596.898 560.3L598.898 557H602.698L604.698 560.3L602.698 563.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M604.099 596.2H597.499L594.199 590.5L597.499 584.7H604.099L607.399 590.5L604.099 596.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M604.301 611.6H597.301L593.801 605.5L597.301 599.5H604.301L607.801 605.5L604.301 611.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M604.301 626.6H597.301L593.801 620.6L597.301 614.6H604.301L607.801 620.6L604.301 626.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M604.301 641.7H597.301L593.801 635.7L597.301 629.6H604.301L607.801 635.7L604.301 641.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M604.301 656.8H597.301L593.801 650.7L597.301 644.7H604.301L607.801 650.7L604.301 656.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M604.301 671.8H597.301L593.801 665.8L597.301 659.8H604.301L607.801 665.8L604.301 671.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M604.301 686.9H597.301L593.801 680.9L597.301 674.8H604.301L607.801 680.9L604.301 686.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M604.301 702H597.301L593.801 695.9L597.301 689.9H604.301L607.801 695.9L604.301 702Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M604.301 717H597.301L593.801 711L597.301 705H604.301L607.801 711L604.301 717Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M604.301 732.1H597.301L593.801 726.1L597.301 720.1H604.301L607.801 726.1L604.301 732.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M616.699 768.7H610.999L608.199 763.8L610.999 758.9H616.699L619.499 763.8L616.699 768.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M630.398 777.3H623.398L619.898 771.3L623.398 765.3H630.398L633.898 771.3L630.398 777.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.4 784.9H636.5L633 778.8L636.5 772.8H643.4L646.9 778.8L643.4 784.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M656.5 792.4H649.5L646 786.4L649.5 780.3H656.5L660 786.4L656.5 792.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M669.502 799.9H662.602L659.102 793.9L662.602 787.9H669.502L673.002 793.9L669.502 799.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M682.602 807.5H675.602L672.102 801.4L675.602 795.4H682.602L686.102 801.4L682.602 807.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M695.601 814.9H688.701L685.301 809L688.701 803H695.601L699.001 809L695.601 814.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1321.5 572.9H1315.7L1312.8 567.8L1315.7 562.8H1321.5L1324.4 567.8L1321.5 572.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1322.1 558.8H1315.2L1311.7 552.8L1315.2 546.7H1322.1L1325.6 552.8L1322.1 558.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1322.1 543.7H1315.2L1311.7 537.7L1315.2 531.7H1322.1L1325.6 537.7L1322.1 543.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1322.1 528.7H1315.2L1311.7 522.6L1315.2 516.6H1322.1L1325.6 522.6L1322.1 528.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1322.1 513.6H1315.2L1311.7 507.6L1315.2 501.5H1322.1L1325.6 507.6L1322.1 513.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1322.1 498.5H1315.2L1311.7 492.5L1315.2 486.5H1322.1L1325.6 492.5L1322.1 498.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1322.1 483.4H1315.2L1311.7 477.4L1315.2 471.4H1322.1L1325.6 477.4L1322.1 483.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1322.1 468.4H1315.2L1311.7 462.4L1315.2 456.3H1322.1L1325.6 462.4L1322.1 468.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1322.1 453.3H1315.2L1311.7 447.3L1315.2 441.3H1322.1L1325.6 447.3L1322.1 453.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1322.1 438.2H1315.2L1311.7 432.2L1315.2 426.2H1322.1L1325.6 432.2L1322.1 438.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1322.1 423.2H1315.2L1311.7 417.1L1315.2 411.1H1322.1L1325.6 417.1L1322.1 423.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1322.1 408.1H1315.2L1311.7 402.1L1315.2 396H1322.1L1325.6 402.1L1322.1 408.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1322.1 393H1315.2L1311.7 387L1315.2 381H1322.1L1325.6 387L1322.1 393Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1322.1 378H1315.2L1311.7 371.9L1315.2 365.9H1322.1L1325.6 371.9L1322.1 378Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1322.1 362.9H1315.2L1311.7 356.9L1315.2 350.8H1322.1L1325.6 356.9L1322.1 362.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1322.1 347.8H1315.2L1311.7 341.8L1315.2 335.8H1322.1L1325.6 341.8L1322.1 347.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1322.1 332.7H1315.2L1311.7 326.7L1315.2 320.7H1322.1L1325.6 326.7L1322.1 332.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1309.1 325.2H1302.1L1298.6 319.2L1302.1 313.1H1309.1L1312.5 319.2L1309.1 325.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1296 317.7H1289.1L1285.6 311.6L1289.1 305.6H1296L1299.5 311.6L1296 317.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1283 310.1H1276L1272.5 304.1L1276 298.1H1283L1286.4 304.1L1283 310.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1269.9 302.6H1262.9L1259.5 296.6L1262.9 290.5H1269.9L1273.4 296.6L1269.9 302.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1256.9 295.1H1249.9L1246.4 289L1249.9 283H1256.9L1260.3 289L1256.9 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1243.8 287.5H1236.8L1233.4 281.5L1236.8 275.5H1243.8L1247.3 281.5L1243.8 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1230.8 280H1223.8L1220.3 274L1223.8 267.9H1230.8L1234.2 274L1230.8 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1217.7 272.5H1210.7L1207.3 266.4L1210.7 260.4H1217.7L1221.2 266.4L1217.7 272.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1204.5 264.6H1197.9L1194.6 258.9L1197.9 253.2H1204.5L1207.7 258.9L1204.5 264.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1191.5 257.2H1184.8L1181.4 251.4L1184.8 245.6H1191.5L1194.8 251.4L1191.5 257.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1178.2 249.3H1171.9L1168.8 243.8L1171.9 238.4H1178.2L1181.4 243.8L1178.2 249.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1138.9 226.3H1133L1130 221.2L1133 216.1H1138.9L1141.8 221.2L1138.9 226.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1123.4 214.7H1122.3L1121.7 213.7L1122.3 212.7H1123.4L1124 213.7L1123.4 214.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M865.099 174.2H858.499L855.199 168.5L858.499 162.7H865.099L868.499 168.5L865.099 174.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M851.999 181.7H845.499L842.199 176L845.499 170.3H851.999L855.299 176L851.999 181.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M839.201 189.6H832.201L828.801 183.5L832.201 177.5H839.201L842.701 183.5L839.201 189.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M826.199 197.1H819.199L815.699 191.1L819.199 185H826.199L829.599 191.1L826.199 197.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M813.099 204.6H806.099L802.699 198.6L806.099 192.6H813.099L816.599 198.6L813.099 204.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M800.002 212.2H793.102L789.602 206.1L793.102 200.1H800.002L803.502 206.1L800.002 212.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M787.002 219.7H780.002L776.602 213.7L780.002 207.7H787.002L790.502 213.7L787.002 219.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M773.9 227.2H767L763.5 221.2L767 215.2H773.9L777.4 221.2L773.9 227.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M760.9 234.8H753.9L750.5 228.8L753.9 222.7H760.9L764.4 228.8L760.9 234.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M747.798 242.3H740.898L737.398 236.3L740.898 230.3H747.798L751.298 236.3L747.798 242.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M734.801 249.9H727.801L724.301 243.8L727.801 237.8H734.801L738.301 243.8L734.801 249.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M721.4 256.8H715.1L712 251.4L715.1 245.9H721.4L724.5 251.4L721.4 256.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M681.099 277.3H677.099L675.199 274L677.099 270.6H681.099L682.999 274L681.099 277.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M669.502 287.5H662.602L659.102 281.5L662.602 275.5H669.502L673.002 281.5L669.502 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M656.5 295.1H649.5L646 289L649.5 283H656.5L660 289L656.5 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.4 302.6H636.5L633 296.6L636.5 290.6H643.4L646.9 296.6L643.4 302.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M617.3 317.6H610.4L607 311.6L610.4 305.7H617.3L620.7 311.6L617.3 317.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M589.999 360.8H585.499L583.199 356.9L585.499 352.9H589.999L592.299 356.9L589.999 360.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M591.102 377.7H584.402L581.102 371.9L584.402 366.2H591.102L594.402 371.9L591.102 377.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M591.201 393H584.301L580.801 387L584.301 381H591.201L594.701 387L591.201 393Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M591.201 408.1H584.301L580.801 402.1L584.301 396H591.201L594.701 402.1L591.201 408.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M591.201 423.2H584.301L580.801 417.1L584.301 411.1H591.201L594.701 417.1L591.201 423.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M591.201 438.2H584.301L580.801 432.2L584.301 426.2H591.201L594.701 432.2L591.201 438.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M591.201 453.3H584.301L580.801 447.3L584.301 441.3H591.201L594.701 447.3L591.201 453.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M591.201 468.4H584.301L580.801 462.4L584.301 456.3H591.201L594.701 462.4L591.201 468.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M590.602 482.3H584.902L582.102 477.4L584.902 472.5H590.602L593.402 477.4L590.602 482.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M589.198 540.2H586.298L584.898 537.7L586.298 535.2H589.198L590.598 537.7L589.198 540.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M589.001 554.9H586.501L585.301 552.8L586.501 550.6H589.001L590.201 552.8L589.001 554.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M590.499 602.8H584.999L582.199 598L584.999 593.2H590.499L593.299 598L590.499 602.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M591.201 619.1H584.301L580.801 613.1L584.301 607H591.201L594.701 613.1L591.201 619.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M591.201 634.2H584.301L580.801 628.1L584.301 622.1H591.201L594.701 628.1L591.201 634.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M591.201 649.2H584.301L580.801 643.2L584.301 637.2H591.201L594.701 643.2L591.201 649.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M591.201 664.3H584.301L580.801 658.3L584.301 652.2H591.201L594.701 658.3L591.201 664.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M591.201 679.4H584.301L580.801 673.3L584.301 667.3H591.201L594.701 673.3L591.201 679.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M591.201 694.4H584.301L580.801 688.4L584.301 682.4H591.201L594.701 688.4L591.201 694.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M591.198 709.4H584.298L580.898 703.5L584.298 697.5H591.198L594.598 703.5L591.198 709.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M589.802 722.1H585.702L583.602 718.6L585.702 715H589.802L591.802 718.6L589.802 722.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M616.399 783.3H611.199L608.699 778.8L611.199 774.3H616.399L618.999 778.8L616.399 783.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M630.398 792.4H623.398L619.898 786.4L623.398 780.3H630.398L633.898 786.4L630.398 792.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.4 799.9H636.5L633 793.9L636.5 787.9H643.4L646.9 793.9L643.4 799.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M656.5 807.5H649.5L646 801.4L649.5 795.4H656.5L660 801.4L656.5 807.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M669.502 815H662.602L659.102 809L662.602 803H669.502L673.002 809L669.502 815Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M682.599 822.5H675.599L672.199 816.5L675.599 810.5H682.599L685.999 816.5L682.599 822.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1334.2 640H1329.2L1326.7 635.7L1329.2 631.4H1334.2L1336.7 635.7L1334.2 640Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1333.8 624.2H1329.6L1327.5 620.6L1329.6 617H1333.8L1335.8 620.6L1333.8 624.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1334.6 580.4H1328.8L1325.9 575.4L1328.8 570.3H1334.6L1337.5 575.4L1334.6 580.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1335.2 566.3H1328.2L1324.7 560.3L1328.2 554.3H1335.2L1338.6 560.3L1335.2 566.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1335.2 551.3H1328.2L1324.7 545.2L1328.2 539.2H1335.2L1338.6 545.2L1335.2 551.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1335.2 536.2H1328.2L1324.7 530.2L1328.2 524.1H1335.2L1338.6 530.2L1335.2 536.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1335.2 521.1H1328.2L1324.7 515.1L1328.2 509.1H1335.2L1338.6 515.1L1335.2 521.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1335.2 506.1H1328.2L1324.7 500L1328.2 494H1335.2L1338.6 500L1335.2 506.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1335.2 491H1328.2L1324.7 485L1328.2 478.9H1335.2L1338.6 485L1335.2 491Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1335.2 475.9H1328.2L1324.7 469.9L1328.2 463.9H1335.2L1338.6 469.9L1335.2 475.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1335.2 460.8H1328.2L1324.7 454.8L1328.2 448.8H1335.2L1338.6 454.8L1335.2 460.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1335.2 445.8H1328.2L1324.7 439.7L1328.2 433.7H1335.2L1338.6 439.7L1335.2 445.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1335.2 430.7H1328.2L1324.7 424.7L1328.2 418.6H1335.2L1338.6 424.7L1335.2 430.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1335.2 415.6H1328.2L1324.7 409.6L1328.2 403.6H1335.2L1338.6 409.6L1335.2 415.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1335.2 400.6H1328.2L1324.7 394.5L1328.2 388.5H1335.2L1338.6 394.5L1335.2 400.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1335.2 385.5H1328.2L1324.7 379.5L1328.2 373.4H1335.2L1338.6 379.5L1335.2 385.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1335.2 370.4H1328.2L1324.7 364.4L1328.2 358.4H1335.2L1338.6 364.4L1335.2 370.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1335.2 355.3H1328.2L1324.7 349.3L1328.2 343.3H1335.2L1338.6 349.3L1335.2 355.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1335.2 340.3H1328.2L1324.7 334.2L1328.2 328.2H1335.2L1338.6 334.2L1335.2 340.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1335.2 325.2H1328.2L1324.7 319.2L1328.2 313.1H1335.2L1338.6 319.2L1335.2 325.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1322.1 317.7H1315.2L1311.7 311.6L1315.2 305.6H1322.1L1325.6 311.6L1322.1 317.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1309.1 310.1H1302.1L1298.6 304.1L1302.1 298.1H1309.1L1312.5 304.1L1309.1 310.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1296 302.6H1289.1L1285.6 296.6L1289.1 290.5H1296L1299.5 296.6L1296 302.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1283 295.1H1276L1272.5 289L1276 283H1283L1286.4 289L1283 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1269.9 287.5H1262.9L1259.5 281.5L1262.9 275.5H1269.9L1273.4 281.5L1269.9 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1256.9 280H1249.9L1246.4 274L1249.9 267.9H1256.9L1260.3 274L1256.9 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1243.8 272.5H1236.8L1233.4 266.4L1236.8 260.4H1243.8L1247.3 266.4L1243.8 272.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1230.8 264.9H1223.8L1220.3 258.9L1223.8 252.9H1230.8L1234.2 258.9L1230.8 264.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1217.7 257.4H1210.7L1207.3 251.4L1210.7 245.3H1217.7L1221.2 251.4L1217.7 257.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1203.1 247.1H1199.3L1197.4 243.8L1199.3 240.6H1203.1L1204.9 243.8L1203.1 247.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1189 237.7H1187.3L1186.5 236.3L1187.3 234.8H1189L1189.8 236.3L1189 237.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1151.4 217.8H1146.6L1144.2 213.7L1146.6 209.5H1151.4L1153.7 213.7L1151.4 217.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M851.102 165H846.502L844.102 160.9L846.502 156.9H851.102L853.402 160.9L851.102 165Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M839.201 174.5H832.201L828.801 168.5L832.201 162.4H839.201L842.701 168.5L839.201 174.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M826.199 182H819.199L815.699 176L819.199 170H826.199L829.599 176L826.199 182Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M813.099 189.6H806.099L802.699 183.5L806.099 177.5H813.099L816.599 183.5L813.099 189.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M800.002 197.1H793.102L789.602 191.1L793.102 185H800.002L803.502 191.1L800.002 197.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M787.002 204.6H780.002L776.602 198.6L780.002 192.6H787.002L790.502 198.6L787.002 204.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M773.9 212.2H767L763.5 206.1L767 200.1H773.9L777.4 206.1L773.9 212.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M760.9 219.7H753.9L750.5 213.7L753.9 207.7H760.9L764.4 213.7L760.9 219.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M747.798 227.2H740.898L737.398 221.2L740.898 215.2H747.798L751.298 221.2L747.798 227.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M734.801 234.8H727.801L724.301 228.8L727.801 222.7H734.801L738.301 228.8L734.801 234.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M721.698 242.2H714.798L711.398 236.3L714.798 230.3H721.698L725.098 236.3L721.698 242.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M705.999 245.1H704.399L703.699 243.8L704.399 242.5H705.999L706.699 243.8L705.999 245.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M668.201 270.1H663.901L661.801 266.4L663.901 262.7H668.201L670.301 266.4L668.201 270.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M656.5 280H649.5L646 274L649.5 267.9H656.5L660 274L656.5 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.4 287.5H636.5L633 281.5L636.5 275.5H643.4L646.9 281.5L643.4 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M630.3 295H623.4L620 289L623.4 283.1H630.3L633.8 289L630.3 295Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M614.601 297.9H613.101L612.301 296.6L613.101 295.2H614.601L615.401 296.6L614.601 297.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M602.402 306.9H599.202L597.602 304.1L599.202 301.3H602.402L604.002 304.1L602.402 306.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M575.702 351.1H573.602L572.602 349.3L573.602 347.5H575.702L576.802 349.3L575.702 351.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M578.199 370.4H571.199L567.699 364.4L571.199 358.4H578.199L581.599 364.4L578.199 370.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M578.199 385.5H571.199L567.699 379.5L571.199 373.4H578.199L581.599 379.5L578.199 385.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M578.199 400.6H571.199L567.699 394.5L571.199 388.5H578.199L581.599 394.5L578.199 400.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M578.199 415.6H571.199L567.699 409.6L571.199 403.6H578.199L581.599 409.6L578.199 415.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M578.199 430.7H571.199L567.699 424.7L571.199 418.6H578.199L581.599 424.7L578.199 430.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M578.199 445.8H571.199L567.699 439.7L571.199 433.7H578.199L581.599 439.7L578.199 445.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M578.199 460.8H571.199L567.699 454.8L571.199 448.8H578.199L581.599 454.8L578.199 460.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M578.199 475.9H571.199L567.699 469.9L571.199 463.9H578.199L581.599 469.9L578.199 475.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M578.098 490.8H571.298L567.898 485L571.298 479.1H578.098L581.498 485L578.098 490.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M575.798 502H573.598L572.398 500L573.598 498.1H575.798L576.898 500L575.798 502Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M577.601 520.2H571.801L568.801 515.1L571.801 510H577.601L580.501 515.1L577.601 520.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M575.601 546.8H573.801L572.801 545.2L573.801 543.6H575.601L576.501 545.2L575.601 546.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M578.002 611.3H571.402L568.102 605.5L571.402 599.8H578.002L581.302 605.5L578.002 611.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M575.699 622.3H573.699L572.699 620.6L573.699 618.9H575.699L576.699 620.6L575.699 622.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M576.8 639.3H572.6L570.5 635.7L572.6 632H576.8L578.9 635.7L576.8 639.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M578.199 656.8H571.199L567.699 650.7L571.199 644.7H578.199L581.599 650.7L578.199 656.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M578.101 671.8H571.201L567.801 665.8L571.201 659.8H578.101L581.601 665.8L578.101 671.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M576.1 683.2H573.3L572 680.9L573.3 678.5H576.1L577.4 680.9L576.1 683.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M577.702 701.2H571.602L568.602 695.9L571.602 690.7H577.702L580.802 695.9L577.702 701.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M615.798 797.3H611.898L609.898 793.9L611.898 790.5H615.798L617.798 793.9L615.798 797.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M630.398 807.5H623.398L619.898 801.4L623.398 795.4H630.398L633.898 801.4L630.398 807.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.4 815H636.5L633 809L636.5 803H643.4L646.9 809L643.4 815Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M656.5 822.5H649.5L646 816.5L649.5 810.5H656.5L660 816.5L656.5 822.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M669.502 830.1H662.602L659.102 824L662.602 818H669.502L673.002 824L669.502 830.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M680.9 834.7H677.3L675.5 831.6L677.3 828.5H680.9L682.7 831.6L680.9 834.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1347 662.2H1342.5L1340.2 658.3L1342.5 654.3H1347L1349.3 658.3L1347 662.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1348 648.9H1341.5L1338.2 643.2L1341.5 637.5H1348L1351.3 643.2L1348 648.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1345.8 630H1343.7L1342.6 628.1L1343.7 626.3H1345.8L1346.9 628.1L1345.8 630Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1348.1 618.8H1341.4L1338.1 613.1L1341.4 607.3H1348.1L1351.4 613.1L1348.1 618.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1345.8 599.8H1343.7L1342.6 598L1343.7 596.2H1345.8L1346.8 598L1345.8 599.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1348 588.6H1341.4L1338.2 582.9L1341.4 577.2H1348L1351.3 582.9L1348 588.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1348.2 573.9H1341.3L1337.8 567.8L1341.3 561.8H1348.2L1351.7 567.8L1348.2 573.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1348.2 558.8H1341.3L1337.8 552.8L1341.3 546.7H1348.2L1351.7 552.8L1348.2 558.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1348.2 543.7H1341.3L1337.8 537.7L1341.3 531.7H1348.2L1351.7 537.7L1348.2 543.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1348.2 528.7H1341.3L1337.8 522.6L1341.3 516.6H1348.2L1351.7 522.6L1348.2 528.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1348.2 513.6H1341.3L1337.8 507.6L1341.3 501.5H1348.2L1351.7 507.6L1348.2 513.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1348.2 498.5H1341.3L1337.8 492.5L1341.3 486.5H1348.2L1351.7 492.5L1348.2 498.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1348.2 483.4H1341.3L1337.8 477.4L1341.3 471.4H1348.2L1351.7 477.4L1348.2 483.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1348.2 468.4H1341.3L1337.8 462.4L1341.3 456.3H1348.2L1351.7 462.4L1348.2 468.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1348.2 453.3H1341.3L1337.8 447.3L1341.3 441.3H1348.2L1351.7 447.3L1348.2 453.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1348.2 438.2H1341.3L1337.8 432.2L1341.3 426.2H1348.2L1351.7 432.2L1348.2 438.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1348.2 423.2H1341.3L1337.8 417.1L1341.3 411.1H1348.2L1351.7 417.1L1348.2 423.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1348.2 408.1H1341.3L1337.8 402.1L1341.3 396H1348.2L1351.7 402.1L1348.2 408.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1348.2 393H1341.3L1337.8 387L1341.3 381H1348.2L1351.7 387L1348.2 393Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1348.2 378H1341.3L1337.8 371.9L1341.3 365.9H1348.2L1351.7 371.9L1348.2 378Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1348.2 362.9H1341.3L1337.8 356.9L1341.3 350.8H1348.2L1351.7 356.9L1348.2 362.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1348.2 347.8H1341.3L1337.8 341.8L1341.3 335.8H1348.2L1351.7 341.8L1348.2 347.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1348.2 332.7H1341.3L1337.8 326.7L1341.3 320.7H1348.2L1351.7 326.7L1348.2 332.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1348.2 317.7H1341.3L1337.8 311.6L1341.3 305.6H1348.2L1351.7 311.6L1348.2 317.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1335.2 310.1H1328.2L1324.7 304.1L1328.2 298.1H1335.2L1338.6 304.1L1335.2 310.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1322.1 302.6H1315.2L1311.7 296.6L1315.2 290.5H1322.1L1325.6 296.6L1322.1 302.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1309.1 295.1H1302.1L1298.6 289L1302.1 283H1309.1L1312.5 289L1309.1 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1296 287.5H1289.1L1285.6 281.5L1289.1 275.5H1296L1299.5 281.5L1296 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1283 280H1276L1272.5 274L1276 267.9H1283L1286.4 274L1283 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1269.9 272.5H1262.9L1259.5 266.4L1262.9 260.4H1269.9L1273.4 266.4L1269.9 272.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1256.9 264.9H1249.9L1246.4 258.9L1249.9 252.9H1256.9L1260.3 258.9L1256.9 264.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1243.8 257.4H1236.8L1233.4 251.4L1236.8 245.3H1243.8L1247.3 251.4L1243.8 257.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1230.6 249.7H1223.9L1220.5 243.8L1223.9 238H1230.6L1234 243.8L1230.6 249.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1215.9 239.1H1212.6L1210.9 236.3L1212.6 233.5H1215.9L1217.5 236.3L1215.9 239.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1165.1 211.4H1159L1155.9 206.1L1159 200.9H1165.1L1168.1 206.1L1165.1 211.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M851.1 150H846.4L844 145.9L846.4 141.7H851.1L853.5 145.9L851.1 150Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M838.898 158.9H832.598L829.398 153.4L832.598 147.9H838.898L841.998 153.4L838.898 158.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M824.202 163.6H821.102L819.602 160.9L821.102 158.2H824.202L825.802 160.9L824.202 163.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M813.099 174.5H806.099L802.699 168.5L806.099 162.4H813.099L816.599 168.5L813.099 174.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M800.002 182H793.102L789.602 176L793.102 170H800.002L803.502 176L800.002 182Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M787.002 189.6H780.002L776.602 183.5L780.002 177.5H787.002L790.502 183.5L787.002 189.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M773.9 197.1H767L763.5 191.1L767 185H773.9L777.4 191.1L773.9 197.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M760.9 204.6H753.9L750.5 198.6L753.9 192.6H760.9L764.4 198.6L760.9 204.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M747.798 212.2H740.898L737.398 206.1L740.898 200.1H747.798L751.298 206.1L747.798 212.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M734.801 219.7H727.801L724.301 213.7L727.801 207.7H734.801L738.301 213.7L734.801 219.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M721.701 227.2H714.801L711.301 221.2L714.801 215.2H721.701L725.201 221.2L721.701 227.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M706.502 231H703.902L702.602 228.8L703.902 226.5H706.502L707.802 228.8L706.502 231Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M656.5 264.9H649.5L646 258.9L649.5 252.9H656.5L660 258.9L656.5 264.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.198 272.1H636.698L633.398 266.4L636.698 260.7H643.198L646.498 266.4L643.198 272.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M590.398 301.2H585.098L582.398 296.6L585.098 292H590.398L593.098 296.6L590.398 301.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M563.099 314.2H560.199L558.699 311.6L560.199 309.1H563.099L564.599 311.6L563.099 314.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M562.7 343.6H560.6L559.5 341.8L560.6 339.9H562.7L563.8 341.8L562.7 343.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M565.099 362.9H558.199L554.699 356.9L558.199 350.8H565.099L568.599 356.9L565.099 362.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M565.099 378H558.199L554.699 371.9L558.199 365.9H565.099L568.599 371.9L565.099 378Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M565.099 393H558.199L554.699 387L558.199 381H565.099L568.599 387L565.099 393Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M565.099 408.1H558.199L554.699 402.1L558.199 396H565.099L568.599 402.1L565.099 408.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M565.099 423.2H558.199L554.699 417.1L558.199 411.1H565.099L568.599 417.1L565.099 423.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M565.099 438.2H558.199L554.699 432.2L558.199 426.2H565.099L568.599 432.2L565.099 438.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M565.099 453.3H558.199L554.699 447.3L558.199 441.3H565.099L568.599 447.3L565.099 453.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M565.099 468.4H558.199L554.699 462.4L558.199 456.3H565.099L568.599 462.4L565.099 468.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M565.099 483.4H558.199L554.699 477.4L558.199 471.4H565.099L568.599 477.4L565.099 483.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M565.099 498.5H558.199L554.699 492.5L558.199 486.5H565.099L568.599 492.5L565.099 498.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M562.9 509.8H560.3L559 507.6L560.3 505.3H562.9L564.3 507.6L562.9 509.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M564.702 543H558.602L555.602 537.7L558.602 532.5H564.702L567.702 537.7L564.702 543Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M562.4 584.3H560.8L560 582.9L560.8 581.5H562.4L563.2 582.9L562.4 584.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M562.7 599.8H560.6L559.5 598L560.6 596.1H562.7L563.8 598L562.7 599.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M563.101 615.5H560.201L558.801 613.1L560.201 610.6H563.101L564.501 613.1L563.101 615.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M616.902 814.3H610.702L607.602 809L610.702 803.6H616.902L620.002 809L616.902 814.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M630.398 822.5H623.398L619.898 816.5L623.398 810.5H630.398L633.898 816.5L630.398 822.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.4 830.1H636.5L633 824L636.5 818H643.4L646.9 824L643.4 830.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M656.5 837.6H649.5L646 831.6L649.5 825.6H656.5L660 831.6L656.5 837.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M669.502 845.1H662.602L659.102 839.1L662.602 833.1H669.502L673.002 839.1L669.502 845.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1361.1 671.5H1354.5L1351.2 665.8L1354.5 660.1H1361.1L1364.3 665.8L1361.1 671.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1361 656.3H1354.6L1351.4 650.7L1354.6 645.2H1361L1364.2 650.7L1361 656.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1359.3 638.2H1356.3L1354.8 635.7L1356.3 633.1H1359.3L1360.8 635.7L1359.3 638.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1359.5 623.6H1356.1L1354.4 620.6L1356.1 617.6H1359.5L1361.2 620.6L1359.5 623.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1361.3 596.5H1354.3L1350.8 590.5L1354.3 584.4H1361.3L1364.8 590.5L1361.3 596.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1361.3 581.4H1354.3L1350.8 575.4L1354.3 569.4H1361.3L1364.8 575.4L1361.3 581.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1361.3 566.3H1354.3L1350.8 560.3L1354.3 554.3H1361.3L1364.8 560.3L1361.3 566.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1361.3 551.3H1354.3L1350.8 545.2L1354.3 539.2H1361.3L1364.8 545.2L1361.3 551.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1361.3 536.2H1354.3L1350.8 530.2L1354.3 524.1H1361.3L1364.8 530.2L1361.3 536.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1361.3 521.1H1354.3L1350.8 515.1L1354.3 509.1H1361.3L1364.8 515.1L1361.3 521.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1361.3 506.1H1354.3L1350.8 500L1354.3 494H1361.3L1364.8 500L1361.3 506.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1361.3 491H1354.3L1350.8 485L1354.3 478.9H1361.3L1364.8 485L1361.3 491Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1361.3 475.9H1354.3L1350.8 469.9L1354.3 463.9H1361.3L1364.8 469.9L1361.3 475.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1361.3 460.8H1354.3L1350.8 454.8L1354.3 448.8H1361.3L1364.8 454.8L1361.3 460.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1361.3 445.8H1354.3L1350.8 439.7L1354.3 433.7H1361.3L1364.8 439.7L1361.3 445.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1361.3 430.7H1354.3L1350.8 424.7L1354.3 418.6H1361.3L1364.8 424.7L1361.3 430.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1361.3 415.6H1354.3L1350.8 409.6L1354.3 403.6H1361.3L1364.8 409.6L1361.3 415.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1361.3 400.6H1354.3L1350.8 394.5L1354.3 388.5H1361.3L1364.8 394.5L1361.3 400.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1361.3 385.5H1354.3L1350.8 379.5L1354.3 373.4H1361.3L1364.8 379.5L1361.3 385.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1361.3 370.4H1354.3L1350.8 364.4L1354.3 358.4H1361.3L1364.8 364.4L1361.3 370.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1361.3 355.3H1354.3L1350.8 349.3L1354.3 343.3H1361.3L1364.8 349.3L1361.3 355.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1361.3 340.3H1354.3L1350.8 334.2L1354.3 328.2H1361.3L1364.8 334.2L1361.3 340.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1361.3 325.2H1354.3L1350.8 319.2L1354.3 313.1H1361.3L1364.8 319.2L1361.3 325.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1361.3 310.1H1354.3L1350.8 304.1L1354.3 298.1H1361.3L1364.8 304.1L1361.3 310.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1348.2 302.6H1341.3L1337.8 296.6L1341.3 290.5H1348.2L1351.7 296.6L1348.2 302.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1335.2 295.1H1328.2L1324.7 289L1328.2 283H1335.2L1338.6 289L1335.2 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1322.1 287.5H1315.2L1311.7 281.5L1315.2 275.5H1322.1L1325.6 281.5L1322.1 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1309.1 280H1302.1L1298.6 274L1302.1 267.9H1309.1L1312.5 274L1309.1 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1296 272.5H1289.1L1285.6 266.4L1289.1 260.4H1296L1299.5 266.4L1296 272.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1283 264.9H1276L1272.5 258.9L1276 252.9H1283L1286.4 258.9L1283 264.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1269.9 257.4H1262.9L1259.5 251.4L1262.9 245.3H1269.9L1273.4 251.4L1269.9 257.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1256.9 249.9H1249.9L1246.4 243.8L1249.9 237.8H1256.9L1260.3 243.8L1256.9 249.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1243.8 242.3H1236.8L1233.4 236.3L1236.8 230.3H1243.8L1247.3 236.3L1243.8 242.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1229.8 233.1H1224.8L1222.3 228.8L1224.8 224.4H1229.8L1232.3 228.8L1229.8 233.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1137.2 178.2H1134.6L1133.4 176L1134.6 173.8H1137.2L1138.5 176L1137.2 178.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M825.998 151.7H819.298L815.898 145.9L819.298 140H825.998L829.398 145.9L825.998 151.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M812.9 159.1H806.3L803 153.4L806.3 147.7H812.9L816.2 153.4L812.9 159.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M800.002 167H793.102L789.602 160.9L793.102 154.9H800.002L803.502 160.9L800.002 167Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M787.002 174.5H780.002L776.602 168.5L780.002 162.4H787.002L790.502 168.5L787.002 174.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M773.9 182H767L763.5 176L767 170H773.9L777.4 176L773.9 182Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M760.9 189.6H753.9L750.5 183.5L753.9 177.5H760.9L764.4 183.5L760.9 189.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M747.798 197.1H740.898L737.398 191.1L740.898 185H747.798L751.298 191.1L747.798 197.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M734.801 204.6H727.801L724.301 198.6L727.801 192.6H734.801L738.301 198.6L734.801 204.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M721.701 212.2H714.801L711.301 206.1L714.801 200.1H721.701L725.201 206.1L721.701 212.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M708.6 219.5H701.8L698.5 213.7L701.8 207.8H708.6L711.9 213.7L708.6 219.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M654.998 247.3H650.998L648.898 243.8L650.998 240.3H654.998L657.098 243.8L654.998 247.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.4 257.4H636.5L633 251.4L636.5 245.3H643.4L646.9 251.4L643.4 257.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M629.499 263.4H624.299L621.699 258.9L624.299 254.4H629.499L632.099 258.9L629.499 263.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M604.301 280H597.301L593.801 274L597.301 267.9H604.301L607.801 274L604.301 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M591.102 287.2H584.402L581.102 281.5L584.402 275.8H591.102L594.402 281.5L591.102 287.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M578.199 295.1H571.199L567.699 289L571.199 283H578.199L581.599 289L578.199 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M565.099 302.6H558.199L554.699 296.6L558.199 290.5H565.099L568.599 296.6L565.099 302.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M552.102 310.1H545.102L541.602 304.1L545.102 298.1H552.102L555.502 304.1L552.102 310.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M551.898 325H545.198L541.898 319.2L545.198 313.4H551.898L555.298 319.2L551.898 325Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M551.698 339.6H545.498L542.398 334.2L545.498 328.9H551.698L554.698 334.2L551.698 339.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M552.102 355.3H545.102L541.602 349.3L545.102 343.3H552.102L555.502 349.3L552.102 355.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M552.102 370.4H545.102L541.602 364.4L545.102 358.4H552.102L555.502 364.4L552.102 370.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M552.102 385.5H545.102L541.602 379.5L545.102 373.4H552.102L555.502 379.5L552.102 385.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M552.102 400.6H545.102L541.602 394.5L545.102 388.5H552.102L555.502 394.5L552.102 400.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M552.102 415.6H545.102L541.602 409.6L545.102 403.6H552.102L555.502 409.6L552.102 415.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M552.102 430.7H545.102L541.602 424.7L545.102 418.6H552.102L555.502 424.7L552.102 430.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M552.102 445.8H545.102L541.602 439.7L545.102 433.7H552.102L555.502 439.7L552.102 445.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M552.102 460.8H545.102L541.602 454.8L545.102 448.8H552.102L555.502 454.8L552.102 460.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M552.102 475.9H545.102L541.602 469.9L545.102 463.9H552.102L555.502 469.9L552.102 475.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M552.102 491H545.102L541.602 485L545.102 478.9H552.102L555.502 485L552.102 491Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M551.898 505.8H545.198L541.898 500L545.198 494.2H551.898L555.298 500L551.898 505.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M552.102 581.4H545.102L541.602 575.4L545.102 569.4H552.102L555.502 575.4L552.102 581.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M552.102 596.5H545.102L541.602 590.5L545.102 584.4H552.102L555.502 590.5L552.102 596.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M549.1 606.5H548L547.5 605.5L548 604.6H549.1L549.7 605.5L549.1 606.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M617.298 830.1H610.398L606.898 824L610.398 818H617.298L620.798 824L617.298 830.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M630.398 837.6H623.398L619.898 831.6L623.398 825.6H630.398L633.898 831.6L630.398 837.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.4 845.1H636.5L633 839.1L636.5 833.1H643.4L646.9 839.1L643.4 845.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M656.502 852.6H649.502L646.102 846.7L649.502 840.7H656.502L659.902 846.7L656.502 852.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1372.6 676.3H1369.1L1367.4 673.3L1369.1 670.4H1372.6L1374.3 673.3L1372.6 676.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1374.1 603.5H1367.6L1364.4 598L1367.6 592.4H1374.1L1377.3 598L1374.1 603.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1374.3 588.9H1367.4L1363.9 582.9L1367.4 576.9H1374.3L1377.8 582.9L1374.3 588.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1374.3 573.9H1367.4L1363.9 567.8L1367.4 561.8H1374.3L1377.8 567.8L1374.3 573.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1372.2 555.1H1369.5L1368.2 552.8L1369.5 550.5H1372.2L1373.5 552.8L1372.2 555.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1374.3 543.7H1367.4L1363.9 537.7L1367.4 531.7H1374.3L1377.8 537.7L1374.3 543.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1374.3 528.7H1367.4L1363.9 522.6L1367.4 516.6H1374.3L1377.8 522.6L1374.3 528.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1374.3 513.6H1367.4L1363.9 507.6L1367.4 501.5H1374.3L1377.8 507.6L1374.3 513.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1374.3 498.5H1367.4L1363.9 492.5L1367.4 486.5H1374.3L1377.8 492.5L1374.3 498.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1374.3 483.4H1367.4L1363.9 477.4L1367.4 471.4H1374.3L1377.8 477.4L1374.3 483.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1374.3 468.4H1367.4L1363.9 462.4L1367.4 456.3H1374.3L1377.8 462.4L1374.3 468.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1374.3 453.3H1367.4L1363.9 447.3L1367.4 441.3H1374.3L1377.8 447.3L1374.3 453.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1374.3 438.2H1367.4L1363.9 432.2L1367.4 426.2H1374.3L1377.8 432.2L1374.3 438.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1374.3 423.2H1367.4L1363.9 417.1L1367.4 411.1H1374.3L1377.8 417.1L1374.3 423.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1374.3 408.1H1367.4L1363.9 402.1L1367.4 396H1374.3L1377.8 402.1L1374.3 408.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1374.3 393H1367.4L1363.9 387L1367.4 381H1374.3L1377.8 387L1374.3 393Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1374.3 378H1367.4L1363.9 371.9L1367.4 365.9H1374.3L1377.8 371.9L1374.3 378Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1374.3 362.9H1367.4L1363.9 356.9L1367.4 350.8H1374.3L1377.8 356.9L1374.3 362.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1374.3 347.8H1367.4L1363.9 341.8L1367.4 335.8H1374.3L1377.8 341.8L1374.3 347.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1374.3 332.7H1367.4L1363.9 326.7L1367.4 320.7H1374.3L1377.8 326.7L1374.3 332.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1374.3 317.7H1367.4L1363.9 311.6L1367.4 305.6H1374.3L1377.8 311.6L1374.3 317.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1374.3 302.6H1367.4L1363.9 296.6L1367.4 290.5H1374.3L1377.8 296.6L1374.3 302.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1361.3 295.1H1354.3L1350.8 289L1354.3 283H1361.3L1364.8 289L1361.3 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1348.2 287.5H1341.3L1337.8 281.5L1341.3 275.5H1348.2L1351.7 281.5L1348.2 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1335.2 280H1328.2L1324.7 274L1328.2 267.9H1335.2L1338.6 274L1335.2 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1322.1 272.5H1315.2L1311.7 266.4L1315.2 260.4H1322.1L1325.6 266.4L1322.1 272.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1309.1 264.9H1302.1L1298.6 258.9L1302.1 252.9H1309.1L1312.5 258.9L1309.1 264.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1296 257.4H1289.1L1285.6 251.4L1289.1 245.3H1296L1299.5 251.4L1296 257.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1283 249.9H1276L1272.5 243.8L1276 237.8H1283L1286.4 243.8L1283 249.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1269.9 242.3H1262.9L1259.5 236.3L1262.9 230.3H1269.9L1273.4 236.3L1269.9 242.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1256.9 234.8H1249.9L1246.4 228.8L1249.9 222.7H1256.9L1260.3 228.8L1256.9 234.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1243.7 227.1H1236.9L1233.6 221.2L1236.9 215.4H1243.7L1247.1 221.2L1243.7 227.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M800.001 151.7H793.201L789.801 145.9L793.201 140H800.001L803.301 145.9L800.001 151.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M787.002 159.4H780.002L776.602 153.4L780.002 147.4H787.002L790.502 153.4L787.002 159.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M773.9 167H767L763.5 160.9L767 154.9H773.9L777.4 160.9L773.9 167Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M760.9 174.5H753.9L750.5 168.5L753.9 162.4H760.9L764.4 168.5L760.9 174.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M747.798 182H740.898L737.398 176L740.898 170H747.798L751.298 176L747.798 182Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M734.801 189.6H727.801L724.301 183.5L727.801 177.5H734.801L738.301 183.5L734.801 189.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M721.701 197.1H714.801L711.301 191.1L714.801 185H721.701L725.201 191.1L721.701 197.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M708.699 204.6H701.699L698.199 198.6L701.699 192.6H708.699L712.199 198.6L708.699 204.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M695.599 212.2H688.699L685.199 206.1L688.699 200.1H695.599L699.099 206.1L695.599 212.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M680.4 216H677.8L676.5 213.7L677.8 211.4H680.4L681.7 213.7L680.4 216Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M640.602 237.4H639.302L638.602 236.3L639.302 235.1H640.602L641.302 236.3L640.602 237.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M630.398 249.9H623.398L619.898 243.8L623.398 237.8H630.398L633.898 243.8L630.398 249.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M617.298 257.4H610.398L606.898 251.4L610.398 245.3H617.298L620.798 251.4L617.298 257.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M603.501 263.6H598.101L595.301 258.9L598.101 254.2H603.501L606.301 258.9L603.501 263.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M589.699 269.9H585.699L583.699 266.4L585.699 263H589.699L591.799 266.4L589.699 269.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M578.199 280H571.199L567.699 274L571.199 267.9H578.199L581.599 274L578.199 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M565.099 287.5H558.199L554.699 281.5L558.199 275.5H565.099L568.599 281.5L565.099 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M552.102 295.1H545.102L541.602 289L545.102 283H552.102L555.502 289L552.102 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M539.002 302.6H532.102L528.602 296.6L532.102 290.5H539.002L542.502 296.6L539.002 302.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M539.002 317.7H532.102L528.602 311.6L532.102 305.6H539.002L542.502 311.6L539.002 317.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M539.002 332.7H532.102L528.602 326.7L532.102 320.7H539.002L542.502 326.7L539.002 332.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M539.002 347.8H532.102L528.602 341.8L532.102 335.8H539.002L542.502 341.8L539.002 347.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M539.002 362.9H532.102L528.602 356.9L532.102 350.8H539.002L542.502 356.9L539.002 362.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M539.002 378H532.102L528.602 371.9L532.102 365.9H539.002L542.502 371.9L539.002 378Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M539.002 393H532.102L528.602 387L532.102 381H539.002L542.502 387L539.002 393Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M539.002 408.1H532.102L528.602 402.1L532.102 396H539.002L542.502 402.1L539.002 408.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M539.002 423.2H532.102L528.602 417.1L532.102 411.1H539.002L542.502 417.1L539.002 423.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M539.002 438.2H532.102L528.602 432.2L532.102 426.2H539.002L542.502 432.2L539.002 438.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M539.002 453.3H532.102L528.602 447.3L532.102 441.3H539.002L542.502 447.3L539.002 453.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M539.002 468.4H532.102L528.602 462.4L532.102 456.3H539.002L542.502 462.4L539.002 468.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M539.002 483.4H532.102L528.602 477.4L532.102 471.4H539.002L542.502 477.4L539.002 483.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M539.002 498.5H532.102L528.602 492.5L532.102 486.5H539.002L542.502 492.5L539.002 498.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M537.901 511.6H533.201L530.801 507.6L533.201 503.5H537.901L540.201 507.6L537.901 511.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M539.002 558.8H532.102L528.602 552.8L532.102 546.7H539.002L542.502 552.8L539.002 558.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M538.699 573.3H532.399L529.199 567.8L532.399 562.4H538.699L541.799 567.8L538.699 573.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M539.002 588.9H532.102L528.602 582.9L532.102 576.9H539.002L542.502 582.9L539.002 588.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M617.199 844.9H610.499L607.199 839.1L610.499 833.3H617.199L620.499 839.1L617.199 844.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M630.398 852.7H623.398L619.898 846.7L623.398 840.6H630.398L633.898 846.7L630.398 852.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.4 860.2H636.5L633 854.2L636.5 848.2H643.4L646.9 854.2L643.4 860.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M654 863.4H652L651 861.7L652 860H654L655 861.7L654 863.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1387.2 686.7H1380.6L1377.2 680.9L1380.6 675.1H1387.2L1390.6 680.9L1387.2 686.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1386.3 654.9H1381.5L1379.1 650.7L1381.5 646.6H1386.3L1388.7 650.7L1386.3 654.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1384.6 591.8H1383.1L1382.4 590.5L1383.1 589.2H1384.6L1385.4 590.5L1384.6 591.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1385.1 577.5H1382.7L1381.4 575.4L1382.7 573.2H1385.1L1386.4 575.4L1385.1 577.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1386.5 564.8H1381.3L1378.7 560.3L1381.3 555.8H1386.5L1389.1 560.3L1386.5 564.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1387.2 551H1380.6L1377.3 545.2L1380.6 539.5H1387.2L1390.5 545.2L1387.2 551Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1387.4 536.2H1380.4L1376.9 530.2L1380.4 524.1H1387.4L1390.9 530.2L1387.4 536.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1387.4 521.1H1380.4L1376.9 515.1L1380.4 509.1H1387.4L1390.9 515.1L1387.4 521.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1387.4 506.1H1380.4L1376.9 500L1380.4 494H1387.4L1390.9 500L1387.4 506.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1387.4 491H1380.4L1376.9 485L1380.4 478.9H1387.4L1390.9 485L1387.4 491Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1387.4 475.9H1380.4L1376.9 469.9L1380.4 463.9H1387.4L1390.9 469.9L1387.4 475.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1387.4 460.8H1380.4L1376.9 454.8L1380.4 448.8H1387.4L1390.9 454.8L1387.4 460.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1387.4 445.8H1380.4L1376.9 439.7L1380.4 433.7H1387.4L1390.9 439.7L1387.4 445.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1387.4 430.7H1380.4L1376.9 424.7L1380.4 418.6H1387.4L1390.9 424.7L1387.4 430.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1387.4 415.6H1380.4L1376.9 409.6L1380.4 403.6H1387.4L1390.9 409.6L1387.4 415.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1387.4 400.6H1380.4L1376.9 394.5L1380.4 388.5H1387.4L1390.9 394.5L1387.4 400.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1387.4 385.5H1380.4L1376.9 379.5L1380.4 373.4H1387.4L1390.9 379.5L1387.4 385.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1387.4 370.4H1380.4L1376.9 364.4L1380.4 358.4H1387.4L1390.9 364.4L1387.4 370.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1387.4 355.3H1380.4L1376.9 349.3L1380.4 343.3H1387.4L1390.9 349.3L1387.4 355.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1387.4 340.3H1380.4L1376.9 334.2L1380.4 328.2H1387.4L1390.9 334.2L1387.4 340.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1387.4 325.2H1380.4L1376.9 319.2L1380.4 313.1H1387.4L1390.9 319.2L1387.4 325.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1387.4 310.1H1380.4L1376.9 304.1L1380.4 298.1H1387.4L1390.9 304.1L1387.4 310.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1387.4 295.1H1380.4L1376.9 289L1380.4 283H1387.4L1390.9 289L1387.4 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1374.3 287.5H1367.4L1363.9 281.5L1367.4 275.5H1374.3L1377.8 281.5L1374.3 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1361.3 280H1354.3L1350.8 274L1354.3 267.9H1361.3L1364.8 274L1361.3 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1348.2 272.5H1341.3L1337.8 266.4L1341.3 260.4H1348.2L1351.7 266.4L1348.2 272.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1335.2 264.9H1328.2L1324.7 258.9L1328.2 252.9H1335.2L1338.6 258.9L1335.2 264.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1322.1 257.4H1315.2L1311.7 251.4L1315.2 245.3H1322.1L1325.6 251.4L1322.1 257.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1309.1 249.9H1302.1L1298.6 243.8L1302.1 237.8H1309.1L1312.5 243.8L1309.1 249.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1296 242.3H1289.1L1285.6 236.3L1289.1 230.3H1296L1299.5 236.3L1296 242.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1283 234.8H1276L1272.5 228.8L1276 222.7H1283L1286.4 228.8L1283 234.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1269.9 227.2H1262.9L1259.5 221.2L1262.9 215.2H1269.9L1273.4 221.2L1269.9 227.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1255.2 216.8H1251.5L1249.7 213.7L1251.5 210.5H1255.2L1257 213.7L1255.2 216.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M773.298 150.7H767.698L764.898 145.9L767.698 141H773.298L776.098 145.9L773.298 150.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M760.198 158.2H754.698L751.898 153.4L754.698 148.6H760.198L762.898 153.4L760.198 158.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M747 165.6H741.7L739 160.9L741.7 156.3H747L749.7 160.9L747 165.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M734.801 174.5H727.801L724.301 168.5L727.801 162.4H734.801L738.301 168.5L734.801 174.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M721.701 182H714.801L711.301 176L714.801 170H721.701L725.201 176L721.701 182Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M708.699 189.6H701.699L698.199 183.5L701.699 177.5H708.699L712.199 183.5L708.699 189.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M695.599 197.1H688.699L685.199 191.1L688.699 185H695.599L699.099 191.1L695.599 197.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M680.698 201.4H677.498L675.898 198.6L677.498 195.9H680.698L682.298 198.6L680.698 201.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M669.3 211.8H662.8L659.5 206.1L662.8 200.5H669.3L672.6 206.1L669.3 211.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M617.199 242.1H610.499L607.199 236.3L610.499 230.5H617.199L620.499 236.3L617.199 242.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M604.301 249.9H597.301L593.801 243.8L597.301 237.8H604.301L607.801 243.8L604.301 249.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M591.201 257.4H584.301L580.801 251.4L584.301 245.3H591.201L594.701 251.4L591.201 257.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M578.201 264.9H571.201L567.801 258.9L571.201 252.9H578.201L581.601 258.9L578.201 264.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M564.798 271.8H558.498L555.398 266.4L558.498 261H564.798L567.898 266.4L564.798 271.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M552.102 280H545.102L541.602 274L545.102 267.9H552.102L555.502 274L552.102 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M539.002 287.5H532.102L528.602 281.5L532.102 275.5H539.002L542.502 281.5L539.002 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M526 295.1H519L515.5 289L519 283H526L529.4 289L526 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M526 310.1H519L515.5 304.1L519 298.1H526L529.4 304.1L526 310.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M526 325.2H519L515.5 319.2L519 313.1H526L529.4 319.2L526 325.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M526 340.3H519L515.5 334.2L519 328.2H526L529.4 334.2L526 340.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M526 355.3H519L515.5 349.3L519 343.3H526L529.4 349.3L526 355.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M526 370.4H519L515.5 364.4L519 358.4H526L529.4 364.4L526 370.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M526 385.5H519L515.5 379.5L519 373.4H526L529.4 379.5L526 385.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M526 400.6H519L515.5 394.5L519 388.5H526L529.4 394.5L526 400.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M526 415.6H519L515.5 409.6L519 403.6H526L529.4 409.6L526 415.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M526 430.7H519L515.5 424.7L519 418.6H526L529.4 424.7L526 430.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M526 445.8H519L515.5 439.7L519 433.7H526L529.4 439.7L526 445.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M526 460.8H519L515.5 454.8L519 448.8H526L529.4 454.8L526 460.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M526 475.9H519L515.5 469.9L519 463.9H526L529.4 469.9L526 475.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M526 491H519L515.5 485L519 478.9H526L529.4 485L526 491Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M525.801 505.8H519.101L515.801 500L519.101 494.2H525.801L529.201 500L525.801 505.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M523.399 546.8H521.599L520.699 545.2L521.599 543.7H523.399L524.299 545.2L523.399 546.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M525.902 566.3H519.002L515.602 560.3L519.002 554.3H525.902L529.402 560.3L525.902 566.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M525.9 581.4H519L515.5 575.4L519 569.4H525.9L529.4 575.4L525.9 581.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M617 859.7H610.7L607.5 854.2L610.7 848.7H617L620.1 854.2L617 859.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M630.398 867.8H623.398L619.898 861.7L623.398 855.7H630.398L633.898 861.7L630.398 867.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.4 875.3H636.5L633 869.3L636.5 863.2H643.4L646.9 869.3L643.4 875.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1400.2 799.5H1393.7L1390.5 793.9L1393.7 788.4H1400.2L1403.4 793.9L1400.2 799.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1400.4 784.8H1393.5L1390.1 778.8L1393.5 772.9H1400.4L1403.8 778.8L1400.4 784.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1398.6 766.6H1395.3L1393.7 763.8L1395.3 760.9H1398.6L1400.2 763.8L1398.6 766.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1399.8 693.4H1394.1L1391.2 688.4L1394.1 683.5H1399.8L1402.7 688.4L1399.8 693.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1400.4 664.3H1393.5L1390 658.3L1393.5 652.2H1400.4L1403.9 658.3L1400.4 664.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1400.4 649.2H1393.5L1390 643.2L1393.5 637.2H1400.4L1403.9 643.2L1400.4 649.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1397.8 629.5H1396.1L1395.3 628.1L1396.1 626.7H1397.8L1398.6 628.1L1397.8 629.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1400.4 543.7H1393.5L1390 537.7L1393.5 531.7H1400.4L1403.9 537.7L1400.4 543.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1400.4 528.7H1393.5L1390 522.6L1393.5 516.6H1400.4L1403.9 522.6L1400.4 528.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1400.4 513.6H1393.5L1390 507.6L1393.5 501.5H1400.4L1403.9 507.6L1400.4 513.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1400.4 498.5H1393.5L1390 492.5L1393.5 486.5H1400.4L1403.9 492.5L1400.4 498.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1400.4 483.4H1393.5L1390 477.4L1393.5 471.4H1400.4L1403.9 477.4L1400.4 483.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1400.4 468.4H1393.5L1390 462.4L1393.5 456.3H1400.4L1403.9 462.4L1400.4 468.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1400.4 453.3H1393.5L1390 447.3L1393.5 441.3H1400.4L1403.9 447.3L1400.4 453.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1400.4 438.2H1393.5L1390 432.2L1393.5 426.2H1400.4L1403.9 432.2L1400.4 438.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1400.4 423.2H1393.5L1390 417.1L1393.5 411.1H1400.4L1403.9 417.1L1400.4 423.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1400.4 408.1H1393.5L1390 402.1L1393.5 396H1400.4L1403.9 402.1L1400.4 408.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1400.4 393H1393.5L1390 387L1393.5 381H1400.4L1403.9 387L1400.4 393Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1400.4 378H1393.5L1390 371.9L1393.5 365.9H1400.4L1403.9 371.9L1400.4 378Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1400.4 362.9H1393.5L1390 356.9L1393.5 350.8H1400.4L1403.9 356.9L1400.4 362.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1400.4 347.8H1393.5L1390 341.8L1393.5 335.8H1400.4L1403.9 341.8L1400.4 347.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1400.4 332.7H1393.5L1390 326.7L1393.5 320.7H1400.4L1403.9 326.7L1400.4 332.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1400.4 317.7H1393.5L1390 311.6L1393.5 305.6H1400.4L1403.9 311.6L1400.4 317.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1400.4 302.6H1393.5L1390 296.6L1393.5 290.5H1400.4L1403.9 296.6L1400.4 302.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1400.4 287.5H1393.5L1390 281.5L1393.5 275.5H1400.4L1403.9 281.5L1400.4 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1387.4 280H1380.4L1376.9 274L1380.4 267.9H1387.4L1390.9 274L1387.4 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1374.3 272.5H1367.4L1363.9 266.4L1367.4 260.4H1374.3L1377.8 266.4L1374.3 272.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1361.3 264.9H1354.3L1350.8 258.9L1354.3 252.9H1361.3L1364.8 258.9L1361.3 264.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1348.2 257.4H1341.3L1337.8 251.4L1341.3 245.3H1348.2L1351.7 251.4L1348.2 257.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1335.2 249.9H1328.2L1324.7 243.8L1328.2 237.8H1335.2L1338.6 243.8L1335.2 249.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1322.1 242.3H1315.2L1311.7 236.3L1315.2 230.3H1322.1L1325.6 236.3L1322.1 242.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1309.1 234.8H1302.1L1298.6 228.8L1302.1 222.7H1309.1L1312.5 228.8L1309.1 234.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1296 227.2H1289.1L1285.6 221.2L1289.1 215.2H1296L1299.5 221.2L1296 227.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1282.9 219.6H1276L1272.6 213.7L1276 207.7H1282.9L1286.4 213.7L1282.9 219.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1267.4 207.8H1265.4L1264.5 206.1L1265.4 204.4H1267.4L1268.4 206.1L1267.4 207.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M720.801 165.3H715.801L713.301 160.9L715.801 156.6H720.801L723.301 160.9L720.801 165.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M708.502 174.2H701.902L698.602 168.5L701.902 162.8H708.502L711.802 168.5L708.502 174.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M695.599 182H688.699L685.199 176L688.699 170H695.599L699.099 176L695.599 182Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M680.198 185.5H677.998L676.898 183.5L677.998 181.6H680.198L681.298 183.5L680.198 185.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M668.502 195.4H663.602L661.102 191.1L663.602 186.8H668.502L671.002 191.1L668.502 195.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M629.6 218.3H624.2L621.5 213.7L624.2 209H629.6L632.2 213.7L629.6 218.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M616.901 226.4H610.801L607.801 221.2L610.801 216H616.901L619.901 221.2L616.901 226.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M602.9 232.5H598.6L596.5 228.8L598.6 225H602.9L605.1 228.8L602.9 232.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M591.1 242.1H584.4L581 236.3L584.4 230.5H591.1L594.5 236.3L591.1 242.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M564.998 257.2H558.298L554.898 251.4L558.298 245.6H564.998L568.298 251.4L564.998 257.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M536.6 268.2H534.5L533.5 266.4L534.5 264.7H536.6L537.6 266.4L536.6 268.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M526 280H519L515.5 274L519 267.9H526L529.4 274L526 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M512.9 287.5H505.9L502.5 281.5L505.9 275.5H512.9L516.4 281.5L512.9 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M512.9 302.6H505.9L502.5 296.6L505.9 290.5H512.9L516.4 296.6L512.9 302.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M512.9 317.7H505.9L502.5 311.6L505.9 305.6H512.9L516.4 311.6L512.9 317.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M512.9 332.7H505.9L502.5 326.7L505.9 320.7H512.9L516.4 326.7L512.9 332.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M512.9 347.8H505.9L502.5 341.8L505.9 335.8H512.9L516.4 341.8L512.9 347.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M512.9 362.9H505.9L502.5 356.9L505.9 350.8H512.9L516.4 356.9L512.9 362.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M512.9 378H505.9L502.5 371.9L505.9 365.9H512.9L516.4 371.9L512.9 378Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M512.9 393H505.9L502.5 387L505.9 381H512.9L516.4 387L512.9 393Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M512.9 408.1H505.9L502.5 402.1L505.9 396H512.9L516.4 402.1L512.9 408.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M512.9 423.2H505.9L502.5 417.1L505.9 411.1H512.9L516.4 417.1L512.9 423.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M512.9 438.2H505.9L502.5 432.2L505.9 426.2H512.9L516.4 432.2L512.9 438.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M512.9 453.3H505.9L502.5 447.3L505.9 441.3H512.9L516.4 447.3L512.9 453.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M512.9 468.4H505.9L502.5 462.4L505.9 456.3H512.9L516.4 462.4L512.9 468.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M512.9 483.4H505.9L502.5 477.4L505.9 471.4H512.9L516.4 477.4L512.9 483.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M512.9 498.5H505.9L502.5 492.5L505.9 486.5H512.9L516.4 492.5L512.9 498.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M511.999 512.1H506.799L504.199 507.6L506.799 503H511.999L514.599 507.6L511.999 512.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M510.299 554.3H508.599L507.699 552.8L508.599 551.3H510.299L511.099 552.8L510.299 554.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M512.9 573.8H506L502.5 567.8L506 561.9H512.9L516.3 567.8L512.9 573.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M617.298 875.3H610.398L606.898 869.3L610.398 863.2H617.298L620.798 869.3L617.298 875.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M630.398 882.8H623.398L619.898 876.8L623.398 870.8H630.398L633.898 876.8L630.398 882.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.4 890.3H636.5L633 884.3L636.5 878.3H643.4L646.9 884.3L643.4 890.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1398.7 812H1395.2L1393.4 809L1395.2 805.9H1398.7L1400.5 809L1398.7 812Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1413.5 807.5H1406.5L1403 801.4L1406.5 795.4H1413.5L1417 801.4L1413.5 807.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1413.5 792.4H1406.5L1403 786.4L1406.5 780.3H1413.5L1417 786.4L1413.5 792.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1413.5 777.3H1406.5L1403 771.3L1406.5 765.3H1413.5L1417 771.3L1413.5 777.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1412.5 760.6H1407.5L1405 756.2L1407.5 751.9H1412.5L1415 756.2L1412.5 760.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1413.3 671.5H1406.7L1403.4 665.8L1406.7 660.1H1413.3L1416.6 665.8L1413.3 671.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1413.5 656.8H1406.5L1403 650.7L1406.5 644.7H1413.5L1417 650.7L1413.5 656.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1413.5 641.7H1406.5L1403 635.7L1406.5 629.6H1413.5L1417 635.7L1413.5 641.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1412.9 625.6H1407.1L1404.3 620.6L1407.1 615.6H1412.9L1415.7 620.6L1412.9 625.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1413.2 535.6H1406.8L1403.7 530.2L1406.8 524.7H1413.2L1416.3 530.2L1413.2 535.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1413.5 521.1H1406.5L1403 515.1L1406.5 509.1H1413.5L1417 515.1L1413.5 521.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1413.5 506.1H1406.5L1403 500L1406.5 494H1413.5L1417 500L1413.5 506.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1413.5 491H1406.5L1403 485L1406.5 478.9H1413.5L1417 485L1413.5 491Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1413.5 475.9H1406.5L1403 469.9L1406.5 463.9H1413.5L1417 469.9L1413.5 475.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1411.9 458.1H1408.1L1406.2 454.8L1408.1 451.6H1411.9L1413.8 454.8L1411.9 458.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1413.5 445.8H1406.5L1403 439.7L1406.5 433.7H1413.5L1417 439.7L1413.5 445.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1413.5 430.7H1406.5L1403 424.7L1406.5 418.6H1413.5L1417 424.7L1413.5 430.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1413.5 415.6H1406.5L1403 409.6L1406.5 403.6H1413.5L1417 409.6L1413.5 415.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1413.5 400.6H1406.5L1403 394.5L1406.5 388.5H1413.5L1417 394.5L1413.5 400.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1413.5 385.5H1406.5L1403 379.5L1406.5 373.4H1413.5L1417 379.5L1413.5 385.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1413.5 370.4H1406.5L1403 364.4L1406.5 358.4H1413.5L1417 364.4L1413.5 370.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1413.5 355.3H1406.5L1403 349.3L1406.5 343.3H1413.5L1417 349.3L1413.5 355.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1413.5 340.3H1406.5L1403 334.2L1406.5 328.2H1413.5L1417 334.2L1413.5 340.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1413.5 325.2H1406.5L1403 319.2L1406.5 313.1H1413.5L1417 319.2L1413.5 325.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1413.5 310.1H1406.5L1403 304.1L1406.5 298.1H1413.5L1417 304.1L1413.5 310.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1413.5 295.1H1406.5L1403 289L1406.5 283H1413.5L1417 289L1413.5 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1413.5 280H1406.5L1403 274L1406.5 267.9H1413.5L1417 274L1413.5 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1400.4 272.5H1393.5L1390 266.4L1393.5 260.4H1400.4L1403.9 266.4L1400.4 272.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1387.4 264.9H1380.4L1376.9 258.9L1380.4 252.9H1387.4L1390.9 258.9L1387.4 264.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1374.3 257.4H1367.4L1363.9 251.4L1367.4 245.3H1374.3L1377.8 251.4L1374.3 257.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1361.3 249.9H1354.3L1350.8 243.8L1354.3 237.8H1361.3L1364.8 243.8L1361.3 249.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1348.2 242.3H1341.3L1337.8 236.3L1341.3 230.3H1348.2L1351.7 236.3L1348.2 242.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1335.1 234.7H1328.3L1324.9 228.8L1328.3 222.8H1335.1L1338.5 228.8L1335.1 234.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1322.1 227.2H1315.2L1311.8 221.2L1315.2 215.3H1322.1L1325.5 221.2L1322.1 227.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1309.1 219.7H1302.1L1298.6 213.7L1302.1 207.7H1309.1L1312.5 213.7L1309.1 219.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1296 212.2H1289.1L1285.6 206.1L1289.1 200.1H1296L1299.5 206.1L1296 212.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1255.9 187.9H1250.8L1248.3 183.5L1250.8 179.1H1255.9L1258.5 183.5L1255.9 187.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1242 178.8H1238.7L1237 176L1238.7 173.2H1242L1243.6 176L1242 178.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M694.601 165.1H689.801L687.301 160.9L689.801 156.8H694.601L697.001 160.9L694.601 165.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M681.001 171.8H677.201L675.301 168.5L677.201 165.1H681.001L683.001 168.5L681.001 171.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M669.098 181.3H662.998L659.898 176L662.998 170.7H669.098L672.198 176L669.098 181.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M655.098 187.1H650.898L648.898 183.5L650.898 180H655.098L657.098 183.5L655.098 187.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.301 196.8H636.601L633.301 191.1L636.601 185.3H643.301L646.601 191.1L643.301 196.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M630.398 204.6H623.398L619.898 198.6L623.398 192.6H630.398L633.898 198.6L630.398 204.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M617.298 212.2H610.398L606.898 206.1L610.398 200.1H617.298L620.798 206.1L617.298 212.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M602.298 216.2H599.298L597.898 213.7L599.298 211.2H602.298L603.698 213.7L602.298 216.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M589.398 224.1H585.998L584.398 221.2L585.998 218.3H589.398L591.098 221.2L589.398 224.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M550.201 246.7H546.901L545.301 243.8L546.901 241H550.201L551.901 243.8L550.201 246.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M537.601 255H533.401L531.301 251.4L533.401 247.7H537.601L539.701 251.4L537.601 255Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M524.599 262.6H520.299L518.199 258.9L520.299 255.2H524.599L526.799 258.9L524.599 262.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M510.4 268.1H508.4L507.5 266.4L508.4 264.7H510.4L511.4 266.4L510.4 268.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M499.898 280H492.898L489.398 274L492.898 267.9H499.898L503.298 274L499.898 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M499.898 295.1H492.898L489.398 289L492.898 283H499.898L503.298 289L499.898 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M499.898 310.1H492.898L489.398 304.1L492.898 298.1H499.898L503.298 304.1L499.898 310.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M499.898 325.2H492.898L489.398 319.2L492.898 313.1H499.898L503.298 319.2L499.898 325.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M499.898 340.3H492.898L489.398 334.2L492.898 328.2H499.898L503.298 334.2L499.898 340.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M499.898 355.3H492.898L489.398 349.3L492.898 343.3H499.898L503.298 349.3L499.898 355.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M499.898 370.4H492.898L489.398 364.4L492.898 358.4H499.898L503.298 364.4L499.898 370.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M499.898 385.5H492.898L489.398 379.5L492.898 373.4H499.898L503.298 379.5L499.898 385.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M499.898 400.6H492.898L489.398 394.5L492.898 388.5H499.898L503.298 394.5L499.898 400.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M499.898 415.6H492.898L489.398 409.6L492.898 403.6H499.898L503.298 409.6L499.898 415.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M499.898 430.7H492.898L489.398 424.7L492.898 418.6H499.898L503.298 424.7L499.898 430.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M499.898 445.8H492.898L489.398 439.7L492.898 433.7H499.898L503.298 439.7L499.898 445.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M499.898 460.8H492.898L489.398 454.8L492.898 448.8H499.898L503.298 454.8L499.898 460.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M499.898 475.9H492.898L489.398 469.9L492.898 463.9H499.898L503.298 469.9L499.898 475.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M499.898 491H492.898L489.398 485L492.898 478.9H499.898L503.298 485L499.898 491Z",
  fill: "#AF6AF4",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M499.898 506.1H492.898L489.398 500L492.898 494H499.898L503.298 500L499.898 506.1Z",
  fill: "#AF6AF4",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M499.898 521.1H492.898L489.398 515.1L492.898 509.1H499.898L503.298 515.1L499.898 521.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M499.898 536.2H492.898L489.398 530.2L492.898 524.1H499.898L503.298 530.2L499.898 536.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M499.898 551.3H492.898L489.398 545.2L492.898 539.2H499.898L503.298 545.2L499.898 551.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M499.898 566.3H492.898L489.398 560.3L492.898 554.3H499.898L503.298 560.3L499.898 566.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M497.098 576.7H495.598L494.898 575.4L495.598 574.1H497.098L497.898 575.4L497.098 576.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M617.298 890.3H610.398L606.898 884.3L610.398 878.3H617.298L620.798 884.3L617.298 890.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M630.398 897.9H623.398L619.898 891.9L623.398 885.8H630.398L633.898 891.9L630.398 897.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.402 905.3H636.502L633.102 899.4L636.502 893.5H643.402L646.802 899.4L643.402 905.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1398.1 826H1395.8L1394.7 824L1395.8 822.1H1398.1L1399.2 824L1398.1 826Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1413.5 822.5H1406.5L1403 816.5L1406.5 810.5H1413.5L1417 816.5L1413.5 822.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1426.5 815H1419.6L1416.1 809L1419.6 803H1426.5L1430 809L1426.5 815Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1426.5 799.9H1419.6L1416.1 793.9L1419.6 787.9H1426.5L1430 793.9L1426.5 799.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1426.5 784.9H1419.6L1416.1 778.8L1419.6 772.8H1426.5L1430 778.8L1426.5 784.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1426.5 769.8H1419.6L1416.1 763.8L1419.6 757.7H1426.5L1430 763.8L1426.5 769.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1426.4 754.5H1419.7L1416.4 748.7L1419.7 742.9H1426.4L1429.7 748.7L1426.4 754.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1423.7 734.7H1422.4L1421.8 733.6L1422.4 732.6H1423.7L1424.3 733.6L1423.7 734.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1425.2 662H1420.9L1418.8 658.3L1420.9 654.6H1425.2L1427.3 658.3L1425.2 662Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1424.2 645.1H1421.9L1420.8 643.2L1421.9 641.3H1424.2L1425.3 643.2L1424.2 645.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1425.2 631.8H1420.9L1418.8 628.1L1420.9 624.4H1425.2L1427.3 628.1L1425.2 631.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1424.8 540.7H1421.3L1419.6 537.7L1421.3 534.7H1424.8L1426.5 537.7L1424.8 540.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1424.1 524.5H1422L1420.9 522.6L1422 520.8H1424.1L1425.2 522.6L1424.1 524.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1426.2 513H1419.9L1416.7 507.6L1419.9 502.1H1426.2L1429.4 507.6L1426.2 513Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1426.4 498.3H1419.7L1416.3 492.5L1419.7 486.7H1426.4L1429.8 492.5L1426.4 498.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1423.6 478.4H1422.5L1421.9 477.4L1422.5 476.4H1423.6L1424.2 477.4L1423.6 478.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1424.5 464.8H1421.6L1420.2 462.4L1421.6 459.9H1424.5L1425.9 462.4L1424.5 464.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1426.1 452.6H1420L1417 447.3L1420 442H1426.1L1429.1 447.3L1426.1 452.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1426.5 438.2H1419.6L1416.1 432.2L1419.6 426.2H1426.5L1430 432.2L1426.5 438.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1426.5 423.2H1419.6L1416.1 417.1L1419.6 411.1H1426.5L1430 417.1L1426.5 423.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1426.5 408.1H1419.6L1416.1 402.1L1419.6 396H1426.5L1430 402.1L1426.5 408.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1426.5 393H1419.6L1416.1 387L1419.6 381H1426.5L1430 387L1426.5 393Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1426.5 378H1419.6L1416.1 371.9L1419.6 365.9H1426.5L1430 371.9L1426.5 378Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1426.5 362.9H1419.6L1416.1 356.9L1419.6 350.8H1426.5L1430 356.9L1426.5 362.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1426.5 347.8H1419.6L1416.1 341.8L1419.6 335.8H1426.5L1430 341.8L1426.5 347.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1426.5 332.7H1419.6L1416.1 326.7L1419.6 320.7H1426.5L1430 326.7L1426.5 332.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1426.5 317.7H1419.6L1416.1 311.6L1419.6 305.6H1426.5L1430 311.6L1426.5 317.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1426.5 302.6H1419.6L1416.1 296.6L1419.6 290.5H1426.5L1430 296.6L1426.5 302.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1426.5 287.5H1419.6L1416.1 281.5L1419.6 275.5H1426.5L1430 281.5L1426.5 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1426.5 272.5H1419.6L1416.1 266.4L1419.6 260.4H1426.5L1430 266.4L1426.5 272.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1413.5 264.9H1406.5L1403 258.9L1406.5 252.9H1413.5L1417 258.9L1413.5 264.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1400.4 257.4H1393.5L1390 251.4L1393.5 245.3H1400.4L1403.9 251.4L1400.4 257.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1387.4 249.9H1380.4L1376.9 243.8L1380.4 237.8H1387.4L1390.9 243.8L1387.4 249.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1374.3 242.3H1367.4L1363.9 236.3L1367.4 230.3H1374.3L1377.7 236.3L1374.3 242.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1359.3 231.4H1356.2L1354.7 228.8L1356.2 226.1H1359.3L1360.9 228.8L1359.3 231.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1333.3 216.4H1330.1L1328.5 213.7L1330.1 210.9H1333.3L1334.9 213.7L1333.3 216.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1322.1 212.1H1315.2L1311.7 206.1L1315.2 200.2H1322.1L1325.5 206.1L1322.1 212.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1268.1 178.8H1264.8L1263.2 176L1264.8 173.2H1268.1L1269.7 176L1268.1 178.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M681.499 157.6H676.699L674.199 153.4L676.699 149.2H681.499L683.999 153.4L681.499 157.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M669.502 167H662.602L659.102 160.9L662.602 154.9H669.502L673.002 160.9L669.502 167Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M656.5 174.5H649.5L646 168.5L649.5 162.4H656.5L660 168.5L656.5 174.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.4 182H636.5L633 176L636.5 170H643.4L646.9 176L643.4 182Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M630.398 189.6H623.398L619.898 183.5L623.398 177.5H630.398L633.898 183.5L630.398 189.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M617.298 197.1H610.398L606.898 191.1L610.398 185H617.298L620.798 191.1L617.298 197.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M603.801 203.8H597.801L594.801 198.6L597.801 193.4H603.801L606.801 198.6L603.801 203.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M590.499 211H584.999L582.199 206.1L584.999 201.3H590.499L593.299 206.1L590.499 211Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M575.598 215.2H573.798L572.898 213.7L573.798 212.2H575.598L576.398 213.7L575.598 215.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M552.102 234.8H545.102L541.602 228.8L545.102 222.7H552.102L555.502 228.8L552.102 234.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M536.701 238.2H534.401L533.301 236.3L534.401 234.3H536.701L537.801 236.3L536.701 238.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M526 249.9H519L515.5 243.8L519 237.8H526L529.4 243.8L526 249.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M512.9 257.4H505.9L502.5 251.4L505.9 245.3H512.9L516.4 251.4L512.9 257.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M499.398 264H493.398L490.398 258.9L493.398 253.7H499.398L502.298 258.9L499.398 264Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M486.5 271.9H480.2L477 266.4L480.2 260.9H486.5L489.7 266.4L486.5 271.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M486.798 287.5H479.798L476.398 281.5L479.798 275.5H486.798L490.298 281.5L486.798 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M486.798 302.6H479.798L476.398 296.6L479.798 290.5H486.798L490.298 296.6L486.798 302.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M486.798 317.7H479.798L476.398 311.6L479.798 305.6H486.798L490.298 311.6L486.798 317.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M486.798 332.7H479.798L476.398 326.7L479.798 320.7H486.798L490.298 326.7L486.798 332.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M486.798 347.8H479.798L476.398 341.8L479.798 335.8H486.798L490.298 341.8L486.798 347.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M486.798 362.9H479.798L476.398 356.9L479.798 350.8H486.798L490.298 356.9L486.798 362.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M486.798 378H479.798L476.398 371.9L479.798 365.9H486.798L490.298 371.9L486.798 378Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M486.798 393H479.798L476.398 387L479.798 381H486.798L490.298 387L486.798 393Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M486.798 408.1H479.798L476.398 402.1L479.798 396H486.798L490.298 402.1L486.798 408.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M486.798 423.2H479.798L476.398 417.1L479.798 411.1H486.798L490.298 417.1L486.798 423.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M486.798 438.2H479.798L476.398 432.2L479.798 426.2H486.798L490.298 432.2L486.798 438.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M486.798 453.3H479.798L476.398 447.3L479.798 441.3H486.798L490.298 447.3L486.798 453.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M486.798 468.4H479.798L476.398 462.4L479.798 456.3H486.798L490.298 462.4L486.798 468.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M486.798 483.4H479.798L476.398 477.4L479.798 471.4H486.798L490.298 477.4L486.798 483.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M486.798 498.5H479.798L476.398 492.5L479.798 486.5H486.798L490.298 492.5L486.798 498.5Z",
  fill: "#AF6AF4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M486.798 513.6H479.798L476.398 507.6L479.798 501.5H486.798L490.298 507.6L486.798 513.6Z",
  fill: "#AF6AF4",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M486.798 528.7H479.798L476.398 522.6L479.798 516.6H486.798L490.298 522.6L486.798 528.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M486.798 543.7H479.798L476.398 537.7L479.798 531.7H486.798L490.298 537.7L486.798 543.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M486.798 558.8H479.798L476.398 552.8L479.798 546.7H486.798L490.298 552.8L486.798 558.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M485 570.7H481.7L480 567.8L481.7 565H485L486.6 567.8L485 570.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M616.901 904.6H610.801L607.801 899.4L610.801 894.2H616.901L619.901 899.4L616.901 904.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M630.398 913H623.398L619.898 906.9L623.398 900.9H630.398L633.898 906.9L630.398 913Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M640.998 916.2H638.898L637.898 914.5L638.898 912.7H640.998L641.998 914.5L640.998 916.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1437.8 819.5H1434.4L1432.6 816.5L1434.4 813.5H1437.8L1439.6 816.5L1437.8 819.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1439.6 807.5H1432.6L1429.1 801.4L1432.6 795.4H1439.6L1443.1 801.4L1439.6 807.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1439.6 792.4H1432.6L1429.1 786.4L1432.6 780.3H1439.6L1443.1 786.4L1439.6 792.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1439.6 777.3H1432.6L1429.1 771.3L1432.6 765.3H1439.6L1443.1 771.3L1439.6 777.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1439.6 762.3H1432.6L1429.1 756.2L1432.6 750.2H1439.6L1443.1 756.2L1439.6 762.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1439.6 747.2H1432.6L1429.1 741.2L1432.6 735.1H1439.6L1443.1 741.2L1439.6 747.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1437.5 668.3H1434.7L1433.3 665.8L1434.7 663.3H1437.5L1438.9 665.8L1437.5 668.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1439.3 656.4H1432.9L1429.6 650.7L1432.9 645.1H1439.3L1442.6 650.7L1439.3 656.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1439.6 566.3H1432.6L1429.1 560.3L1432.6 554.3H1439.6L1443.1 560.3L1439.6 566.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1438.5 459H1433.7L1431.3 454.8L1433.7 450.7H1438.5L1440.9 454.8L1438.5 459Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1439.6 445.8H1432.6L1429.1 439.7L1432.6 433.7H1439.6L1443.1 439.7L1439.6 445.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1439.6 430.7H1432.6L1429.1 424.7L1432.6 418.6H1439.6L1443.1 424.7L1439.6 430.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1439.6 415.6H1432.6L1429.1 409.6L1432.6 403.6H1439.6L1443.1 409.6L1439.6 415.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1439.6 400.6H1432.6L1429.1 394.5L1432.6 388.5H1439.6L1443.1 394.5L1439.6 400.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1439.6 385.5H1432.6L1429.1 379.5L1432.6 373.4H1439.6L1443.1 379.5L1439.6 385.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1439.6 370.4H1432.6L1429.1 364.4L1432.6 358.4H1439.6L1443.1 364.4L1439.6 370.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1439.6 355.3H1432.6L1429.1 349.3L1432.6 343.3H1439.6L1443.1 349.3L1439.6 355.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1439.6 340.3H1432.6L1429.1 334.2L1432.6 328.2H1439.6L1443.1 334.2L1439.6 340.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1439.6 325.2H1432.6L1429.1 319.2L1432.6 313.1H1439.6L1443.1 319.2L1439.6 325.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1439.6 310.1H1432.6L1429.1 304.1L1432.6 298.1H1439.6L1443.1 304.1L1439.6 310.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1439.6 295.1H1432.6L1429.1 289L1432.6 283H1439.6L1443.1 289L1439.6 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1439.6 280H1432.6L1429.1 274L1432.6 267.9H1439.6L1443.1 274L1439.6 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1439.6 264.9H1432.6L1429.1 258.9L1432.6 252.9H1439.6L1443.1 258.9L1439.6 264.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1426.5 257.4H1419.6L1416.1 251.4L1419.6 245.3H1426.5L1430 251.4L1426.5 257.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1413.5 249.9H1406.5L1403 243.8L1406.5 237.8H1413.5L1417 243.8L1413.5 249.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1398.9 239.6H1395L1393.1 236.3L1395 233H1398.9L1400.8 236.3L1398.9 239.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M655.7 158.1H650.3L647.5 153.4L650.3 148.7H655.7L658.5 153.4L655.7 158.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.4 167H636.5L633 160.9L636.5 154.9H643.4L646.9 160.9L643.4 167Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M630.398 174.5H623.398L619.898 168.5L623.398 162.4H630.398L633.898 168.5L630.398 174.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M617.298 182H610.398L606.898 176L610.398 170H617.298L620.798 176L617.298 182Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M602.899 187.1H598.699L596.699 183.5L598.699 180H602.899L604.899 183.5L602.899 187.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M590.499 195.9H584.999L582.199 191.1L584.999 186.3H590.499L593.299 191.1L590.499 195.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M562.601 207.8H560.701L559.801 206.1L560.701 204.5H562.601L563.501 206.1L562.601 207.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M551.499 218.7H545.699L542.699 213.7L545.699 208.6H551.499L554.399 213.7L551.499 218.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M537.002 223.7H534.102L532.602 221.2L534.102 218.7H537.002L538.502 221.2L537.002 223.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M525.402 233.9H519.502L516.602 228.8L519.502 223.6H525.402L528.402 228.8L525.402 233.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M512.9 242.3H506L502.5 236.3L506 230.3H512.9L516.3 236.3L512.9 242.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M499.898 249.9H492.898L489.398 243.8L492.898 237.8H499.898L503.298 243.8L499.898 249.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M486.399 256.7H480.199L477.199 251.4L480.199 246H486.399L489.499 251.4L486.399 256.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M471.099 260.3H469.499L468.699 258.9L469.499 257.5H471.099L471.899 258.9L471.099 260.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M473.801 280H466.801L463.301 274L466.801 267.9H473.801L477.201 274L473.801 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M473.801 295.1H466.801L463.301 289L466.801 283H473.801L477.201 289L473.801 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M473.801 310.1H466.801L463.301 304.1L466.801 298.1H473.801L477.201 304.1L473.801 310.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M473.801 325.2H466.801L463.301 319.2L466.801 313.1H473.801L477.201 319.2L473.801 325.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M473.801 340.3H466.801L463.301 334.2L466.801 328.2H473.801L477.201 334.2L473.801 340.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M473.801 355.3H466.801L463.301 349.3L466.801 343.3H473.801L477.201 349.3L473.801 355.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M473.801 370.4H466.801L463.301 364.4L466.801 358.4H473.801L477.201 364.4L473.801 370.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M473.801 385.5H466.801L463.301 379.5L466.801 373.4H473.801L477.201 379.5L473.801 385.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M473.801 400.6H466.801L463.301 394.5L466.801 388.5H473.801L477.201 394.5L473.801 400.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M473.801 415.6H466.801L463.301 409.6L466.801 403.6H473.801L477.201 409.6L473.801 415.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M473.801 430.7H466.801L463.301 424.7L466.801 418.6H473.801L477.201 424.7L473.801 430.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M473.801 445.8H466.801L463.301 439.7L466.801 433.7H473.801L477.201 439.7L473.801 445.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M473.801 460.8H466.801L463.301 454.8L466.801 448.8H473.801L477.201 454.8L473.801 460.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M473.801 475.9H466.801L463.301 469.9L466.801 463.9H473.801L477.201 469.9L473.801 475.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M473.801 491H466.801L463.301 485L466.801 478.9H473.801L477.201 485L473.801 491Z",
  fill: "#AF6AF4",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M473.801 506.1H466.801L463.301 500L466.801 494H473.801L477.201 500L473.801 506.1Z",
  fill: "#AF6AF4",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M473.801 521.1H466.801L463.301 515.1L466.801 509.1H473.801L477.201 515.1L473.801 521.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M473.801 536.2H466.801L463.301 530.2L466.801 524.1H473.801L477.201 530.2L473.801 536.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M473.698 551.2H466.798L463.398 545.2L466.798 539.3H473.698L477.098 545.2L473.698 551.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M471.698 562.8H468.898L467.398 560.3L468.898 557.9H471.698L473.098 560.3L471.698 562.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M615.7 917.8H611.9L610 914.5L611.9 911.2H615.7L617.6 914.5L615.7 917.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M630.398 928H623.398L619.898 922L623.398 916H630.398L633.898 922L630.398 928Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M643.2 935.1H636.7L633.5 929.5L636.7 923.9H643.2L646.4 929.5L643.2 935.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M654.498 939.7H651.498L649.898 937.1L651.498 934.4H654.498L656.098 937.1L654.498 939.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1451.8 813.6H1446.5L1443.8 809L1446.5 804.4H1451.8L1454.5 809L1451.8 813.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1452.6 799.9H1445.7L1442.2 793.9L1445.7 787.9H1452.6L1456.1 793.9L1452.6 799.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1452.6 784.9H1445.7L1442.2 778.8L1445.7 772.8H1452.6L1456.1 778.8L1452.6 784.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1452.6 769.8H1445.7L1442.2 763.8L1445.7 757.7H1452.6L1456.1 763.8L1452.6 769.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1452.6 754.7H1445.7L1442.2 748.7L1445.7 742.7H1452.6L1456.1 748.7L1452.6 754.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1452.6 739.7H1445.7L1442.2 733.6L1445.7 727.6H1452.6L1456.1 733.6L1452.6 739.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1451.7 723H1446.6L1444 718.6L1446.6 714.1H1451.7L1454.3 718.6L1451.7 723Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1450.5 600.3H1447.8L1446.5 598L1447.8 595.7H1450.5L1451.8 598L1450.5 600.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1450.2 584.8H1448.1L1447 582.9L1448.1 581H1450.2L1451.3 582.9L1450.2 584.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1452.5 468.1H1445.9L1442.5 462.4L1445.9 456.6H1452.5L1455.8 462.4L1452.5 468.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1451.7 451.7H1446.6L1444 447.3L1446.6 442.8H1451.7L1454.3 447.3L1451.7 451.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1452.6 438.2H1445.7L1442.2 432.2L1445.7 426.2H1452.6L1456.1 432.2L1452.6 438.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1452.6 423.2H1445.7L1442.2 417.1L1445.7 411.1H1452.6L1456.1 417.1L1452.6 423.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1452.6 408.1H1445.7L1442.2 402.1L1445.7 396H1452.6L1456.1 402.1L1452.6 408.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1452.6 393H1445.7L1442.2 387L1445.7 381H1452.6L1456.1 387L1452.6 393Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1452.6 378H1445.7L1442.2 371.9L1445.7 365.9H1452.6L1456.1 371.9L1452.6 378Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1452.6 362.9H1445.7L1442.2 356.9L1445.7 350.8H1452.6L1456.1 356.9L1452.6 362.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1452.6 347.8H1445.7L1442.2 341.8L1445.7 335.8H1452.6L1456.1 341.8L1452.6 347.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1452.6 332.7H1445.7L1442.2 326.7L1445.7 320.7H1452.6L1456.1 326.7L1452.6 332.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1452.6 317.7H1445.7L1442.2 311.6L1445.7 305.6H1452.6L1456.1 311.6L1452.6 317.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1452.6 302.6H1445.7L1442.2 296.6L1445.7 290.5H1452.6L1456.1 296.6L1452.6 302.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1452.6 287.5H1445.7L1442.2 281.5L1445.7 275.5H1452.6L1456.1 281.5L1452.6 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1452.6 272.5H1445.7L1442.2 266.4L1445.7 260.4H1452.6L1456.1 266.4L1452.6 272.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1452.6 257.4H1445.7L1442.2 251.4L1445.7 245.3H1452.6L1456.1 251.4L1452.6 257.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1439.6 249.9H1432.6L1429.1 243.8L1432.6 237.8H1439.6L1443.1 243.8L1439.6 249.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1425 239.6H1421.1L1419.2 236.3L1421.1 233H1425L1426.9 236.3L1425 239.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M628.999 157H624.799L622.699 153.4L624.799 149.8H628.999L631.099 153.4L628.999 157Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M617.298 167H610.398L606.898 160.9L610.398 154.9H617.298L620.798 160.9L617.298 167Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M603.299 172.8H598.299L595.699 168.5L598.299 164.1H603.299L605.799 168.5L603.299 172.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M591.201 182H584.301L580.801 176L584.301 170H591.201L594.701 176L591.201 182Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M536.601 208.1H534.401L533.301 206.1L534.401 204.2H536.601L537.701 206.1L536.601 208.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M525.798 219.4H519.198L515.898 213.7L519.198 208H525.798L528.998 213.7L525.798 219.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M511.902 225.4H507.002L504.602 221.2L507.002 217H511.902L514.302 221.2L511.902 225.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M499.798 234.8H492.898L489.398 228.8L492.898 222.7H499.798L503.298 228.8L499.798 234.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M486.798 242.3H479.798L476.398 236.3L479.798 230.3H486.798L490.298 236.3L486.798 242.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M471.1 245.3H469.4L468.5 243.8L469.4 242.3H471.1L472 243.8L471.1 245.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M460.701 272.5H453.701L450.301 266.4L453.701 260.4H460.701L464.201 266.4L460.701 272.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M460.701 287.5H453.701L450.301 281.5L453.701 275.5H460.701L464.201 281.5L460.701 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M460.701 302.6H453.701L450.301 296.6L453.701 290.5H460.701L464.201 296.6L460.701 302.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M460.701 317.7H453.701L450.301 311.6L453.701 305.6H460.701L464.201 311.6L460.701 317.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M460.701 332.7H453.701L450.301 326.7L453.701 320.7H460.701L464.201 326.7L460.701 332.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M460.701 347.8H453.701L450.301 341.8L453.701 335.8H460.701L464.201 341.8L460.701 347.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M460.701 362.9H453.701L450.301 356.9L453.701 350.8H460.701L464.201 356.9L460.701 362.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M460.701 378H453.701L450.301 371.9L453.701 365.9H460.701L464.201 371.9L460.701 378Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M460.701 393H453.701L450.301 387L453.701 381H460.701L464.201 387L460.701 393Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M460.701 408.1H453.701L450.301 402.1L453.701 396H460.701L464.201 402.1L460.701 408.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M460.701 423.2H453.701L450.301 417.1L453.701 411.1H460.701L464.201 417.1L460.701 423.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M460.701 438.2H453.701L450.301 432.2L453.701 426.2H460.701L464.201 432.2L460.701 438.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M460.701 453.3H453.701L450.301 447.3L453.701 441.3H460.701L464.201 447.3L460.701 453.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M460.701 468.4H453.701L450.301 462.4L453.701 456.3H460.701L464.201 462.4L460.701 468.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M460.701 483.4H453.701L450.301 477.4L453.701 471.4H460.701L464.201 477.4L460.701 483.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M460.701 498.5H453.701L450.301 492.5L453.701 486.5H460.701L464.201 492.5L460.701 498.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M460.701 513.6H453.701L450.301 507.6L453.701 501.5H460.701L464.201 507.6L460.701 513.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M460.499 528.3H453.999L450.699 522.6L453.999 517H460.499L463.699 522.6L460.499 528.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1465.7 807.5H1458.7L1455.2 801.4L1458.7 795.4H1465.7L1469.2 801.4L1465.7 807.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1465.7 792.4H1458.7L1455.2 786.4L1458.7 780.3H1465.7L1469.2 786.4L1465.7 792.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1465.7 777.3H1458.7L1455.2 771.3L1458.7 765.3H1465.7L1469.2 771.3L1465.7 777.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1465.7 762.3H1458.7L1455.2 756.2L1458.7 750.2H1465.7L1469.2 756.2L1465.7 762.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1465.7 747.2H1458.7L1455.2 741.2L1458.7 735.1H1465.7L1469.2 741.2L1465.7 747.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1465.7 732.1H1458.7L1455.2 726.1L1458.7 720.1H1465.7L1469.2 726.1L1465.7 732.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1463.2 712.8H1461.2L1460.1 711L1461.2 709.2H1463.2L1464.3 711L1463.2 712.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1465.6 596.3H1458.8L1455.5 590.5L1458.8 584.6H1465.6L1468.9 590.5L1465.6 596.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1464.8 489.5H1459.6L1457 485L1459.6 480.4H1464.8L1467.4 485L1464.8 489.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1462.7 470.8H1461.7L1461.1 469.9L1461.7 469H1462.7L1463.3 469.9L1462.7 470.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1465.5 430.4H1458.9L1455.6 424.7L1458.9 419H1465.5L1468.8 424.7L1465.5 430.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1465.7 415.6H1458.7L1455.2 409.6L1458.7 403.6H1465.7L1469.2 409.6L1465.7 415.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1465.7 400.6H1458.7L1455.2 394.5L1458.7 388.5H1465.7L1469.2 394.5L1465.7 400.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1465.7 385.5H1458.7L1455.2 379.5L1458.7 373.4H1465.7L1469.2 379.5L1465.7 385.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1465.6 370.3H1458.8L1455.4 364.4L1458.8 358.5H1465.6L1469 364.4L1465.6 370.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1464.5 353.3H1459.9L1457.6 349.3L1459.9 345.4H1464.5L1466.8 349.3L1464.5 353.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1465.7 340.3H1458.7L1455.2 334.2L1458.7 328.2H1465.7L1469.2 334.2L1465.7 340.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1465.7 325.2H1458.7L1455.2 319.2L1458.7 313.1H1465.7L1469.2 319.2L1465.7 325.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1465.7 310.1H1458.7L1455.2 304.1L1458.7 298.1H1465.7L1469.2 304.1L1465.7 310.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1465.7 295.1H1458.7L1455.2 289L1458.7 283H1465.7L1469.2 289L1465.7 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1465.7 280H1458.7L1455.2 274L1458.7 267.9H1465.7L1469.2 274L1465.7 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1465.7 264.9H1458.7L1455.2 258.9L1458.7 252.9H1465.7L1469.2 258.9L1465.7 264.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1465.7 249.9H1458.7L1455.2 243.8L1458.7 237.8H1465.7L1469.2 243.8L1465.7 249.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1452.6 242.3H1445.7L1442.2 236.3L1445.7 230.3H1452.6L1456.1 236.3L1452.6 242.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1437.8 231.7H1434.4L1432.7 228.8L1434.4 225.8H1437.8L1439.5 228.8L1437.8 231.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M601.402 154.4H600.202L599.602 153.4L600.202 152.4H601.402L602.002 153.4L601.402 154.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M588.302 162H587.202L586.602 160.9L587.202 159.9H588.302L588.902 160.9L588.302 162Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M523.801 200.9H521.201L519.801 198.6L521.201 196.3H523.801L525.101 198.6L523.801 200.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M510.299 207.6H508.599L507.699 206.1L508.599 204.7H510.299L511.099 206.1L510.299 207.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M497.901 216.3H494.901L493.301 213.7L494.901 211.1H497.901L499.401 213.7L497.901 216.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M486.699 227H479.999L476.699 221.2L479.999 215.4H486.699L489.999 221.2L486.699 227Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M473.801 234.8H466.801L463.301 228.8L466.801 222.7H473.801L477.201 228.8L473.801 234.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M460.701 242.3H453.701L450.301 236.3L453.701 230.3H460.701L464.201 236.3L460.701 242.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M446.202 262.4H442.202L440.102 258.9L442.202 255.4H446.202L448.202 258.9L446.202 262.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M447.699 280H440.699L437.199 274L440.699 267.9H447.699L451.099 274L447.699 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M447.699 295.1H440.699L437.199 289L440.699 283H447.699L451.099 289L447.699 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M447.699 310.1H440.699L437.199 304.1L440.699 298.1H447.699L451.099 304.1L447.699 310.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M447.699 325.2H440.699L437.199 319.2L440.699 313.1H447.699L451.099 319.2L447.699 325.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M447.699 340.3H440.699L437.199 334.2L440.699 328.2H447.699L451.099 334.2L447.699 340.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M447.699 355.3H440.699L437.199 349.3L440.699 343.3H447.699L451.099 349.3L447.699 355.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M447.699 370.4H440.699L437.199 364.4L440.699 358.4H447.699L451.099 364.4L447.699 370.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M447.699 385.5H440.699L437.199 379.5L440.699 373.4H447.699L451.099 379.5L447.699 385.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M447.699 400.6H440.699L437.199 394.5L440.699 388.5H447.699L451.099 394.5L447.699 400.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M447.699 415.6H440.699L437.199 409.6L440.699 403.6H447.699L451.099 409.6L447.699 415.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M447.699 430.7H440.699L437.199 424.7L440.699 418.6H447.699L451.099 424.7L447.699 430.7Z",
  fill: "#AF6AF4",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M447.699 445.8H440.699L437.199 439.7L440.699 433.7H447.699L451.099 439.7L447.699 445.8Z",
  fill: "#AF6AF4",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M447.699 460.8H440.699L437.199 454.8L440.699 448.8H447.699L451.099 454.8L447.699 460.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M447.699 475.9H440.699L437.199 469.9L440.699 463.9H447.699L451.099 469.9L447.699 475.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M447.699 491H440.699L437.199 485L440.699 478.9H447.699L451.099 485L447.699 491Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M447.598 505.9H440.798L437.398 500L440.798 494.1H447.598L450.998 500L447.598 505.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M447.199 520.3H441.199L438.199 515.1L441.199 509.9H447.199L450.099 515.1L447.199 520.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M446.7 534.6H441.6L439 530.2L441.6 525.7H446.7L449.3 530.2L446.7 534.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1476.6 826.4H1473.9L1472.6 824L1473.9 821.7H1476.6L1477.9 824L1476.6 826.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1478.7 815H1471.8L1468.3 809L1471.8 803H1478.7L1482.2 809L1478.7 815Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1478.7 799.9H1471.8L1468.3 793.9L1471.8 787.9H1478.7L1482.2 793.9L1478.7 799.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1478.7 784.9H1471.8L1468.3 778.8L1471.8 772.8H1478.7L1482.2 778.8L1478.7 784.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1478.7 769.8H1471.8L1468.3 763.8L1471.8 757.7H1478.7L1482.2 763.8L1478.7 769.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1478.7 754.7H1471.8L1468.3 748.7L1471.8 742.7H1478.7L1482.2 748.7L1478.7 754.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1478.7 739.7H1471.8L1468.3 733.6L1471.8 727.6H1478.7L1482.2 733.6L1478.7 739.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1478.7 724.6H1471.8L1468.3 718.6L1471.8 712.5H1478.7L1482.2 718.6L1478.7 724.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1476.9 706.3H1473.6L1472 703.5L1473.6 700.7H1476.9L1478.5 703.5L1476.9 706.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1477.2 661.6H1473.3L1471.4 658.3L1473.3 654.9H1477.2L1479.1 658.3L1477.2 661.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1478.6 648.9H1471.9L1468.6 643.2L1471.9 637.5H1478.6L1481.9 643.2L1478.6 648.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1478.5 483H1472L1468.8 477.4L1472 471.8H1478.5L1481.7 477.4L1478.5 483Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1475.9 418.3H1474.6L1473.9 417.1L1474.6 416H1475.9L1476.6 417.1L1475.9 418.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1478.7 408H1471.8L1468.4 402.1L1471.8 396.1H1478.7L1482.2 402.1L1478.7 408Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1478.7 393H1471.8L1468.3 387L1471.8 381H1478.7L1482.2 387L1478.7 393Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1478.7 377.9H1471.8L1468.4 371.9L1471.8 366H1478.7L1482.1 371.9L1478.7 377.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1476.7 359.4H1473.8L1472.3 356.9L1473.8 354.3H1476.7L1478.2 356.9L1476.7 359.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1478.6 332.5H1471.9L1468.5 326.7L1471.9 320.9H1478.6L1482 326.7L1478.6 332.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1478.7 317.7H1471.8L1468.3 311.6L1471.8 305.6H1478.7L1482.2 311.6L1478.7 317.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1478.7 302.6H1471.8L1468.3 296.6L1471.8 290.5H1478.7L1482.2 296.6L1478.7 302.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1478.7 287.5H1471.8L1468.3 281.5L1471.8 275.5H1478.7L1482.2 281.5L1478.7 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1478.7 272.5H1471.8L1468.3 266.4L1471.8 260.4H1478.7L1482.2 266.4L1478.7 272.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1478.7 257.4H1471.8L1468.3 251.4L1471.8 245.3H1478.7L1482.2 251.4L1478.7 257.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1439.2 219H1433L1429.9 213.7L1433 208.3H1439.2L1442.3 213.7L1439.2 219Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1425.8 210.9H1420.3L1417.5 206.1L1420.3 201.4H1425.8L1428.6 206.1L1425.8 210.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M471.501 215.8H469.001L467.801 213.7L469.001 211.5H471.501L472.801 213.7L471.501 215.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M458.999 224.2H455.499L453.699 221.2L455.499 218.2H458.999L460.699 221.2L458.999 224.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M434.599 272.5H427.599L424.199 266.4L427.599 260.4H434.599L438.099 266.4L434.599 272.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M434.599 287.5H427.599L424.199 281.5L427.599 275.5H434.599L438.099 281.5L434.599 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M434.599 302.6H427.599L424.199 296.6L427.599 290.5H434.599L438.099 296.6L434.599 302.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M434.599 317.7H427.599L424.199 311.6L427.599 305.6H434.599L438.099 311.6L434.599 317.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M434.599 332.7H427.599L424.199 326.7L427.599 320.7H434.599L438.099 326.7L434.599 332.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M434.599 347.8H427.599L424.199 341.8L427.599 335.8H434.599L438.099 341.8L434.599 347.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M434.599 362.9H427.599L424.199 356.9L427.599 350.8H434.599L438.099 356.9L434.599 362.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M434.599 378H427.599L424.199 371.9L427.599 365.9H434.599L438.099 371.9L434.599 378Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M434.599 393H427.599L424.199 387L427.599 381H434.599L438.099 387L434.599 393Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M434.599 408.1H427.599L424.199 402.1L427.599 396H434.599L438.099 402.1L434.599 408.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M434.599 423.2H427.599L424.199 417.1L427.599 411.1H434.599L438.099 417.1L434.599 423.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M434.599 438.2H427.599L424.199 432.2L427.599 426.2H434.599L438.099 432.2L434.599 438.2Z",
  fill: "#AF6AF4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M434.599 453.3H427.599L424.199 447.3L427.599 441.3H434.599L438.099 447.3L434.599 453.3Z",
  fill: "#AF6AF4",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M434.599 468.4H427.599L424.199 462.4L427.599 456.3H434.599L438.099 462.4L434.599 468.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M434.599 483.4H427.599L424.199 477.4L427.599 471.4H434.599L438.099 477.4L434.599 483.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M434.599 498.5H427.599L424.199 492.5L427.599 486.5H434.599L438.099 492.5L434.599 498.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M434.402 513.2H427.902L424.602 507.6L427.902 501.9H434.402L437.602 507.6L434.402 513.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1489.3 833.3H1487.3L1486.4 831.6L1487.3 829.9H1489.3L1490.2 831.6L1489.3 833.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1491.8 822.5H1484.8L1481.3 816.5L1484.8 810.5H1491.8L1495.3 816.5L1491.8 822.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1491.8 807.5H1484.8L1481.3 801.4L1484.8 795.4H1491.8L1495.3 801.4L1491.8 807.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1491.8 792.4H1484.8L1481.3 786.4L1484.8 780.3H1491.8L1495.3 786.4L1491.8 792.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1491.8 777.3H1484.8L1481.3 771.3L1484.8 765.3H1491.8L1495.3 771.3L1491.8 777.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1491.8 762.3H1484.8L1481.3 756.2L1484.8 750.2H1491.8L1495.3 756.2L1491.8 762.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1491.8 747.2H1484.8L1481.3 741.2L1484.8 735.1H1491.8L1495.3 741.2L1491.8 747.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1491.8 732.1H1484.8L1481.3 726.1L1484.8 720.1H1491.8L1495.3 726.1L1491.8 732.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1491.8 717H1484.8L1481.3 711L1484.8 705H1491.8L1495.3 711L1491.8 717Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1491.8 475.9H1484.8L1481.3 469.9L1484.8 463.9H1491.8L1495.3 469.9L1491.8 475.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1490.1 427.8H1486.5L1484.7 424.7L1486.5 421.5H1490.1L1491.9 424.7L1490.1 427.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1489.4 396.4H1487.2L1486.1 394.5L1487.2 392.6H1489.4L1490.5 394.5L1489.4 396.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1490.5 383.3H1486.1L1483.8 379.5L1486.1 375.6H1490.5L1492.8 379.5L1490.5 383.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1490.9 369H1485.7L1483 364.4L1485.7 359.8H1490.9L1493.6 364.4L1490.9 369Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1491.8 325.2H1484.8L1481.3 319.2L1484.8 313.1H1491.8L1495.3 319.2L1491.8 325.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1491.8 310.1H1484.8L1481.3 304.1L1484.8 298.1H1491.8L1495.3 304.1L1491.8 310.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1491.8 295.1H1484.8L1481.3 289L1484.8 283H1491.8L1495.3 289L1491.8 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1491.8 280H1484.8L1481.3 274L1484.8 267.9H1491.8L1495.3 274L1491.8 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1491.8 264.9H1484.8L1481.3 258.9L1484.8 252.9H1491.8L1495.3 258.9L1491.8 264.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1489.2 245.4H1487.4L1486.5 243.8L1487.4 242.3H1489.2L1490.1 243.8L1489.2 245.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M420.302 262.8H415.802L413.602 258.9L415.802 255H420.302L422.602 258.9L420.302 262.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M421.502 280H414.602L411.102 274L414.602 267.9H421.502L425.002 274L421.502 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M421.502 295.1H414.602L411.102 289L414.602 283H421.502L425.002 289L421.502 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M421.502 310.1H414.602L411.102 304.1L414.602 298.1H421.502L425.002 304.1L421.502 310.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M421.502 325.2H414.602L411.102 319.2L414.602 313.1H421.502L425.002 319.2L421.502 325.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M421.502 340.3H414.602L411.102 334.2L414.602 328.2H421.502L425.002 334.2L421.502 340.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M421.502 355.3H414.602L411.102 349.3L414.602 343.3H421.502L425.002 349.3L421.502 355.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M421.502 370.4H414.602L411.102 364.4L414.602 358.4H421.502L425.002 364.4L421.502 370.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M421.502 385.5H414.602L411.102 379.5L414.602 373.4H421.502L425.002 379.5L421.502 385.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M421.502 400.6H414.602L411.102 394.5L414.602 388.5H421.502L425.002 394.5L421.502 400.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M421.502 415.6H414.602L411.102 409.6L414.602 403.6H421.502L425.002 409.6L421.502 415.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M421.502 430.7H414.602L411.102 424.7L414.602 418.6H421.502L425.002 424.7L421.502 430.7Z",
  fill: "#AF6AF4",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M421.502 445.8H414.602L411.102 439.7L414.602 433.7H421.502L425.002 439.7L421.502 445.8Z",
  fill: "#AF6AF4",
  fillOpacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  d: "M421.502 460.8H414.602L411.102 454.8L414.602 448.8H421.502L425.002 454.8L421.502 460.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M421.502 475.9H414.602L411.102 469.9L414.602 463.9H421.502L425.002 469.9L421.502 475.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M419.098 486.8H416.998L415.898 485L416.998 483.1H419.098L420.198 485L419.098 486.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1503.5 858H1499.2L1497 854.2L1499.2 850.4H1503.5L1505.7 854.2L1503.5 858Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1504.8 845.1H1497.9L1494.4 839.1L1497.9 833.1H1504.8L1508.3 839.1L1504.8 845.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1504.8 830.1H1497.9L1494.4 824L1497.9 818H1504.8L1508.3 824L1504.8 830.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1504.8 815H1497.9L1494.4 809L1497.9 803H1504.8L1508.3 809L1504.8 815Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1504.8 799.9H1497.9L1494.4 793.9L1497.9 787.9H1504.8L1508.3 793.9L1504.8 799.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1504.8 784.9H1497.9L1494.4 778.8L1497.9 772.8H1504.8L1508.3 778.8L1504.8 784.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1504.8 769.8H1497.9L1494.4 763.8L1497.9 757.7H1504.8L1508.3 763.8L1504.8 769.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1504.8 754.7H1497.9L1494.4 748.7L1497.9 742.7H1504.8L1508.3 748.7L1504.8 754.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1504.8 739.7H1497.9L1494.4 733.6L1497.9 727.6H1504.8L1508.3 733.6L1504.8 739.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1502.2 674.8H1500.5L1499.7 673.3L1500.5 671.9H1502.2L1503 673.3L1502.2 674.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1504.8 664.3H1497.9L1494.4 658.3L1497.9 652.2H1504.8L1508.3 658.3L1504.8 664.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1504.4 467.7H1498.3L1495.2 462.4L1498.3 457H1504.4L1507.5 462.4L1504.4 467.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1503.4 450.8H1499.3L1497.3 447.3L1499.3 443.8H1503.4L1505.4 447.3L1503.4 450.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1502.6 434.3H1500.2L1499 432.2L1500.2 430.1H1502.6L1503.8 432.2L1502.6 434.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1504.5 422.6H1498.2L1495.1 417.1L1498.2 411.7H1504.5L1507.6 417.1L1504.5 422.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1502.8 389.5H1499.9L1498.5 387L1499.9 384.5H1502.8L1504.2 387L1502.8 389.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1504.7 332.5H1498L1494.6 326.7L1498 320.9H1504.7L1508.1 326.7L1504.7 332.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1504.8 317.7H1497.9L1494.4 311.6L1497.9 305.6H1504.8L1508.3 311.6L1504.8 317.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1504.8 302.6H1497.9L1494.4 296.6L1497.9 290.5H1504.8L1508.3 296.6L1504.8 302.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1504.8 287.5H1497.9L1494.4 281.5L1497.9 275.5H1504.8L1508.3 281.5L1504.8 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1504.8 272.5H1497.9L1494.4 266.4L1497.9 260.4H1504.8L1508.3 266.4L1504.8 272.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1504.8 257.4H1497.9L1494.4 251.4L1497.9 245.3H1504.8L1508.3 251.4L1504.8 257.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M408.502 272.5H401.502L398.102 266.4L401.502 260.4H408.502L412.002 266.4L408.502 272.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M408.502 287.5H401.502L398.102 281.5L401.502 275.5H408.502L412.002 281.5L408.502 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M408.502 302.6H401.502L398.102 296.6L401.502 290.5H408.502L412.002 296.6L408.502 302.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M408.502 317.7H401.502L398.102 311.6L401.502 305.6H408.502L412.002 311.6L408.502 317.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M408.502 332.7H401.502L398.102 326.7L401.502 320.7H408.502L412.002 326.7L408.502 332.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M408.502 347.8H401.502L398.102 341.8L401.502 335.8H408.502L412.002 341.8L408.502 347.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M408.298 362.6H401.698L398.398 356.9L401.698 351.1H408.298L411.598 356.9L408.298 362.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M407.598 376.3H402.498L399.898 371.9L402.498 367.5H407.598L410.098 371.9L407.598 376.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M406.3 389.2H403.8L402.5 387L403.8 384.8H406.3L407.5 387L406.3 389.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M405.8 403.4H404.3L403.5 402.1L404.3 400.8H405.8L406.5 402.1L405.8 403.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M406.099 419.1H403.899L402.699 417.1L403.899 415.2H406.099L407.299 417.1L406.099 419.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M406.3 434.4H403.8L402.5 432.2L403.8 430H406.3L407.5 432.2L406.3 434.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M407.5 451.7H402.5L400 447.3L402.5 442.9H407.5L410.1 447.3L407.5 451.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M406.3 464.5H403.8L402.5 462.4L403.8 460.2H406.3L407.5 462.4L406.3 464.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1517.9 867.7H1510.9L1507.5 861.7L1510.9 855.7H1517.9L1521.3 861.7L1517.9 867.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1516.1 849.6H1512.7L1511 846.7L1512.7 843.7H1516.1L1517.8 846.7L1516.1 849.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1517.9 837.6H1510.9L1507.5 831.6L1510.9 825.6H1517.9L1521.4 831.6L1517.9 837.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1517.9 822.5H1510.9L1507.5 816.5L1510.9 810.5H1517.9L1521.4 816.5L1517.9 822.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1517.9 807.5H1510.9L1507.5 801.4L1510.9 795.4H1517.9L1521.4 801.4L1517.9 807.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1517.9 792.4H1510.9L1507.5 786.4L1510.9 780.3H1517.9L1521.4 786.4L1517.9 792.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1517.9 777.3H1510.9L1507.5 771.3L1510.9 765.3H1517.9L1521.4 771.3L1517.9 777.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1517.9 762.3H1510.9L1507.5 756.2L1510.9 750.2H1517.9L1521.4 756.2L1517.9 762.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1517.9 747.2H1510.9L1507.5 741.2L1510.9 735.1H1517.9L1521.4 741.2L1517.9 747.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1515.8 728.5H1513L1511.7 726.1L1513 723.7H1515.8L1517.2 726.1L1515.8 728.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1517.8 686.7H1511L1507.7 680.9L1511 675H1517.8L1521.2 680.9L1517.8 686.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1517.9 671.8H1510.9L1507.5 665.8L1510.9 659.8H1517.9L1521.4 665.8L1517.9 671.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1515.2 652.2H1513.6L1512.7 650.7L1513.6 649.3H1515.2L1516.1 650.7L1515.2 652.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1516.6 338.1H1512.2L1510 334.2L1512.2 330.4H1516.6L1518.8 334.2L1516.6 338.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1517.9 325.2H1510.9L1507.5 319.2L1510.9 313.1H1517.9L1521.4 319.2L1517.9 325.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1517.9 310.1H1510.9L1507.5 304.1L1510.9 298.1H1517.9L1521.4 304.1L1517.9 310.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1517.9 295.1H1510.9L1507.5 289L1510.9 283H1517.9L1521.4 289L1517.9 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1517.9 280H1510.9L1507.5 274L1510.9 267.9H1517.9L1521.4 274L1517.9 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1517.8 264.8H1511L1507.6 258.9L1511 253H1517.8L1521.2 258.9L1517.8 264.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M394.5 263.2H389.5L387 258.9L389.5 254.6H394.5L397 258.9L394.5 263.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M395.4 280H388.5L385 274L388.5 267.9H395.4L398.9 274L395.4 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M395.4 295.1H388.5L385 289L388.5 283H395.4L398.9 289L395.4 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M395.4 310.1H388.5L385 304.1L388.5 298.1H395.4L398.9 304.1L395.4 310.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M395.4 325.2H388.5L385 319.2L388.5 313.1H395.4L398.9 319.2L395.4 325.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M395.4 340.3H388.5L385 334.2L388.5 328.2H395.4L398.9 334.2L395.4 340.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M394.7 354H389.2L386.5 349.3L389.2 344.6H394.7L397.4 349.3L394.7 354Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1528.3 855.6H1526.7L1525.9 854.2L1526.7 852.8H1528.3L1529.1 854.2L1528.3 855.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1530.8 844.8H1524.2L1520.9 839.1L1524.2 833.4H1530.8L1534 839.1L1530.8 844.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1530.9 830.1H1524L1520.5 824L1524 818H1530.9L1534.4 824L1530.9 830.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1530.9 815H1524L1520.5 809L1524 803H1530.9L1534.4 809L1530.9 815Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1530.9 799.9H1524L1520.5 793.9L1524 787.9H1530.9L1534.4 793.9L1530.9 799.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1530.9 784.9H1524L1520.5 778.8L1524 772.8H1530.9L1534.4 778.8L1530.9 784.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1530.9 769.8H1524L1520.5 763.8L1524 757.7H1530.9L1534.4 763.8L1530.9 769.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1530.9 754.7H1524L1520.5 748.7L1524 742.7H1530.9L1534.4 748.7L1530.9 754.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1530.9 739.7H1524L1520.5 733.6L1524 727.6H1530.9L1534.4 733.6L1530.9 739.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1530.6 723.9H1524.4L1521.2 718.6L1524.4 713.2H1530.6L1533.7 718.6L1530.6 723.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1528.6 705.4H1526.3L1525.2 703.5L1526.3 701.5H1528.6L1529.7 703.5L1528.6 705.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1530.7 694H1524.3L1521 688.4L1524.3 682.9H1530.7L1533.9 688.4L1530.7 694Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1530.9 679.4H1524L1520.5 673.3L1524 667.3H1530.9L1534.4 673.3L1530.9 679.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1530.9 317.6H1524L1520.5 311.6L1524 305.6H1530.9L1534.4 311.6L1530.9 317.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1530.9 302.6H1524L1520.5 296.6L1524 290.5H1530.9L1534.4 296.6L1530.9 302.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1530.9 287.5H1524L1520.5 281.5L1524 275.5H1530.9L1534.4 281.5L1530.9 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1530.9 272.5H1524L1520.5 266.4L1524 260.4H1530.9L1534.4 266.4L1530.9 272.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M379.602 252.5H378.302L377.602 251.4L378.302 250.2H379.602L380.202 251.4L379.602 252.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M382.4 272.5H375.4L372 266.4L375.4 260.4H382.4L385.9 266.4L382.4 272.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M382.4 287.5H375.4L372 281.5L375.4 275.5H382.4L385.9 281.5L382.4 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M382.4 302.6H375.4L372 296.6L375.4 290.5H382.4L385.9 296.6L382.4 302.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M382.4 317.7H375.4L372 311.6L375.4 305.6H382.4L385.9 311.6L382.4 317.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M382.4 332.7H375.4L372 326.7L375.4 320.7H382.4L385.9 326.7L382.4 332.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M381.398 346.1H376.398L373.898 341.8L376.398 337.5H381.398L383.898 341.8L381.398 346.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1542.6 835.2H1538.4L1536.3 831.6L1538.4 828H1542.6L1544.7 831.6L1542.6 835.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1544 822.5H1537L1533.6 816.5L1537 810.5H1544L1547.5 816.5L1544 822.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1544 807.5H1537L1533.6 801.4L1537 795.4H1544L1547.5 801.4L1544 807.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1544 792.4H1537L1533.6 786.4L1537 780.3H1544L1547.5 786.4L1544 792.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1544 777.3H1537L1533.6 771.3L1537 765.3H1544L1547.5 771.3L1544 777.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1544 762.3H1537L1533.6 756.2L1537 750.2H1544L1547.5 756.2L1544 762.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1543.5 746.4H1537.5L1534.5 741.2L1537.5 735.9H1543.5L1546.5 741.2L1543.5 746.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1543.9 686.7H1537.1L1533.7 680.9L1537.1 675H1543.9L1547.3 680.9L1543.9 686.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1541.2 380.6H1539.9L1539.2 379.5L1539.9 378.3H1541.2L1541.8 379.5L1541.2 380.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1543.7 370H1537.3L1534 364.4L1537.3 358.8H1543.7L1547 364.4L1543.7 370Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1544 355.3H1537L1533.6 349.3L1537 343.3H1544L1547.5 349.3L1544 355.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1543.9 340.1H1537.1L1533.8 334.2L1537.1 328.4H1543.9L1547.3 334.2L1543.9 340.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1542.2 322.1H1538.8L1537.2 319.2L1538.8 316.3H1542.2L1543.9 319.2L1542.2 322.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1544 310.1H1537L1533.6 304.1L1537 298.1H1544L1547.5 304.1L1544 310.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1544 295.1H1537L1533.6 289L1537 283H1544L1547.5 289L1544 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1544 280H1537L1533.6 274L1537 267.9H1544L1547.5 274L1544 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1543.9 264.7H1537.2L1533.8 258.9L1537.2 253.1H1543.9L1547.2 258.9L1543.9 264.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M369.298 264.9H362.398L358.898 258.9L362.398 252.9H369.298L372.798 258.9L369.298 264.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M369.298 280H362.398L358.898 274L362.398 267.9H369.298L372.798 274L369.298 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M369.298 295.1H362.398L358.898 289L362.398 283H369.298L372.798 289L369.298 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M369.298 310.1H362.398L358.898 304.1L362.398 298.1H369.298L372.798 304.1L369.298 310.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M369.298 325.2H362.398L358.898 319.2L362.398 313.1H369.298L372.798 319.2L369.298 325.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M366.802 335.8H365.002L364.102 334.2L365.002 332.7H366.802L367.702 334.2L366.802 335.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1556.2 813.6H1550.9L1548.3 809L1550.9 804.4H1556.2L1558.9 809L1556.2 813.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1557 799.9H1550.1L1546.6 793.9L1550.1 787.9H1557L1560.5 793.9L1557 799.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1557 784.7H1550.2L1546.7 778.8L1550.2 772.9H1557L1560.4 778.8L1557 784.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1555.9 767.7H1551.3L1549 763.8L1551.3 759.8H1555.9L1558.2 763.8L1555.9 767.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1554.9 690.7H1552.2L1550.9 688.4L1552.2 686.1H1554.9L1556.2 688.4L1554.9 690.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1556.9 362.6H1550.3L1547 356.9L1550.3 351.1H1556.9L1560.2 356.9L1556.9 362.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1557 347.7H1550.2L1546.8 341.8L1550.2 335.9H1557L1560.4 341.8L1557 347.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1557 332.7H1550.1L1546.7 326.7L1550.1 320.8H1557L1560.4 326.7L1557 332.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1557 317.7H1550.1L1546.6 311.6L1550.1 305.6H1557L1560.5 311.6L1557 317.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1557 302.6H1550.1L1546.6 296.6L1550.1 290.5H1557L1560.5 296.6L1557 302.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1557 287.5H1550.1L1546.6 281.5L1550.1 275.5H1557L1560.5 281.5L1557 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1557 272.5H1550.1L1546.6 266.4L1550.1 260.4H1557L1560.5 266.4L1557 272.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1555.1 254H1552L1550.5 251.4L1552 248.7H1555.1L1556.6 251.4L1555.1 254Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M354.599 254.5H350.999L349.199 251.4L350.999 248.2H354.599L356.499 251.4L354.599 254.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M356.301 272.5H349.301L345.801 266.4L349.301 260.4H356.301L359.801 266.4L356.301 272.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M356.301 287.5H349.301L345.801 281.5L349.301 275.5H356.301L359.801 281.5L356.301 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M356.301 302.6H349.301L345.801 296.6L349.301 290.5H356.301L359.801 296.6L356.301 302.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M356.301 317.7H349.301L345.801 311.6L349.301 305.6H356.301L359.801 311.6L356.301 317.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M356.301 332.7H349.301L345.801 326.7L349.301 320.7H356.301L359.801 326.7L356.301 332.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1567.9 758.5H1565.3L1564.1 756.2L1565.3 754H1567.9L1569.2 756.2L1567.9 758.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1567.5 742.7H1565.7L1564.8 741.2L1565.7 739.6H1567.5L1568.4 741.2L1567.5 742.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1570.1 325.2H1563.2L1559.7 319.2L1563.2 313.2H1570.1L1573.6 319.2L1570.1 325.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1570.1 310.1H1563.1L1559.7 304.1L1563.1 298.1H1570.1L1573.6 304.1L1570.1 310.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1570.1 295.1H1563.1L1559.7 289L1563.1 283H1570.1L1573.6 289L1570.1 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1570.1 280H1563.1L1559.7 274L1563.1 267.9H1570.1L1573.6 274L1570.1 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1570.1 264.9H1563.2L1559.7 258.9L1563.2 252.9H1570.1L1573.6 258.9L1570.1 264.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M340.602 245.2H339.002L338.102 243.8L339.002 242.4H340.602L341.402 243.8L340.602 245.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M343.201 264.9H336.301L332.801 258.9L336.301 252.9H343.201L346.701 258.9L343.201 264.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M343.201 280H336.301L332.801 274L336.301 267.9H343.201L346.701 274L343.201 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M343.201 295.1H336.301L332.801 289L336.301 283H343.201L346.701 289L343.201 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M343.201 310.1H336.301L332.801 304.1L336.301 298.1H343.201L346.701 304.1L343.201 310.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M343.201 325.2H336.301L332.801 319.2L336.301 313.1H343.201L346.701 319.2L343.201 325.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M343.201 340.3H336.301L332.801 334.2L336.301 328.2H343.201L346.701 334.2L343.201 340.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M343.201 355.3H336.301L332.801 349.3L336.301 343.3H343.201L346.701 349.3L343.201 355.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1580.7 328.5H1578.7L1577.7 326.7L1578.7 325H1580.7L1581.7 326.7L1580.7 328.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1583.2 317.7H1576.2L1572.7 311.6L1576.2 305.6H1583.2L1586.6 311.6L1583.2 317.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1583.2 302.6H1576.2L1572.7 296.6L1576.2 290.5H1583.2L1586.6 296.6L1583.2 302.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1583.2 287.5H1576.2L1572.7 281.5L1576.2 275.5H1583.2L1586.6 281.5L1583.2 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1583.2 272.5H1576.2L1572.7 266.4L1576.2 260.4H1583.2L1586.6 266.4L1583.2 272.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M329.701 256.5H323.701L320.801 251.4L323.701 246.2H329.701L332.601 251.4L329.701 256.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M330.199 272.5H323.199L319.699 266.4L323.199 260.4H330.199L333.699 266.4L330.199 272.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M330.199 287.5H323.199L319.699 281.5L323.199 275.5H330.199L333.699 281.5L330.199 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M330.199 302.6H323.199L319.699 296.6L323.199 290.5H330.199L333.699 296.6L330.199 302.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M330.199 317.7H323.199L319.699 311.6L323.199 305.6H330.199L333.699 311.6L330.199 317.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M330.199 332.7H323.199L319.699 326.7L323.199 320.7H330.199L333.699 326.7L330.199 332.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M330.101 347.7H323.301L319.801 341.8L323.301 335.8H330.101L333.601 341.8L330.101 347.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M329.901 362.4H323.501L320.301 356.9L323.501 351.3H329.901L333.101 356.9L329.901 362.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1593.3 893H1592.1L1591.5 891.9L1592.1 890.8H1593.3L1594 891.9L1593.3 893Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1596.2 310.1H1589.2L1585.8 304.1L1589.2 298.1H1596.2L1599.7 304.1L1596.2 310.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1596.2 295.1H1589.2L1585.8 289L1589.2 283H1596.2L1599.7 289L1596.2 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1596.2 280H1589.2L1585.8 274L1589.2 267.9H1596.2L1599.7 274L1596.2 280Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1593.5 260.3H1591.9L1591.1 258.9L1591.9 257.5H1593.5L1594.3 258.9L1593.5 260.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M317.099 264.9H310.199L306.699 258.9L310.199 252.9H317.099L320.599 258.9L317.099 264.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M316.7 279.3H310.6L307.5 274L310.6 268.7H316.7L319.8 274L316.7 279.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M317.099 295.1H310.199L306.699 289L310.199 283H317.099L320.599 289L317.099 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M317.099 310.1H310.199L306.699 304.1L310.199 298.1H317.099L320.599 304.1L317.099 310.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M317.099 325.2H310.199L306.699 319.2L310.199 313.1H317.099L320.599 319.2L317.099 325.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M317.099 340.3H310.199L306.699 334.2L310.199 328.2H317.099L320.599 334.2L317.099 340.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M317.099 355.3H310.199L306.699 349.3L310.199 343.3H317.099L320.599 349.3L317.099 355.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1609.1 890.1H1602.4L1599.1 884.3L1602.4 878.5H1609.1L1612.5 884.3L1609.1 890.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1606.9 871.2H1604.6L1603.5 869.3L1604.6 867.3H1606.9L1608.1 869.3L1606.9 871.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1606.8 313.3H1604.8L1603.8 311.6L1604.8 309.9H1606.8L1607.7 311.6L1606.8 313.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1607.9 300.2H1603.7L1601.5 296.6L1603.7 292.9H1607.9L1610 296.6L1607.9 300.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1609.3 287.5H1602.3L1598.8 281.5L1602.3 275.5H1609.3L1612.7 281.5L1609.3 287.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1608.6 271.3H1602.9L1600.1 266.4L1602.9 261.5H1608.6L1611.4 266.4L1608.6 271.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M301.198 252.4H299.998L299.398 251.4L299.998 250.3H301.198L301.798 251.4L301.198 252.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M302.198 269.2H298.998L297.398 266.4L298.998 263.6H302.198L303.898 266.4L302.198 269.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M304.001 287.4H297.201L293.801 281.5L297.201 275.6H304.001L307.501 281.5L304.001 287.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M303.302 301.3H297.902L295.102 296.6L297.902 291.8H303.302L306.102 296.6L303.302 301.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M304.102 317.7H297.102L293.602 311.6L297.102 305.6H304.102L307.602 311.6L304.102 317.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M304.102 332.7H297.102L293.602 326.7L297.102 320.7H304.102L307.602 326.7L304.102 332.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M304.102 347.8H297.102L293.602 341.8L297.102 335.8H304.102L307.602 341.8L304.102 347.8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M304.099 362.9H297.099L293.699 356.9L297.099 350.8H304.099L307.499 356.9L304.099 362.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1620.9 880.4H1616.8L1614.7 876.8L1616.8 873.2H1620.9L1622.9 876.8L1620.9 880.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1622 867.3H1615.6L1612.4 861.7L1615.6 856.2H1622L1625.2 861.7L1622 867.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1621.2 293.2H1616.4L1614 289L1616.4 284.9H1621.2L1623.7 289L1621.2 293.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1621.1 277.9H1616.6L1614.3 274L1616.6 270.1H1621.1L1623.3 274L1621.1 277.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M288.701 275.9H286.401L285.301 274L286.401 272H288.701L289.801 274L288.701 275.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M291.002 295.1H284.102L280.602 289L284.102 283H291.002L294.502 289L291.002 295.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M288.098 305.1H286.998L286.398 304.1L286.998 303.1H288.098L288.698 304.1L288.098 305.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M291.002 325.2H284.102L280.602 319.2L284.102 313.1H291.002L294.502 319.2L291.002 325.2Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M291.002 340.3H284.102L280.602 334.2L284.102 328.2H291.002L294.502 334.2L291.002 340.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M289.098 352H285.998L284.398 349.3L285.998 346.6H289.098L290.698 349.3L289.098 352Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M289.499 367.7H285.599L283.699 364.4L285.599 361.1H289.499L291.399 364.4L289.499 367.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M290.3 384.3H284.8L282 379.5L284.8 374.7H290.3L293.1 379.5L290.3 384.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1632.6 870.5H1631.2L1630.5 869.3L1631.2 868.1H1632.6L1633.3 869.3L1632.6 870.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1634 857.9H1629.7L1627.6 854.2L1629.7 850.5H1634L1636.2 854.2L1634 857.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1633 841.1H1630.7L1629.6 839.1L1630.7 837.2H1633L1634.1 839.1L1633 841.1Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1633.8 299.9H1630L1628 296.6L1630 293.2H1633.8L1635.7 296.6L1633.8 299.9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1633.9 285H1629.9L1627.8 281.5L1629.9 278H1633.9L1635.9 281.5L1633.9 285Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M276.702 285.3H272.302L270.102 281.5L272.302 277.7H276.702L278.902 281.5L276.702 285.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M277.2 316.4H271.8L269 311.6L271.8 306.9H277.2L280 311.6L277.2 316.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M278 332.7H271L267.5 326.7L271 320.7H278L281.5 326.7L278 332.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M277.2 346.5H271.8L269 341.8L271.8 337.1H277.2L280 341.8L277.2 346.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M275.298 373.3H273.698L272.898 371.9L273.698 370.6H275.298L276.098 371.9L275.298 373.3Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M276.601 390.6H272.401L270.301 387L272.401 383.4H276.601L278.701 387L276.601 390.6Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1647.8 851.7H1642L1639.1 846.7L1642 841.6H1647.8L1650.8 846.7L1647.8 851.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1648.4 837.5H1641.5L1638.1 831.6L1641.5 825.6H1648.4L1651.8 831.6L1648.4 837.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1645.6 817.7H1644.2L1643.6 816.5L1644.2 815.3H1645.6L1646.3 816.5L1645.6 817.7Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M262.2 320.4H260.7L260 319.2L260.7 317.9H262.2L262.9 319.2L262.2 320.4Z",
  fill: "#EBECF7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M262.2 380.7H260.7L260 379.5L260.7 378.2H262.2L262.9 379.5L262.2 380.7Z",
  fill: "#EBECF7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M262.102 395.7H260.802L260.102 394.5L260.802 393.4H262.102L262.802 394.5L262.102 395.7Z",
  fill: "#EBECF7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1659 825.8H1657L1656 824L1657 822.3H1659L1660 824L1659 825.8Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_dddddddd_10458_6632)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 459,
  y: 436,
  width: 166.293,
  height: 41.5733,
  rx: 3.7794,
  fill: "white"
})), /*#__PURE__*/React.createElement("path", {
  d: "M484.675 485.604C484.199 486.485 482.936 486.485 482.459 485.604L476.391 474.393C475.937 473.554 476.544 472.534 477.499 472.534L489.635 472.534C490.59 472.534 491.198 473.554 490.743 474.393L484.675 485.604Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M476.352 455.506C476.128 455.095 475.82 454.783 475.428 454.568C475.036 454.353 474.579 454.246 474.056 454.246C473.477 454.246 472.964 454.377 472.516 454.638C472.068 454.899 471.718 455.273 471.466 455.758C471.214 456.243 471.088 456.803 471.088 457.438C471.088 458.091 471.214 458.661 471.466 459.146C471.727 459.631 472.087 460.005 472.544 460.266C473.001 460.527 473.533 460.658 474.14 460.658C474.887 460.658 475.498 460.462 475.974 460.07C476.45 459.669 476.763 459.113 476.912 458.404H473.552V456.906H478.844V458.614C478.713 459.295 478.433 459.925 478.004 460.504C477.575 461.083 477.019 461.549 476.338 461.904C475.666 462.249 474.91 462.422 474.07 462.422C473.127 462.422 472.273 462.212 471.508 461.792C470.752 461.363 470.155 460.77 469.716 460.014C469.287 459.258 469.072 458.399 469.072 457.438C469.072 456.477 469.287 455.618 469.716 454.862C470.155 454.097 470.752 453.504 471.508 453.084C472.273 452.655 473.123 452.44 474.056 452.44C475.157 452.44 476.114 452.711 476.926 453.252C477.738 453.784 478.298 454.535 478.606 455.506H476.352ZM487.616 454.582V462.338H485.642V461.358C485.39 461.694 485.059 461.96 484.648 462.156C484.247 462.343 483.808 462.436 483.332 462.436C482.725 462.436 482.189 462.31 481.722 462.058C481.255 461.797 480.887 461.419 480.616 460.924C480.355 460.42 480.224 459.823 480.224 459.132V454.582H482.184V458.852C482.184 459.468 482.338 459.944 482.646 460.28C482.954 460.607 483.374 460.77 483.906 460.77C484.447 460.77 484.872 460.607 485.18 460.28C485.488 459.944 485.642 459.468 485.642 458.852V454.582H487.616ZM489.046 458.432C489.046 457.648 489.2 456.953 489.508 456.346C489.825 455.739 490.25 455.273 490.782 454.946C491.323 454.619 491.925 454.456 492.588 454.456C493.167 454.456 493.671 454.573 494.1 454.806C494.539 455.039 494.889 455.333 495.15 455.688V454.582H497.124V462.338H495.15V461.204C494.898 461.568 494.548 461.871 494.1 462.114C493.661 462.347 493.153 462.464 492.574 462.464C491.921 462.464 491.323 462.296 490.782 461.96C490.25 461.624 489.825 461.153 489.508 460.546C489.2 459.93 489.046 459.225 489.046 458.432ZM495.15 458.46C495.15 457.984 495.057 457.578 494.87 457.242C494.683 456.897 494.431 456.635 494.114 456.458C493.797 456.271 493.456 456.178 493.092 456.178C492.728 456.178 492.392 456.267 492.084 456.444C491.776 456.621 491.524 456.883 491.328 457.228C491.141 457.564 491.048 457.965 491.048 458.432C491.048 458.899 491.141 459.309 491.328 459.664C491.524 460.009 491.776 460.275 492.084 460.462C492.401 460.649 492.737 460.742 493.092 460.742C493.456 460.742 493.797 460.653 494.114 460.476C494.431 460.289 494.683 460.028 494.87 459.692C495.057 459.347 495.15 458.936 495.15 458.46ZM498.534 458.432C498.534 457.648 498.688 456.953 498.996 456.346C499.314 455.739 499.743 455.273 500.284 454.946C500.826 454.619 501.428 454.456 502.09 454.456C502.594 454.456 503.075 454.568 503.532 454.792C503.99 455.007 504.354 455.296 504.624 455.66V451.978H506.612V462.338H504.624V461.19C504.382 461.573 504.041 461.881 503.602 462.114C503.164 462.347 502.655 462.464 502.076 462.464C501.423 462.464 500.826 462.296 500.284 461.96C499.743 461.624 499.314 461.153 498.996 460.546C498.688 459.93 498.534 459.225 498.534 458.432ZM504.638 458.46C504.638 457.984 504.545 457.578 504.358 457.242C504.172 456.897 503.92 456.635 503.602 456.458C503.285 456.271 502.944 456.178 502.58 456.178C502.216 456.178 501.88 456.267 501.572 456.444C501.264 456.621 501.012 456.883 500.816 457.228C500.63 457.564 500.536 457.965 500.536 458.432C500.536 458.899 500.63 459.309 500.816 459.664C501.012 460.009 501.264 460.275 501.572 460.462C501.89 460.649 502.226 460.742 502.58 460.742C502.944 460.742 503.285 460.653 503.602 460.476C503.92 460.289 504.172 460.028 504.358 459.692C504.545 459.347 504.638 458.936 504.638 458.46ZM508.023 458.432C508.023 457.648 508.177 456.953 508.485 456.346C508.802 455.739 509.227 455.273 509.759 454.946C510.3 454.619 510.902 454.456 511.565 454.456C512.143 454.456 512.647 454.573 513.077 454.806C513.515 455.039 513.865 455.333 514.127 455.688V454.582H516.101V462.338H514.127V461.204C513.875 461.568 513.525 461.871 513.077 462.114C512.638 462.347 512.129 462.464 511.551 462.464C510.897 462.464 510.3 462.296 509.759 461.96C509.227 461.624 508.802 461.153 508.485 460.546C508.177 459.93 508.023 459.225 508.023 458.432ZM514.127 458.46C514.127 457.984 514.033 457.578 513.847 457.242C513.66 456.897 513.408 456.635 513.091 456.458C512.773 456.271 512.433 456.178 512.069 456.178C511.705 456.178 511.369 456.267 511.061 456.444C510.753 456.621 510.501 456.883 510.305 457.228C510.118 457.564 510.025 457.965 510.025 458.432C510.025 458.899 510.118 459.309 510.305 459.664C510.501 460.009 510.753 460.275 511.061 460.462C511.378 460.649 511.714 460.742 512.069 460.742C512.433 460.742 512.773 460.653 513.091 460.476C513.408 460.289 513.66 460.028 513.847 459.692C514.033 459.347 514.127 458.936 514.127 458.46ZM519.975 451.978V462.338H518.015V451.978H519.975ZM521.407 458.432C521.407 457.648 521.561 456.953 521.869 456.346C522.187 455.739 522.611 455.273 523.143 454.946C523.685 454.619 524.287 454.456 524.949 454.456C525.528 454.456 526.032 454.573 526.461 454.806C526.9 455.039 527.25 455.333 527.511 455.688V454.582H529.485V462.338H527.511V461.204C527.259 461.568 526.909 461.871 526.461 462.114C526.023 462.347 525.514 462.464 524.935 462.464C524.282 462.464 523.685 462.296 523.143 461.96C522.611 461.624 522.187 461.153 521.869 460.546C521.561 459.93 521.407 459.225 521.407 458.432ZM527.511 458.46C527.511 457.984 527.418 457.578 527.231 457.242C527.045 456.897 526.793 456.635 526.475 456.458C526.158 456.271 525.817 456.178 525.453 456.178C525.089 456.178 524.753 456.267 524.445 456.444C524.137 456.621 523.885 456.883 523.689 457.228C523.503 457.564 523.409 457.965 523.409 458.432C523.409 458.899 523.503 459.309 523.689 459.664C523.885 460.009 524.137 460.275 524.445 460.462C524.763 460.649 525.099 460.742 525.453 460.742C525.817 460.742 526.158 460.653 526.475 460.476C526.793 460.289 527.045 460.028 527.231 459.692C527.418 459.347 527.511 458.936 527.511 458.46ZM532.394 453.658C532.039 453.658 531.745 453.551 531.512 453.336C531.288 453.112 531.176 452.837 531.176 452.51C531.176 452.183 531.288 451.913 531.512 451.698C531.745 451.474 532.039 451.362 532.394 451.362C532.739 451.362 533.024 451.474 533.248 451.698C533.472 451.913 533.584 452.183 533.584 452.51C533.584 452.837 533.472 453.112 533.248 453.336C533.024 453.551 532.739 453.658 532.394 453.658ZM533.36 463.612C533.36 464.471 533.145 465.087 532.716 465.46C532.296 465.843 531.689 466.034 530.896 466.034H530.028V464.368H530.588C530.886 464.368 531.096 464.307 531.218 464.186C531.339 464.074 531.4 463.887 531.4 463.626V454.582H533.36V463.612ZM534.792 458.432C534.792 457.648 534.946 456.953 535.254 456.346C535.571 455.739 535.996 455.273 536.528 454.946C537.069 454.619 537.671 454.456 538.334 454.456C538.913 454.456 539.417 454.573 539.846 454.806C540.285 455.039 540.635 455.333 540.896 455.688V454.582H542.87V462.338H540.896V461.204C540.644 461.568 540.294 461.871 539.846 462.114C539.407 462.347 538.899 462.464 538.32 462.464C537.667 462.464 537.069 462.296 536.528 461.96C535.996 461.624 535.571 461.153 535.254 460.546C534.946 459.93 534.792 459.225 534.792 458.432ZM540.896 458.46C540.896 457.984 540.803 457.578 540.616 457.242C540.429 456.897 540.177 456.635 539.86 456.458C539.543 456.271 539.202 456.178 538.838 456.178C538.474 456.178 538.138 456.267 537.83 456.444C537.522 456.621 537.27 456.883 537.074 457.228C536.887 457.564 536.794 457.965 536.794 458.432C536.794 458.899 536.887 459.309 537.074 459.664C537.27 460.009 537.522 460.275 537.83 460.462C538.147 460.649 538.483 460.742 538.838 460.742C539.202 460.742 539.543 460.653 539.86 460.476C540.177 460.289 540.429 460.028 540.616 459.692C540.803 459.347 540.896 458.936 540.896 458.46ZM546.744 455.786C546.996 455.375 547.323 455.053 547.724 454.82C548.135 454.587 548.602 454.47 549.124 454.47V456.528H548.606C547.99 456.528 547.524 456.673 547.206 456.962C546.898 457.251 546.744 457.755 546.744 458.474V462.338H544.784V454.582H546.744V455.786ZM549.941 458.432C549.941 457.648 550.095 456.953 550.403 456.346C550.72 455.739 551.145 455.273 551.677 454.946C552.218 454.619 552.82 454.456 553.483 454.456C554.061 454.456 554.565 454.573 554.995 454.806C555.433 455.039 555.783 455.333 556.045 455.688V454.582H558.019V462.338H556.045V461.204C555.793 461.568 555.443 461.871 554.995 462.114C554.556 462.347 554.047 462.464 553.469 462.464C552.815 462.464 552.218 462.296 551.677 461.96C551.145 461.624 550.72 461.153 550.403 460.546C550.095 459.93 549.941 459.225 549.941 458.432ZM556.045 458.46C556.045 457.984 555.951 457.578 555.765 457.242C555.578 456.897 555.326 456.635 555.009 456.458C554.691 456.271 554.351 456.178 553.987 456.178C553.623 456.178 553.287 456.267 552.979 456.444C552.671 456.621 552.419 456.883 552.223 457.228C552.036 457.564 551.943 457.965 551.943 458.432C551.943 458.899 552.036 459.309 552.223 459.664C552.419 460.009 552.671 460.275 552.979 460.462C553.296 460.649 553.632 460.742 553.987 460.742C554.351 460.742 554.691 460.653 555.009 460.476C555.326 460.289 555.578 460.028 555.765 459.692C555.951 459.347 556.045 458.936 556.045 458.46ZM562.075 460.28L560.437 464.214H559.177L560.087 460.28H562.075ZM577.477 452.566V462.338H575.517V455.982L572.899 462.338H571.415L568.783 455.982V462.338H566.823V452.566H569.049L572.157 459.832L575.265 452.566H577.477ZM586.625 458.292C586.625 458.572 586.607 458.824 586.569 459.048H580.899C580.946 459.608 581.142 460.047 581.487 460.364C581.833 460.681 582.257 460.84 582.761 460.84C583.489 460.84 584.007 460.527 584.315 459.902H586.429C586.205 460.649 585.776 461.265 585.141 461.75C584.507 462.226 583.727 462.464 582.803 462.464C582.057 462.464 581.385 462.301 580.787 461.974C580.199 461.638 579.737 461.167 579.401 460.56C579.075 459.953 578.911 459.253 578.911 458.46C578.911 457.657 579.075 456.953 579.401 456.346C579.728 455.739 580.185 455.273 580.773 454.946C581.361 454.619 582.038 454.456 582.803 454.456C583.541 454.456 584.199 454.615 584.777 454.932C585.365 455.249 585.818 455.702 586.135 456.29C586.462 456.869 586.625 457.536 586.625 458.292ZM584.595 457.732C584.586 457.228 584.404 456.827 584.049 456.528C583.695 456.22 583.261 456.066 582.747 456.066C582.262 456.066 581.851 456.215 581.515 456.514C581.189 456.803 580.988 457.209 580.913 457.732H584.595ZM592.34 462.338L590.744 459.93L589.33 462.338H587.23L589.764 458.446L587.202 454.582H589.414L590.996 456.976L592.424 454.582H594.524L591.976 458.446L594.552 462.338H592.34ZM596.61 453.658C596.265 453.658 595.976 453.551 595.742 453.336C595.518 453.112 595.406 452.837 595.406 452.51C595.406 452.183 595.518 451.913 595.742 451.698C595.976 451.474 596.265 451.362 596.61 451.362C596.956 451.362 597.24 451.474 597.464 451.698C597.698 451.913 597.814 452.183 597.814 452.51C597.814 452.837 597.698 453.112 597.464 453.336C597.24 453.551 596.956 453.658 596.61 453.658ZM597.576 454.582V462.338H595.616V454.582H597.576ZM599.009 458.46C599.009 457.657 599.172 456.957 599.499 456.36C599.826 455.753 600.278 455.287 600.857 454.96C601.436 454.624 602.098 454.456 602.845 454.456C603.806 454.456 604.6 454.699 605.225 455.184C605.86 455.66 606.284 456.332 606.499 457.2H604.385C604.273 456.864 604.082 456.603 603.811 456.416C603.55 456.22 603.223 456.122 602.831 456.122C602.271 456.122 601.828 456.327 601.501 456.738C601.174 457.139 601.011 457.713 601.011 458.46C601.011 459.197 601.174 459.771 601.501 460.182C601.828 460.583 602.271 460.784 602.831 460.784C603.624 460.784 604.142 460.429 604.385 459.72H606.499C606.284 460.56 605.86 461.227 605.225 461.722C604.59 462.217 603.797 462.464 602.845 462.464C602.098 462.464 601.436 462.301 600.857 461.974C600.278 461.638 599.826 461.171 599.499 460.574C599.172 459.967 599.009 459.263 599.009 458.46ZM611.379 462.464C610.632 462.464 609.96 462.301 609.363 461.974C608.765 461.638 608.294 461.167 607.949 460.56C607.613 459.953 607.445 459.253 607.445 458.46C607.445 457.667 607.617 456.967 607.963 456.36C608.317 455.753 608.798 455.287 609.405 454.96C610.011 454.624 610.688 454.456 611.435 454.456C612.181 454.456 612.858 454.624 613.465 454.96C614.071 455.287 614.547 455.753 614.893 456.36C615.247 456.967 615.425 457.667 615.425 458.46C615.425 459.253 615.243 459.953 614.879 460.56C614.524 461.167 614.039 461.638 613.423 461.974C612.816 462.301 612.135 462.464 611.379 462.464ZM611.379 460.756C611.733 460.756 612.065 460.672 612.373 460.504C612.69 460.327 612.942 460.065 613.129 459.72C613.315 459.375 613.409 458.955 613.409 458.46C613.409 457.723 613.213 457.158 612.821 456.766C612.438 456.365 611.967 456.164 611.407 456.164C610.847 456.164 610.375 456.365 609.993 456.766C609.619 457.158 609.433 457.723 609.433 458.46C609.433 459.197 609.615 459.767 609.979 460.168C610.352 460.56 610.819 460.756 611.379 460.756Z",
  fill: "#AF6AF4"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_dddddddd_10458_6632)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 407,
  y: 374,
  width: 132.279,
  height: 41.5733,
  rx: 3.7794,
  fill: "white"
})), /*#__PURE__*/React.createElement("path", {
  d: "M432.507 423.604C432.031 424.485 430.768 424.485 430.291 423.604L424.223 412.393C423.769 411.554 424.376 410.534 425.331 410.534L437.467 410.534C438.422 410.534 439.03 411.554 438.575 412.393L432.507 423.604Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M420.49 395.438C420.49 394.477 420.705 393.618 421.134 392.862C421.573 392.097 422.165 391.504 422.912 391.084C423.668 390.655 424.513 390.44 425.446 390.44C426.538 390.44 427.495 390.72 428.316 391.28C429.137 391.84 429.711 392.615 430.038 393.604H427.784C427.56 393.137 427.243 392.787 426.832 392.554C426.431 392.321 425.964 392.204 425.432 392.204C424.863 392.204 424.354 392.339 423.906 392.61C423.467 392.871 423.122 393.245 422.87 393.73C422.627 394.215 422.506 394.785 422.506 395.438C422.506 396.082 422.627 396.651 422.87 397.146C423.122 397.631 423.467 398.009 423.906 398.28C424.354 398.541 424.863 398.672 425.432 398.672C425.964 398.672 426.431 398.555 426.832 398.322C427.243 398.079 427.56 397.725 427.784 397.258H430.038C429.711 398.257 429.137 399.036 428.316 399.596C427.504 400.147 426.547 400.422 425.446 400.422C424.513 400.422 423.668 400.212 422.912 399.792C422.165 399.363 421.573 398.77 421.134 398.014C420.705 397.258 420.49 396.399 420.49 395.438ZM431.208 396.432C431.208 395.648 431.362 394.953 431.67 394.346C431.987 393.739 432.412 393.273 432.944 392.946C433.485 392.619 434.087 392.456 434.75 392.456C435.329 392.456 435.833 392.573 436.262 392.806C436.701 393.039 437.051 393.333 437.312 393.688V392.582H439.286V400.338H437.312V399.204C437.06 399.568 436.71 399.871 436.262 400.114C435.823 400.347 435.315 400.464 434.736 400.464C434.083 400.464 433.485 400.296 432.944 399.96C432.412 399.624 431.987 399.153 431.67 398.546C431.362 397.93 431.208 397.225 431.208 396.432ZM437.312 396.46C437.312 395.984 437.219 395.578 437.032 395.242C436.845 394.897 436.593 394.635 436.276 394.458C435.959 394.271 435.618 394.178 435.254 394.178C434.89 394.178 434.554 394.267 434.246 394.444C433.938 394.621 433.686 394.883 433.49 395.228C433.303 395.564 433.21 395.965 433.21 396.432C433.21 396.899 433.303 397.309 433.49 397.664C433.686 398.009 433.938 398.275 434.246 398.462C434.563 398.649 434.899 398.742 435.254 398.742C435.618 398.742 435.959 398.653 436.276 398.476C436.593 398.289 436.845 398.028 437.032 397.692C437.219 397.347 437.312 396.936 437.312 396.46ZM443.16 389.978V400.338H441.2V389.978H443.16ZM446.091 391.658C445.746 391.658 445.456 391.551 445.223 391.336C444.999 391.112 444.887 390.837 444.887 390.51C444.887 390.183 444.999 389.913 445.223 389.698C445.456 389.474 445.746 389.362 446.091 389.362C446.436 389.362 446.721 389.474 446.945 389.698C447.178 389.913 447.295 390.183 447.295 390.51C447.295 390.837 447.178 391.112 446.945 391.336C446.721 391.551 446.436 391.658 446.091 391.658ZM447.057 392.582V400.338H445.097V392.582H447.057ZM452.549 394.192H451.191V400.338H449.203V394.192H448.321V392.582H449.203V392.19C449.203 391.238 449.474 390.538 450.015 390.09C450.557 389.642 451.373 389.432 452.465 389.46V391.112C451.989 391.103 451.658 391.182 451.471 391.35C451.285 391.518 451.191 391.821 451.191 392.26V392.582H452.549V394.192ZM457.264 400.464C456.517 400.464 455.845 400.301 455.248 399.974C454.65 399.638 454.179 399.167 453.834 398.56C453.498 397.953 453.33 397.253 453.33 396.46C453.33 395.667 453.502 394.967 453.848 394.36C454.202 393.753 454.683 393.287 455.29 392.96C455.896 392.624 456.573 392.456 457.32 392.456C458.066 392.456 458.743 392.624 459.35 392.96C459.956 393.287 460.432 393.753 460.778 394.36C461.132 394.967 461.31 395.667 461.31 396.46C461.31 397.253 461.128 397.953 460.764 398.56C460.409 399.167 459.924 399.638 459.308 399.974C458.701 400.301 458.02 400.464 457.264 400.464ZM457.264 398.756C457.618 398.756 457.95 398.672 458.258 398.504C458.575 398.327 458.827 398.065 459.014 397.72C459.2 397.375 459.294 396.955 459.294 396.46C459.294 395.723 459.098 395.158 458.706 394.766C458.323 394.365 457.852 394.164 457.292 394.164C456.732 394.164 456.26 394.365 455.878 394.766C455.504 395.158 455.318 395.723 455.318 396.46C455.318 397.197 455.5 397.767 455.864 398.168C456.237 398.56 456.704 398.756 457.264 398.756ZM464.707 393.786C464.959 393.375 465.286 393.053 465.687 392.82C466.098 392.587 466.565 392.47 467.087 392.47V394.528H466.569C465.953 394.528 465.487 394.673 465.169 394.962C464.861 395.251 464.707 395.755 464.707 396.474V400.338H462.747V392.582H464.707V393.786ZM472.705 392.47C473.629 392.47 474.376 392.764 474.945 393.352C475.515 393.931 475.799 394.743 475.799 395.788V400.338H473.839V396.054C473.839 395.438 473.685 394.967 473.377 394.64C473.069 394.304 472.649 394.136 472.117 394.136C471.576 394.136 471.147 394.304 470.829 394.64C470.521 394.967 470.367 395.438 470.367 396.054V400.338H468.407V392.582H470.367V393.548C470.629 393.212 470.96 392.951 471.361 392.764C471.772 392.568 472.22 392.47 472.705 392.47ZM478.657 391.658C478.312 391.658 478.023 391.551 477.789 391.336C477.565 391.112 477.453 390.837 477.453 390.51C477.453 390.183 477.565 389.913 477.789 389.698C478.023 389.474 478.312 389.362 478.657 389.362C479.003 389.362 479.287 389.474 479.511 389.698C479.745 389.913 479.861 390.183 479.861 390.51C479.861 390.837 479.745 391.112 479.511 391.336C479.287 391.551 479.003 391.658 478.657 391.658ZM479.623 392.582V400.338H477.663V392.582H479.623ZM481.056 396.432C481.056 395.648 481.21 394.953 481.518 394.346C481.835 393.739 482.26 393.273 482.792 392.946C483.333 392.619 483.935 392.456 484.598 392.456C485.176 392.456 485.68 392.573 486.11 392.806C486.548 393.039 486.898 393.333 487.16 393.688V392.582H489.134V400.338H487.16V399.204C486.908 399.568 486.558 399.871 486.11 400.114C485.671 400.347 485.162 400.464 484.584 400.464C483.93 400.464 483.333 400.296 482.792 399.96C482.26 399.624 481.835 399.153 481.518 398.546C481.21 397.93 481.056 397.225 481.056 396.432ZM487.16 396.46C487.16 395.984 487.066 395.578 486.88 395.242C486.693 394.897 486.441 394.635 486.124 394.458C485.806 394.271 485.466 394.178 485.102 394.178C484.738 394.178 484.402 394.267 484.094 394.444C483.786 394.621 483.534 394.883 483.338 395.228C483.151 395.564 483.058 395.965 483.058 396.432C483.058 396.899 483.151 397.309 483.338 397.664C483.534 398.009 483.786 398.275 484.094 398.462C484.411 398.649 484.747 398.742 485.102 398.742C485.466 398.742 485.806 398.653 486.124 398.476C486.441 398.289 486.693 398.028 486.88 397.692C487.066 397.347 487.16 396.936 487.16 396.46ZM493.19 398.28L491.552 402.214H490.292L491.202 398.28H493.19ZM499.871 390.566V396.614C499.871 397.277 500.043 397.785 500.389 398.14C500.734 398.485 501.219 398.658 501.845 398.658C502.479 398.658 502.969 398.485 503.315 398.14C503.66 397.785 503.833 397.277 503.833 396.614V390.566H505.807V396.6C505.807 397.431 505.625 398.135 505.261 398.714C504.906 399.283 504.425 399.713 503.819 400.002C503.221 400.291 502.554 400.436 501.817 400.436C501.089 400.436 500.426 400.291 499.829 400.002C499.241 399.713 498.774 399.283 498.429 398.714C498.083 398.135 497.911 397.431 497.911 396.6V390.566H499.871ZM511.074 400.436C510.393 400.436 509.777 400.319 509.226 400.086C508.685 399.853 508.256 399.517 507.938 399.078C507.621 398.639 507.458 398.121 507.448 397.524H509.548C509.576 397.925 509.716 398.243 509.968 398.476C510.23 398.709 510.584 398.826 511.032 398.826C511.49 398.826 511.849 398.719 512.11 398.504C512.372 398.28 512.502 397.991 512.502 397.636C512.502 397.347 512.414 397.109 512.236 396.922C512.059 396.735 511.835 396.591 511.564 396.488C511.303 396.376 510.939 396.255 510.472 396.124C509.838 395.937 509.32 395.755 508.918 395.578C508.526 395.391 508.186 395.116 507.896 394.752C507.616 394.379 507.476 393.884 507.476 393.268C507.476 392.689 507.621 392.185 507.91 391.756C508.2 391.327 508.606 391 509.128 390.776C509.651 390.543 510.248 390.426 510.92 390.426C511.928 390.426 512.745 390.673 513.37 391.168C514.005 391.653 514.355 392.335 514.42 393.212H512.264C512.246 392.876 512.101 392.601 511.83 392.386C511.569 392.162 511.219 392.05 510.78 392.05C510.398 392.05 510.09 392.148 509.856 392.344C509.632 392.54 509.52 392.825 509.52 393.198C509.52 393.459 509.604 393.679 509.772 393.856C509.95 394.024 510.164 394.164 510.416 394.276C510.678 394.379 511.042 394.5 511.508 394.64C512.143 394.827 512.661 395.013 513.062 395.2C513.464 395.387 513.809 395.667 514.098 396.04C514.388 396.413 514.532 396.903 514.532 397.51C514.532 398.033 514.397 398.518 514.126 398.966C513.856 399.414 513.459 399.773 512.936 400.044C512.414 400.305 511.793 400.436 511.074 400.436ZM522.224 398.476H518.332L517.688 400.338H515.63L519.144 390.552H521.426L524.94 400.338H522.868L522.224 398.476ZM521.692 396.908L520.278 392.82L518.864 396.908H521.692Z",
  fill: "#AF6AF4"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_dddddddd_10458_6632)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 1014.84,
  y: 332,
  width: 76.8477,
  height: 41.5733,
  rx: 3.7794,
  fill: "white"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1032.96 381.604C1032.48 382.485 1031.22 382.485 1030.74 381.604L1024.67 370.393C1024.22 369.554 1024.83 368.534 1025.78 368.534L1037.92 368.534C1038.87 368.534 1039.48 369.554 1039.02 370.393L1032.96 381.604Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1038.89 353.326C1039.44 353.429 1039.9 353.704 1040.25 354.152C1040.61 354.6 1040.78 355.113 1040.78 355.692C1040.78 356.215 1040.65 356.677 1040.39 357.078C1040.14 357.47 1039.77 357.778 1039.28 358.002C1038.8 358.226 1038.23 358.338 1037.56 358.338H1033.35V348.566H1037.38C1038.04 348.566 1038.61 348.673 1039.09 348.888C1039.57 349.103 1039.94 349.401 1040.18 349.784C1040.43 350.167 1040.56 350.601 1040.56 351.086C1040.56 351.655 1040.4 352.131 1040.1 352.514C1039.8 352.897 1039.4 353.167 1038.89 353.326ZM1035.31 352.598H1037.1C1037.57 352.598 1037.93 352.495 1038.18 352.29C1038.43 352.075 1038.56 351.772 1038.56 351.38C1038.56 350.988 1038.43 350.685 1038.18 350.47C1037.93 350.255 1037.57 350.148 1037.1 350.148H1035.31V352.598ZM1037.28 356.742C1037.76 356.742 1038.13 356.63 1038.39 356.406C1038.66 356.182 1038.79 355.865 1038.79 355.454C1038.79 355.034 1038.65 354.707 1038.37 354.474C1038.09 354.231 1037.72 354.11 1037.24 354.11H1035.31V356.742H1037.28ZM1049.55 354.292C1049.55 354.572 1049.54 354.824 1049.5 355.048H1043.83C1043.88 355.608 1044.07 356.047 1044.42 356.364C1044.76 356.681 1045.19 356.84 1045.69 356.84C1046.42 356.84 1046.94 356.527 1047.24 355.902H1049.36C1049.13 356.649 1048.71 357.265 1048.07 357.75C1047.44 358.226 1046.66 358.464 1045.73 358.464C1044.99 358.464 1044.31 358.301 1043.72 357.974C1043.13 357.638 1042.67 357.167 1042.33 356.56C1042 355.953 1041.84 355.253 1041.84 354.46C1041.84 353.657 1042 352.953 1042.33 352.346C1042.66 351.739 1043.11 351.273 1043.7 350.946C1044.29 350.619 1044.97 350.456 1045.73 350.456C1046.47 350.456 1047.13 350.615 1047.71 350.932C1048.29 351.249 1048.75 351.702 1049.06 352.29C1049.39 352.869 1049.55 353.536 1049.55 354.292ZM1047.52 353.732C1047.52 353.228 1047.33 352.827 1046.98 352.528C1046.62 352.22 1046.19 352.066 1045.68 352.066C1045.19 352.066 1044.78 352.215 1044.44 352.514C1044.12 352.803 1043.92 353.209 1043.84 353.732H1047.52ZM1052.95 351.786C1053.2 351.375 1053.52 351.053 1053.93 350.82C1054.34 350.587 1054.8 350.47 1055.33 350.47V352.528H1054.81C1054.19 352.528 1053.72 352.673 1053.41 352.962C1053.1 353.251 1052.95 353.755 1052.95 354.474V358.338H1050.99V350.582H1052.95V351.786ZM1058.61 347.978V358.338H1056.65V347.978H1058.61ZM1061.54 349.658C1061.19 349.658 1060.9 349.551 1060.67 349.336C1060.44 349.112 1060.33 348.837 1060.33 348.51C1060.33 348.183 1060.44 347.913 1060.67 347.698C1060.9 347.474 1061.19 347.362 1061.54 347.362C1061.88 347.362 1062.17 347.474 1062.39 347.698C1062.62 347.913 1062.74 348.183 1062.74 348.51C1062.74 348.837 1062.62 349.112 1062.39 349.336C1062.17 349.551 1061.88 349.658 1061.54 349.658ZM1062.5 350.582V358.338H1060.54V350.582H1062.5ZM1068.74 350.47C1069.66 350.47 1070.41 350.764 1070.98 351.352C1071.55 351.931 1071.83 352.743 1071.83 353.788V358.338H1069.87V354.054C1069.87 353.438 1069.72 352.967 1069.41 352.64C1069.1 352.304 1068.68 352.136 1068.15 352.136C1067.61 352.136 1067.18 352.304 1066.86 352.64C1066.55 352.967 1066.4 353.438 1066.4 354.054V358.338H1064.44V350.582H1066.4V351.548C1066.66 351.212 1066.99 350.951 1067.39 350.764C1067.8 350.568 1068.25 350.47 1068.74 350.47Z",
  fill: "#AF6AF4"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter4_dddddddd_10458_6632)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 875,
  y: 337.039,
  width: 129.759,
  height: 41.5733,
  rx: 3.7794,
  fill: "white"
})), /*#__PURE__*/React.createElement("path", {
  d: "M904.32 362.961H902.36L897.922 356.255V362.961H895.962V353.175H897.922L902.36 359.895V353.175H904.32V362.961ZM913.467 358.915C913.467 359.195 913.448 359.447 913.411 359.671H907.741C907.788 360.231 907.984 360.67 908.329 360.987C908.674 361.304 909.099 361.463 909.603 361.463C910.331 361.463 910.849 361.15 911.157 360.525H913.271C913.047 361.272 912.618 361.888 911.983 362.373C911.348 362.849 910.569 363.087 909.645 363.087C908.898 363.087 908.226 362.924 907.629 362.597C907.041 362.261 906.579 361.79 906.243 361.183C905.916 360.576 905.753 359.876 905.753 359.083C905.753 358.28 905.916 357.576 906.243 356.969C906.57 356.362 907.027 355.896 907.615 355.569C908.203 355.242 908.88 355.079 909.645 355.079C910.382 355.079 911.04 355.238 911.619 355.555C912.207 355.872 912.66 356.325 912.977 356.913C913.304 357.492 913.467 358.159 913.467 358.915ZM911.437 358.355C911.428 357.851 911.246 357.45 910.891 357.151C910.536 356.843 910.102 356.689 909.589 356.689C909.104 356.689 908.693 356.838 908.357 357.137C908.03 357.426 907.83 357.832 907.755 358.355H911.437ZM917.18 356.815V360.567C917.18 360.828 917.24 361.02 917.362 361.141C917.492 361.253 917.707 361.309 918.006 361.309H918.916V362.961H917.684C916.032 362.961 915.206 362.158 915.206 360.553V356.815H914.282V355.205H915.206V353.287H917.18V355.205H918.916V356.815H917.18ZM924.693 355.093C925.281 355.093 925.804 355.224 926.261 355.485C926.719 355.737 927.073 356.115 927.325 356.619C927.587 357.114 927.717 357.711 927.717 358.411V362.961H925.757V358.677C925.757 358.061 925.603 357.59 925.295 357.263C924.987 356.927 924.567 356.759 924.035 356.759C923.494 356.759 923.065 356.927 922.747 357.263C922.439 357.59 922.285 358.061 922.285 358.677V362.961H920.325V352.601H922.285V356.171C922.537 355.835 922.873 355.574 923.293 355.387C923.713 355.191 924.18 355.093 924.693 355.093ZM936.791 358.915C936.791 359.195 936.773 359.447 936.735 359.671H931.065C931.112 360.231 931.308 360.67 931.653 360.987C931.999 361.304 932.423 361.463 932.927 361.463C933.655 361.463 934.173 361.15 934.481 360.525H936.595C936.371 361.272 935.942 361.888 935.307 362.373C934.673 362.849 933.893 363.087 932.969 363.087C932.223 363.087 931.551 362.924 930.953 362.597C930.365 362.261 929.903 361.79 929.567 361.183C929.241 360.576 929.077 359.876 929.077 359.083C929.077 358.28 929.241 357.576 929.567 356.969C929.894 356.362 930.351 355.896 930.939 355.569C931.527 355.242 932.204 355.079 932.969 355.079C933.707 355.079 934.365 355.238 934.943 355.555C935.531 355.872 935.984 356.325 936.301 356.913C936.628 357.492 936.791 358.159 936.791 358.915ZM934.761 358.355C934.752 357.851 934.57 357.45 934.215 357.151C933.861 356.843 933.427 356.689 932.913 356.689C932.428 356.689 932.017 356.838 931.681 357.137C931.355 357.426 931.154 357.832 931.079 358.355H934.761ZM940.182 356.409C940.434 355.998 940.761 355.676 941.162 355.443C941.573 355.21 942.039 355.093 942.562 355.093V357.151H942.044C941.428 357.151 940.961 357.296 940.644 357.585C940.336 357.874 940.182 358.378 940.182 359.097V362.961H938.222V355.205H940.182V356.409ZM945.842 352.601V362.961H943.882V352.601H945.842ZM947.274 359.055C947.274 358.271 947.428 357.576 947.736 356.969C948.054 356.362 948.479 355.896 949.011 355.569C949.552 355.242 950.154 355.079 950.817 355.079C951.395 355.079 951.899 355.196 952.329 355.429C952.767 355.662 953.117 355.956 953.379 356.311V355.205H955.353V362.961H953.379V361.827C953.127 362.191 952.777 362.494 952.329 362.737C951.89 362.97 951.381 363.087 950.803 363.087C950.149 363.087 949.552 362.919 949.011 362.583C948.479 362.247 948.054 361.776 947.736 361.169C947.428 360.553 947.274 359.848 947.274 359.055ZM953.379 359.083C953.379 358.607 953.285 358.201 953.099 357.865C952.912 357.52 952.66 357.258 952.343 357.081C952.025 356.894 951.685 356.801 951.321 356.801C950.957 356.801 950.621 356.89 950.312 357.067C950.005 357.244 949.753 357.506 949.557 357.851C949.37 358.187 949.277 358.588 949.277 359.055C949.277 359.522 949.37 359.932 949.557 360.287C949.753 360.632 950.005 360.898 950.312 361.085C950.63 361.272 950.966 361.365 951.321 361.365C951.685 361.365 952.025 361.276 952.343 361.099C952.66 360.912 952.912 360.651 953.099 360.315C953.285 359.97 953.379 359.559 953.379 359.083ZM961.565 355.093C962.489 355.093 963.235 355.387 963.805 355.975C964.374 356.554 964.659 357.366 964.659 358.411V362.961H962.699V358.677C962.699 358.061 962.545 357.59 962.237 357.263C961.929 356.927 961.509 356.759 960.977 356.759C960.435 356.759 960.006 356.927 959.689 357.263C959.381 357.59 959.227 358.061 959.227 358.677V362.961H957.267V355.205H959.227V356.171C959.488 355.835 959.819 355.574 960.221 355.387C960.631 355.191 961.079 355.093 961.565 355.093ZM966.019 359.055C966.019 358.271 966.173 357.576 966.481 356.969C966.798 356.362 967.227 355.896 967.769 355.569C968.31 355.242 968.912 355.079 969.575 355.079C970.079 355.079 970.559 355.191 971.017 355.415C971.474 355.63 971.838 355.919 972.109 356.283V352.601H974.097V362.961H972.109V361.813C971.866 362.196 971.525 362.504 971.087 362.737C970.648 362.97 970.139 363.087 969.561 363.087C968.907 363.087 968.31 362.919 967.769 362.583C967.227 362.247 966.798 361.776 966.481 361.169C966.173 360.553 966.019 359.848 966.019 359.055ZM972.123 359.083C972.123 358.607 972.029 358.201 971.843 357.865C971.656 357.52 971.404 357.258 971.087 357.081C970.769 356.894 970.429 356.801 970.065 356.801C969.701 356.801 969.365 356.89 969.057 357.067C968.749 357.244 968.497 357.506 968.301 357.851C968.114 358.187 968.021 358.588 968.021 359.055C968.021 359.522 968.114 359.932 968.301 360.287C968.497 360.632 968.749 360.898 969.057 361.085C969.374 361.272 969.71 361.365 970.065 361.365C970.429 361.365 970.769 361.276 971.087 361.099C971.404 360.912 971.656 360.651 971.843 360.315C972.029 359.97 972.123 359.559 972.123 359.083ZM978.979 363.087C978.344 363.087 977.775 362.975 977.271 362.751C976.767 362.518 976.366 362.205 976.067 361.813C975.778 361.421 975.619 360.987 975.591 360.511H977.565C977.602 360.81 977.747 361.057 977.999 361.253C978.26 361.449 978.582 361.547 978.965 361.547C979.338 361.547 979.628 361.472 979.833 361.323C980.048 361.174 980.155 360.982 980.155 360.749C980.155 360.497 980.024 360.31 979.763 360.189C979.511 360.058 979.105 359.918 978.545 359.769C977.966 359.629 977.49 359.484 977.117 359.335C976.753 359.186 976.436 358.957 976.165 358.649C975.904 358.341 975.773 357.926 975.773 357.403C975.773 356.974 975.894 356.582 976.137 356.227C976.389 355.872 976.744 355.592 977.201 355.387C977.668 355.182 978.214 355.079 978.839 355.079C979.763 355.079 980.5 355.312 981.051 355.779C981.602 356.236 981.905 356.857 981.961 357.641H980.085C980.057 357.333 979.926 357.09 979.693 356.913C979.469 356.726 979.166 356.633 978.783 356.633C978.428 356.633 978.153 356.698 977.957 356.829C977.77 356.96 977.677 357.142 977.677 357.375C977.677 357.636 977.808 357.837 978.069 357.977C978.33 358.108 978.736 358.243 979.287 358.383C979.847 358.523 980.309 358.668 980.673 358.817C981.037 358.966 981.35 359.2 981.611 359.517C981.882 359.825 982.022 360.236 982.031 360.749C982.031 361.197 981.905 361.598 981.653 361.953C981.41 362.308 981.056 362.588 980.589 362.793C980.132 362.989 979.595 363.087 978.979 363.087Z",
  fill: "#AF6AF4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M983.82 389.163C983.343 390.043 982.08 390.043 981.604 389.163L975.536 377.952C975.081 377.112 975.689 376.092 976.643 376.092L988.78 376.092C989.734 376.092 990.342 377.112 989.888 377.952L983.82 389.163Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter5_dddddddd_10458_6632)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 1009,
  y: 437,
  width: 120.941,
  height: 41.5733,
  rx: 3.7794,
  fill: "white"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1034.68 486.604C1034.2 487.485 1032.94 487.485 1032.46 486.604L1026.39 475.393C1025.94 474.554 1026.54 473.534 1027.5 473.534L1039.64 473.534C1040.59 473.534 1041.2 474.554 1040.74 475.393L1034.68 486.604Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1026.31 453.566V455.148H1023.71V463.338H1021.75V455.148H1019.14V453.566H1026.31ZM1034.95 459.292C1034.95 459.572 1034.93 459.824 1034.9 460.048H1029.23C1029.27 460.608 1029.47 461.047 1029.81 461.364C1030.16 461.681 1030.58 461.84 1031.09 461.84C1031.82 461.84 1032.33 461.527 1032.64 460.902H1034.76C1034.53 461.649 1034.1 462.265 1033.47 462.75C1032.83 463.226 1032.05 463.464 1031.13 463.464C1030.38 463.464 1029.71 463.301 1029.11 462.974C1028.53 462.638 1028.06 462.167 1027.73 461.56C1027.4 460.953 1027.24 460.253 1027.24 459.46C1027.24 458.657 1027.4 457.953 1027.73 457.346C1028.05 456.739 1028.51 456.273 1029.1 455.946C1029.69 455.619 1030.36 455.456 1031.13 455.456C1031.87 455.456 1032.52 455.615 1033.1 455.932C1033.69 456.249 1034.14 456.702 1034.46 457.29C1034.79 457.869 1034.95 458.536 1034.95 459.292ZM1032.92 458.732C1032.91 458.228 1032.73 457.827 1032.38 457.528C1032.02 457.22 1031.59 457.066 1031.07 457.066C1030.59 457.066 1030.18 457.215 1029.84 457.514C1029.51 457.803 1029.31 458.209 1029.24 458.732H1032.92ZM1038.34 452.978V463.338H1036.38V452.978H1038.34ZM1049.61 461.476H1045.71L1045.07 463.338H1043.01L1046.53 453.552H1048.81L1052.32 463.338H1050.25L1049.61 461.476ZM1049.07 459.908L1047.66 455.82L1046.25 459.908H1049.07ZM1056.87 461.532L1058.83 455.582H1060.92L1058.05 463.338H1055.67L1052.81 455.582H1054.91L1056.87 461.532ZM1063.01 454.658C1062.67 454.658 1062.38 454.551 1062.14 454.336C1061.92 454.112 1061.81 453.837 1061.81 453.51C1061.81 453.183 1061.92 452.913 1062.14 452.698C1062.38 452.474 1062.67 452.362 1063.01 452.362C1063.36 452.362 1063.64 452.474 1063.86 452.698C1064.1 452.913 1064.21 453.183 1064.21 453.51C1064.21 453.837 1064.1 454.112 1063.86 454.336C1063.64 454.551 1063.36 454.658 1063.01 454.658ZM1063.98 455.582V463.338H1062.02V455.582H1063.98ZM1069.15 461.532L1071.11 455.582H1073.19L1070.32 463.338H1067.94L1065.09 455.582H1067.19L1069.15 461.532ZM1076.44 461.28L1074.8 465.214H1073.54L1074.45 461.28H1076.44ZM1083.14 453.566V463.338H1081.18V453.566H1083.14ZM1088.05 463.464C1087.41 463.464 1086.85 463.352 1086.34 463.128C1085.84 462.895 1085.44 462.582 1085.14 462.19C1084.85 461.798 1084.69 461.364 1084.66 460.888H1086.64C1086.67 461.187 1086.82 461.434 1087.07 461.63C1087.33 461.826 1087.65 461.924 1088.04 461.924C1088.41 461.924 1088.7 461.849 1088.9 461.7C1089.12 461.551 1089.23 461.359 1089.23 461.126C1089.23 460.874 1089.09 460.687 1088.83 460.566C1088.58 460.435 1088.18 460.295 1087.62 460.146C1087.04 460.006 1086.56 459.861 1086.19 459.712C1085.82 459.563 1085.51 459.334 1085.24 459.026C1084.97 458.718 1084.84 458.303 1084.84 457.78C1084.84 457.351 1084.96 456.959 1085.21 456.604C1085.46 456.249 1085.81 455.969 1086.27 455.764C1086.74 455.559 1087.28 455.456 1087.91 455.456C1088.83 455.456 1089.57 455.689 1090.12 456.156C1090.67 456.613 1090.98 457.234 1091.03 458.018H1089.16C1089.13 457.71 1089 457.467 1088.76 457.29C1088.54 457.103 1088.24 457.01 1087.85 457.01C1087.5 457.01 1087.22 457.075 1087.03 457.206C1086.84 457.337 1086.75 457.519 1086.75 457.752C1086.75 458.013 1086.88 458.214 1087.14 458.354C1087.4 458.485 1087.81 458.62 1088.36 458.76C1088.92 458.9 1089.38 459.045 1089.74 459.194C1090.11 459.343 1090.42 459.577 1090.68 459.894C1090.95 460.202 1091.09 460.613 1091.1 461.126C1091.1 461.574 1090.98 461.975 1090.72 462.33C1090.48 462.685 1090.13 462.965 1089.66 463.17C1089.2 463.366 1088.67 463.464 1088.05 463.464ZM1094.67 456.786C1094.92 456.375 1095.25 456.053 1095.65 455.82C1096.06 455.587 1096.53 455.47 1097.05 455.47V457.528H1096.53C1095.92 457.528 1095.45 457.673 1095.13 457.962C1094.82 458.251 1094.67 458.755 1094.67 459.474V463.338H1092.71V455.582H1094.67V456.786ZM1097.87 459.432C1097.87 458.648 1098.02 457.953 1098.33 457.346C1098.65 456.739 1099.07 456.273 1099.6 455.946C1100.14 455.619 1100.75 455.456 1101.41 455.456C1101.99 455.456 1102.49 455.573 1102.92 455.806C1103.36 456.039 1103.71 456.333 1103.97 456.688V455.582H1105.94V463.338H1103.97V462.204C1103.72 462.568 1103.37 462.871 1102.92 463.114C1102.48 463.347 1101.97 463.464 1101.39 463.464C1100.74 463.464 1100.14 463.296 1099.6 462.96C1099.07 462.624 1098.65 462.153 1098.33 461.546C1098.02 460.93 1097.87 460.225 1097.87 459.432ZM1103.97 459.46C1103.97 458.984 1103.88 458.578 1103.69 458.242C1103.5 457.897 1103.25 457.635 1102.93 457.458C1102.62 457.271 1102.28 457.178 1101.91 457.178C1101.55 457.178 1101.21 457.267 1100.9 457.444C1100.6 457.621 1100.34 457.883 1100.15 458.228C1099.96 458.564 1099.87 458.965 1099.87 459.432C1099.87 459.899 1099.96 460.309 1100.15 460.664C1100.34 461.009 1100.6 461.275 1100.9 461.462C1101.22 461.649 1101.56 461.742 1101.91 461.742C1102.28 461.742 1102.62 461.653 1102.93 461.476C1103.25 461.289 1103.5 461.028 1103.69 460.692C1103.88 460.347 1103.97 459.936 1103.97 459.46ZM1115.07 459.292C1115.07 459.572 1115.05 459.824 1115.01 460.048H1109.34C1109.39 460.608 1109.59 461.047 1109.93 461.364C1110.28 461.681 1110.7 461.84 1111.2 461.84C1111.93 461.84 1112.45 461.527 1112.76 460.902H1114.87C1114.65 461.649 1114.22 462.265 1113.58 462.75C1112.95 463.226 1112.17 463.464 1111.25 463.464C1110.5 463.464 1109.83 463.301 1109.23 462.974C1108.64 462.638 1108.18 462.167 1107.84 461.56C1107.52 460.953 1107.35 460.253 1107.35 459.46C1107.35 458.657 1107.52 457.953 1107.84 457.346C1108.17 456.739 1108.63 456.273 1109.22 455.946C1109.8 455.619 1110.48 455.456 1111.25 455.456C1111.98 455.456 1112.64 455.615 1113.22 455.932C1113.81 456.249 1114.26 456.702 1114.58 457.29C1114.91 457.869 1115.07 458.536 1115.07 459.292ZM1113.04 458.732C1113.03 458.228 1112.85 457.827 1112.49 457.528C1112.14 457.22 1111.7 457.066 1111.19 457.066C1110.71 457.066 1110.29 457.215 1109.96 457.514C1109.63 457.803 1109.43 458.209 1109.36 458.732H1113.04ZM1118.46 452.978V463.338H1116.5V452.978H1118.46Z",
  fill: "#AF6AF4"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter6_dddddddd_10458_6632)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 1079,
  y: 488,
  width: 105.823,
  height: 41.5733,
  rx: 3.7794,
  fill: "white"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1150.03 536.345C1149.55 537.225 1148.29 537.225 1147.81 536.345L1141.74 525.133C1141.29 524.294 1141.9 523.274 1142.85 523.274L1154.99 523.274C1155.94 523.274 1156.55 524.294 1156.09 525.133L1150.03 536.345Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1097.91 504.566C1098.93 504.566 1099.83 504.767 1100.61 505.168C1101.39 505.569 1101.99 506.143 1102.41 506.89C1102.84 507.627 1103.06 508.486 1103.06 509.466C1103.06 510.446 1102.84 511.305 1102.41 512.042C1101.99 512.77 1101.39 513.335 1100.61 513.736C1099.83 514.137 1098.93 514.338 1097.91 514.338H1094.49V504.566H1097.91ZM1097.84 512.672C1098.86 512.672 1099.66 512.392 1100.22 511.832C1100.78 511.272 1101.06 510.483 1101.06 509.466C1101.06 508.449 1100.78 507.655 1100.22 507.086C1099.66 506.507 1098.86 506.218 1097.84 506.218H1096.45V512.672H1097.84ZM1111.85 506.582V514.338H1109.87V513.358C1109.62 513.694 1109.29 513.96 1108.88 514.156C1108.48 514.343 1108.04 514.436 1107.56 514.436C1106.96 514.436 1106.42 514.31 1105.95 514.058C1105.49 513.797 1105.12 513.419 1104.85 512.924C1104.59 512.42 1104.45 511.823 1104.45 511.132V506.582H1106.41V510.852C1106.41 511.468 1106.57 511.944 1106.88 512.28C1107.18 512.607 1107.6 512.77 1108.14 512.77C1108.68 512.77 1109.1 512.607 1109.41 512.28C1109.72 511.944 1109.87 511.468 1109.87 510.852V506.582H1111.85ZM1115.74 507.716C1115.99 507.343 1116.34 507.039 1116.78 506.806C1117.22 506.573 1117.73 506.456 1118.3 506.456C1118.97 506.456 1119.56 506.619 1120.09 506.946C1120.64 507.273 1121.06 507.739 1121.37 508.346C1121.69 508.943 1121.84 509.639 1121.84 510.432C1121.84 511.225 1121.69 511.93 1121.37 512.546C1121.06 513.153 1120.64 513.624 1120.09 513.96C1119.56 514.296 1118.97 514.464 1118.3 514.464C1117.72 514.464 1117.22 514.352 1116.78 514.128C1116.35 513.895 1116 513.596 1115.74 513.232V514.338H1113.78V503.978H1115.74V507.716ZM1119.84 510.432C1119.84 509.965 1119.74 509.564 1119.55 509.228C1119.36 508.883 1119.11 508.621 1118.79 508.444C1118.48 508.267 1118.15 508.178 1117.78 508.178C1117.43 508.178 1117.09 508.271 1116.78 508.458C1116.47 508.635 1116.22 508.897 1116.02 509.242C1115.83 509.587 1115.74 509.993 1115.74 510.46C1115.74 510.927 1115.83 511.333 1116.02 511.678C1116.22 512.023 1116.47 512.289 1116.78 512.476C1117.09 512.653 1117.43 512.742 1117.78 512.742C1118.15 512.742 1118.48 512.649 1118.79 512.462C1119.11 512.275 1119.36 512.009 1119.55 511.664C1119.74 511.319 1119.84 510.908 1119.84 510.432ZM1122.76 510.432C1122.76 509.648 1122.92 508.953 1123.23 508.346C1123.54 507.739 1123.97 507.273 1124.5 506.946C1125.04 506.619 1125.64 506.456 1126.31 506.456C1126.89 506.456 1127.39 506.573 1127.82 506.806C1128.26 507.039 1128.61 507.333 1128.87 507.688V506.582H1130.84V514.338H1128.87V513.204C1128.62 513.568 1128.27 513.871 1127.82 514.114C1127.38 514.347 1126.87 514.464 1126.29 514.464C1125.64 514.464 1125.04 514.296 1124.5 513.96C1123.97 513.624 1123.54 513.153 1123.23 512.546C1122.92 511.93 1122.76 511.225 1122.76 510.432ZM1128.87 510.46C1128.87 509.984 1128.78 509.578 1128.59 509.242C1128.4 508.897 1128.15 508.635 1127.83 508.458C1127.52 508.271 1127.17 508.178 1126.81 508.178C1126.45 508.178 1126.11 508.267 1125.8 508.444C1125.49 508.621 1125.24 508.883 1125.05 509.228C1124.86 509.564 1124.77 509.965 1124.77 510.432C1124.77 510.899 1124.86 511.309 1125.05 511.664C1125.24 512.009 1125.49 512.275 1125.8 512.462C1126.12 512.649 1126.46 512.742 1126.81 512.742C1127.17 512.742 1127.52 512.653 1127.83 512.476C1128.15 512.289 1128.4 512.028 1128.59 511.692C1128.78 511.347 1128.87 510.936 1128.87 510.46ZM1133.75 505.658C1133.41 505.658 1133.12 505.551 1132.88 505.336C1132.66 505.112 1132.55 504.837 1132.55 504.51C1132.55 504.183 1132.66 503.913 1132.88 503.698C1133.12 503.474 1133.41 503.362 1133.75 503.362C1134.1 503.362 1134.38 503.474 1134.61 503.698C1134.84 503.913 1134.96 504.183 1134.96 504.51C1134.96 504.837 1134.84 505.112 1134.61 505.336C1134.38 505.551 1134.1 505.658 1133.75 505.658ZM1134.72 506.582V514.338H1132.76V506.582H1134.72ZM1138.8 512.28L1137.16 516.214H1135.9L1136.81 512.28H1138.8ZM1145.48 504.566V510.614C1145.48 511.277 1145.65 511.785 1145.99 512.14C1146.34 512.485 1146.82 512.658 1147.45 512.658C1148.08 512.658 1148.57 512.485 1148.92 512.14C1149.27 511.785 1149.44 511.277 1149.44 510.614V504.566H1151.41V510.6C1151.41 511.431 1151.23 512.135 1150.87 512.714C1150.51 513.283 1150.03 513.713 1149.42 514.002C1148.83 514.291 1148.16 514.436 1147.42 514.436C1146.69 514.436 1146.03 514.291 1145.43 514.002C1144.85 513.713 1144.38 513.283 1144.03 512.714C1143.69 512.135 1143.52 511.431 1143.52 510.6V504.566H1145.48ZM1159.3 512.476H1155.41L1154.76 514.338H1152.7L1156.22 504.552H1158.5L1162.01 514.338H1159.94L1159.3 512.476ZM1158.77 510.908L1157.35 506.82L1155.94 510.908H1158.77ZM1165.29 506.148V508.598H1168.58V510.152H1165.29V512.742H1169V514.338H1163.33V504.552H1169V506.148H1165.29Z",
  fill: "#AF6AF4"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter7_dddddddd_10458_6632)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 1228,
  y: 471,
  width: 166.293,
  height: 41.5733,
  rx: 3.7794,
  fill: "white"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1253.68 520.604C1253.2 521.485 1251.94 521.485 1251.46 520.604L1245.39 509.393C1244.94 508.554 1245.54 507.534 1246.5 507.534L1258.64 507.534C1259.59 507.534 1260.2 508.554 1259.74 509.393L1253.68 520.604Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1240.77 490.506C1240.55 490.095 1240.24 489.783 1239.85 489.568C1239.45 489.353 1239 489.246 1238.47 489.246C1237.9 489.246 1237.38 489.377 1236.93 489.638C1236.49 489.899 1236.14 490.273 1235.88 490.758C1235.63 491.243 1235.51 491.803 1235.51 492.438C1235.51 493.091 1235.63 493.661 1235.88 494.146C1236.15 494.631 1236.5 495.005 1236.96 495.266C1237.42 495.527 1237.95 495.658 1238.56 495.658C1239.3 495.658 1239.92 495.462 1240.39 495.07C1240.87 494.669 1241.18 494.113 1241.33 493.404H1237.97V491.906H1243.26V493.614C1243.13 494.295 1242.85 494.925 1242.42 495.504C1241.99 496.083 1241.44 496.549 1240.76 496.904C1240.08 497.249 1239.33 497.422 1238.49 497.422C1237.55 497.422 1236.69 497.212 1235.93 496.792C1235.17 496.363 1234.57 495.77 1234.13 495.014C1233.7 494.258 1233.49 493.399 1233.49 492.438C1233.49 491.477 1233.7 490.618 1234.13 489.862C1234.57 489.097 1235.17 488.504 1235.93 488.084C1236.69 487.655 1237.54 487.44 1238.47 487.44C1239.58 487.44 1240.53 487.711 1241.34 488.252C1242.16 488.784 1242.72 489.535 1243.02 490.506H1240.77ZM1252.03 489.582V497.338H1250.06V496.358C1249.81 496.694 1249.48 496.96 1249.07 497.156C1248.66 497.343 1248.23 497.436 1247.75 497.436C1247.14 497.436 1246.61 497.31 1246.14 497.058C1245.67 496.797 1245.3 496.419 1245.03 495.924C1244.77 495.42 1244.64 494.823 1244.64 494.132V489.582H1246.6V493.852C1246.6 494.468 1246.76 494.944 1247.06 495.28C1247.37 495.607 1247.79 495.77 1248.32 495.77C1248.87 495.77 1249.29 495.607 1249.6 495.28C1249.91 494.944 1250.06 494.468 1250.06 493.852V489.582H1252.03ZM1255.93 490.786C1256.18 490.375 1256.51 490.053 1256.91 489.82C1257.32 489.587 1257.79 489.47 1258.31 489.47V491.528H1257.79C1257.17 491.528 1256.71 491.673 1256.39 491.962C1256.08 492.251 1255.93 492.755 1255.93 493.474V497.338H1253.97V489.582H1255.93V490.786ZM1266.95 489.582V497.338H1264.98V496.358C1264.72 496.694 1264.39 496.96 1263.98 497.156C1263.58 497.343 1263.14 497.436 1262.67 497.436C1262.06 497.436 1261.52 497.31 1261.06 497.058C1260.59 496.797 1260.22 496.419 1259.95 495.924C1259.69 495.42 1259.56 494.823 1259.56 494.132V489.582H1261.52V493.852C1261.52 494.468 1261.67 494.944 1261.98 495.28C1262.29 495.607 1262.71 495.77 1263.24 495.77C1263.78 495.77 1264.21 495.607 1264.51 495.28C1264.82 494.944 1264.98 494.468 1264.98 493.852V489.582H1266.95ZM1271.92 489.456C1272.5 489.456 1273.01 489.573 1273.45 489.806C1273.89 490.03 1274.23 490.324 1274.48 490.688V489.582H1276.46V497.394C1276.46 498.113 1276.31 498.752 1276.02 499.312C1275.73 499.881 1275.3 500.329 1274.72 500.656C1274.14 500.992 1273.44 501.16 1272.62 501.16C1271.52 501.16 1270.62 500.903 1269.91 500.39C1269.21 499.877 1268.81 499.177 1268.72 498.29H1270.66C1270.76 498.645 1270.98 498.925 1271.32 499.13C1271.67 499.345 1272.08 499.452 1272.57 499.452C1273.14 499.452 1273.6 499.279 1273.95 498.934C1274.31 498.598 1274.48 498.085 1274.48 497.394V496.19C1274.23 496.554 1273.88 496.857 1273.43 497.1C1273 497.343 1272.49 497.464 1271.92 497.464C1271.27 497.464 1270.67 497.296 1270.13 496.96C1269.59 496.624 1269.16 496.153 1268.84 495.546C1268.53 494.93 1268.38 494.225 1268.38 493.432C1268.38 492.648 1268.53 491.953 1268.84 491.346C1269.16 490.739 1269.58 490.273 1270.12 489.946C1270.66 489.619 1271.26 489.456 1271.92 489.456ZM1274.48 493.46C1274.48 492.984 1274.39 492.578 1274.2 492.242C1274.02 491.897 1273.77 491.635 1273.45 491.458C1273.13 491.271 1272.79 491.178 1272.43 491.178C1272.06 491.178 1271.73 491.267 1271.42 491.444C1271.11 491.621 1270.86 491.883 1270.66 492.228C1270.48 492.564 1270.38 492.965 1270.38 493.432C1270.38 493.899 1270.48 494.309 1270.66 494.664C1270.86 495.009 1271.11 495.275 1271.42 495.462C1271.74 495.649 1272.07 495.742 1272.43 495.742C1272.79 495.742 1273.13 495.653 1273.45 495.476C1273.77 495.289 1274.02 495.028 1274.2 494.692C1274.39 494.347 1274.48 493.936 1274.48 493.46ZM1280.33 490.786C1280.58 490.375 1280.91 490.053 1281.31 489.82C1281.72 489.587 1282.19 489.47 1282.71 489.47V491.528H1282.19C1281.58 491.528 1281.11 491.673 1280.79 491.962C1280.49 492.251 1280.33 492.755 1280.33 493.474V497.338H1278.37V489.582H1280.33V490.786ZM1283.53 493.432C1283.53 492.648 1283.68 491.953 1283.99 491.346C1284.31 490.739 1284.73 490.273 1285.26 489.946C1285.81 489.619 1286.41 489.456 1287.07 489.456C1287.65 489.456 1288.15 489.573 1288.58 489.806C1289.02 490.039 1289.37 490.333 1289.63 490.688V489.582H1291.61V497.338H1289.63V496.204C1289.38 496.568 1289.03 496.871 1288.58 497.114C1288.14 497.347 1287.64 497.464 1287.06 497.464C1286.4 497.464 1285.81 497.296 1285.26 496.96C1284.73 496.624 1284.31 496.153 1283.99 495.546C1283.68 494.93 1283.53 494.225 1283.53 493.432ZM1289.63 493.46C1289.63 492.984 1289.54 492.578 1289.35 492.242C1289.17 491.897 1288.91 491.635 1288.6 491.458C1288.28 491.271 1287.94 491.178 1287.57 491.178C1287.21 491.178 1286.87 491.267 1286.57 491.444C1286.26 491.621 1286.01 491.883 1285.81 492.228C1285.62 492.564 1285.53 492.965 1285.53 493.432C1285.53 493.899 1285.62 494.309 1285.81 494.664C1286.01 495.009 1286.26 495.275 1286.57 495.462C1286.88 495.649 1287.22 495.742 1287.57 495.742C1287.94 495.742 1288.28 495.653 1288.6 495.476C1288.91 495.289 1289.17 495.028 1289.35 494.692C1289.54 494.347 1289.63 493.936 1289.63 493.46ZM1303.15 489.47C1304.1 489.47 1304.87 489.764 1305.45 490.352C1306.04 490.931 1306.33 491.743 1306.33 492.788V497.338H1304.37V493.054C1304.37 492.447 1304.22 491.985 1303.91 491.668C1303.6 491.341 1303.18 491.178 1302.65 491.178C1302.12 491.178 1301.69 491.341 1301.37 491.668C1301.07 491.985 1300.91 492.447 1300.91 493.054V497.338H1298.95V493.054C1298.95 492.447 1298.8 491.985 1298.49 491.668C1298.18 491.341 1297.76 491.178 1297.23 491.178C1296.69 491.178 1296.26 491.341 1295.94 491.668C1295.63 491.985 1295.48 492.447 1295.48 493.054V497.338H1293.52V489.582H1295.48V490.52C1295.73 490.193 1296.05 489.937 1296.45 489.75C1296.85 489.563 1297.29 489.47 1297.76 489.47C1298.37 489.47 1298.91 489.601 1299.39 489.862C1299.86 490.114 1300.23 490.478 1300.49 490.954C1300.74 490.506 1301.11 490.147 1301.58 489.876C1302.07 489.605 1302.59 489.47 1303.15 489.47ZM1310.33 495.28L1308.69 499.214H1307.43L1308.34 495.28H1310.33ZM1317.04 487.566V497.338H1315.08V487.566H1317.04ZM1323.28 489.47C1324.2 489.47 1324.95 489.764 1325.52 490.352C1326.09 490.931 1326.37 491.743 1326.37 492.788V497.338H1324.41V493.054C1324.41 492.438 1324.26 491.967 1323.95 491.64C1323.64 491.304 1323.22 491.136 1322.69 491.136C1322.15 491.136 1321.72 491.304 1321.4 491.64C1321.09 491.967 1320.94 492.438 1320.94 493.054V497.338H1318.98V489.582H1320.94V490.548C1321.2 490.212 1321.53 489.951 1321.93 489.764C1322.34 489.568 1322.79 489.47 1323.28 489.47ZM1327.73 493.432C1327.73 492.648 1327.88 491.953 1328.19 491.346C1328.51 490.739 1328.94 490.273 1329.48 489.946C1330.02 489.619 1330.62 489.456 1331.29 489.456C1331.79 489.456 1332.27 489.568 1332.73 489.792C1333.18 490.007 1333.55 490.296 1333.82 490.66V486.978H1335.81V497.338H1333.82V496.19C1333.58 496.573 1333.24 496.881 1332.8 497.114C1332.36 497.347 1331.85 497.464 1331.27 497.464C1330.62 497.464 1330.02 497.296 1329.48 496.96C1328.94 496.624 1328.51 496.153 1328.19 495.546C1327.88 494.93 1327.73 494.225 1327.73 493.432ZM1333.83 493.46C1333.83 492.984 1333.74 492.578 1333.55 492.242C1333.37 491.897 1333.11 491.635 1332.8 491.458C1332.48 491.271 1332.14 491.178 1331.78 491.178C1331.41 491.178 1331.08 491.267 1330.77 491.444C1330.46 491.621 1330.21 491.883 1330.01 492.228C1329.82 492.564 1329.73 492.965 1329.73 493.432C1329.73 493.899 1329.82 494.309 1330.01 494.664C1330.21 495.009 1330.46 495.275 1330.77 495.462C1331.08 495.649 1331.42 495.742 1331.78 495.742C1332.14 495.742 1332.48 495.653 1332.8 495.476C1333.11 495.289 1333.37 495.028 1333.55 494.692C1333.74 494.347 1333.83 493.936 1333.83 493.46ZM1338.72 488.658C1338.37 488.658 1338.08 488.551 1337.85 488.336C1337.62 488.112 1337.51 487.837 1337.51 487.51C1337.51 487.183 1337.62 486.913 1337.85 486.698C1338.08 486.474 1338.37 486.362 1338.72 486.362C1339.06 486.362 1339.35 486.474 1339.57 486.698C1339.8 486.913 1339.92 487.183 1339.92 487.51C1339.92 487.837 1339.8 488.112 1339.57 488.336C1339.35 488.551 1339.06 488.658 1338.72 488.658ZM1339.68 489.582V497.338H1337.72V489.582H1339.68ZM1341.11 493.432C1341.11 492.648 1341.27 491.953 1341.58 491.346C1341.89 490.739 1342.32 490.273 1342.85 489.946C1343.39 489.619 1343.99 489.456 1344.66 489.456C1345.24 489.456 1345.74 489.573 1346.17 489.806C1346.61 490.039 1346.96 490.333 1347.22 490.688V489.582H1349.19V497.338H1347.22V496.204C1346.97 496.568 1346.62 496.871 1346.17 497.114C1345.73 497.347 1345.22 497.464 1344.64 497.464C1343.99 497.464 1343.39 497.296 1342.85 496.96C1342.32 496.624 1341.89 496.153 1341.58 495.546C1341.27 494.93 1341.11 494.225 1341.11 493.432ZM1347.22 493.46C1347.22 492.984 1347.13 492.578 1346.94 492.242C1346.75 491.897 1346.5 491.635 1346.18 491.458C1345.87 491.271 1345.52 491.178 1345.16 491.178C1344.8 491.178 1344.46 491.267 1344.15 491.444C1343.84 491.621 1343.59 491.883 1343.4 492.228C1343.21 492.564 1343.12 492.965 1343.12 493.432C1343.12 493.899 1343.21 494.309 1343.4 494.664C1343.59 495.009 1343.84 495.275 1344.15 495.462C1344.47 495.649 1344.81 495.742 1345.16 495.742C1345.52 495.742 1345.87 495.653 1346.18 495.476C1346.5 495.289 1346.75 495.028 1346.94 494.692C1347.13 494.347 1347.22 493.936 1347.22 493.46ZM1357.83 500.096C1356.93 499.219 1356.22 498.099 1355.72 496.736C1355.22 495.373 1354.97 493.913 1354.97 492.354C1354.97 490.758 1355.24 489.26 1355.76 487.86C1356.28 486.451 1357.04 485.298 1358.04 484.402H1360.01V484.584C1358.99 485.564 1358.2 486.74 1357.66 488.112C1357.13 489.484 1356.86 490.898 1356.86 492.354C1356.86 493.773 1357.12 495.145 1357.62 496.47C1358.13 497.786 1358.86 498.929 1359.8 499.9V500.096H1357.83ZM1369.34 487.566V497.338H1367.38V493.18H1363.2V497.338H1361.24V487.566H1363.2V491.584H1367.38V487.566H1369.34ZM1378.55 499.06L1377.07 497.282C1376.66 497.385 1376.24 497.436 1375.81 497.436C1374.89 497.436 1374.05 497.221 1373.29 496.792C1372.52 496.363 1371.92 495.77 1371.47 495.014C1371.02 494.249 1370.8 493.385 1370.8 492.424C1370.8 491.472 1371.02 490.618 1371.47 489.862C1371.92 489.097 1372.52 488.499 1373.29 488.07C1374.05 487.641 1374.89 487.426 1375.81 487.426C1376.73 487.426 1377.57 487.641 1378.33 488.07C1379.09 488.499 1379.7 489.097 1380.13 489.862C1380.58 490.618 1380.81 491.472 1380.81 492.424C1380.81 493.292 1380.62 494.085 1380.25 494.804C1379.88 495.513 1379.38 496.092 1378.75 496.54L1380.99 499.06H1378.55ZM1372.81 492.424C1372.81 493.077 1372.94 493.651 1373.19 494.146C1373.44 494.641 1373.79 495.023 1374.24 495.294C1374.7 495.555 1375.22 495.686 1375.81 495.686C1376.4 495.686 1376.91 495.555 1377.36 495.294C1377.81 495.023 1378.16 494.641 1378.41 494.146C1378.66 493.651 1378.79 493.077 1378.79 492.424C1378.79 491.771 1378.66 491.201 1378.41 490.716C1378.16 490.221 1377.81 489.843 1377.36 489.582C1376.91 489.321 1376.4 489.19 1375.81 489.19C1375.22 489.19 1374.7 489.321 1374.24 489.582C1373.79 489.843 1373.44 490.221 1373.19 490.716C1372.94 491.201 1372.81 491.771 1372.81 492.424ZM1381.79 500.096V499.9C1382.73 498.929 1383.45 497.786 1383.96 496.47C1384.47 495.145 1384.73 493.773 1384.73 492.354C1384.73 490.898 1384.46 489.484 1383.92 488.112C1383.38 486.74 1382.6 485.564 1381.58 484.584V484.402H1383.55C1384.55 485.298 1385.31 486.451 1385.83 487.86C1386.36 489.26 1386.62 490.758 1386.62 492.354C1386.62 493.913 1386.37 495.373 1385.86 496.736C1385.37 498.099 1384.67 499.219 1383.76 500.096H1381.79Z",
  fill: "#AF6AF4"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_dddd_10458_6632",
  x: 180,
  y: 127.793,
  width: 1560,
  height: 1010.91,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 5.38927
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.51002
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0588235 0 0 0 0 0.0313726 0 0 0 0 0.262745 0 0 0 0.0414311 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 14.9006
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5.62011
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.252036 0 0 0 0 0.19566 0 0 0 0 0.670833 0 0 0 0.0458509 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_10458_6632",
  result: "effect2_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 35.875
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 24.0409
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.209938 0 0 0 0 0.141163 0 0 0 0 0.720833 0 0 0 0.0469633 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow_10458_6632",
  result: "effect3_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 119
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 40
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.220859 0 0 0 0 0.148507 0 0 0 0 0.758333 0 0 0 0.07 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect3_dropShadow_10458_6632",
  result: "effect4_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect4_dropShadow_10458_6632",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_dddddddd_10458_6632",
  x: 418.073,
  y: 425.54,
  width: 248.147,
  height: 156.022,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1.25696
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3.22138
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0241386 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2.85592
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5.83206
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0310556 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_10458_6632",
  result: "effect2_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4.9706
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 7.71546
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0342799 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow_10458_6632",
  result: "effect3_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 7.89626
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8.73967
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0361867 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect3_dropShadow_10458_6632",
  result: "effect4_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 12.1833
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8.82975
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0380395 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect4_dropShadow_10458_6632",
  result: "effect5_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 19.0111
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8.39254
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0410845 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect5_dropShadow_10458_6632",
  result: "effect6_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 31.5615
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10.2522
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0476106 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect6_dropShadow_10458_6632",
  result: "effect7_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 63.0613
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 20.4636
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.07 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect7_dropShadow_10458_6632",
  result: "effect8_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect8_dropShadow_10458_6632",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_dddddddd_10458_6632",
  x: 366.073,
  y: 363.54,
  width: 214.132,
  height: 156.022,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1.25696
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3.22138
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0241386 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2.85592
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5.83206
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0310556 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_10458_6632",
  result: "effect2_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4.9706
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 7.71546
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0342799 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow_10458_6632",
  result: "effect3_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 7.89626
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8.73967
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0361867 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect3_dropShadow_10458_6632",
  result: "effect4_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 12.1833
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8.82975
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0380395 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect4_dropShadow_10458_6632",
  result: "effect5_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 19.0111
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8.39254
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0410845 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect5_dropShadow_10458_6632",
  result: "effect6_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 31.5615
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10.2522
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0476106 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect6_dropShadow_10458_6632",
  result: "effect7_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 63.0613
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 20.4636
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.07 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect7_dropShadow_10458_6632",
  result: "effect8_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect8_dropShadow_10458_6632",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_dddddddd_10458_6632",
  x: 973.917,
  y: 321.54,
  width: 158.702,
  height: 156.022,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1.25696
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3.22138
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0241386 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2.85592
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5.83206
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0310556 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_10458_6632",
  result: "effect2_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4.9706
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 7.71546
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0342799 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow_10458_6632",
  result: "effect3_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 7.89626
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8.73967
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0361867 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect3_dropShadow_10458_6632",
  result: "effect4_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 12.1833
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8.82975
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0380395 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect4_dropShadow_10458_6632",
  result: "effect5_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 19.0111
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8.39254
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0410845 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect5_dropShadow_10458_6632",
  result: "effect6_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 31.5615
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10.2522
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0476106 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect6_dropShadow_10458_6632",
  result: "effect7_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 63.0613
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 20.4636
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.07 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect7_dropShadow_10458_6632",
  result: "effect8_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect8_dropShadow_10458_6632",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter4_dddddddd_10458_6632",
  x: 834.073,
  y: 326.579,
  width: 211.612,
  height: 156.022,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1.25696
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3.22138
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0241386 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2.85592
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5.83206
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0310556 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_10458_6632",
  result: "effect2_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4.9706
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 7.71546
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0342799 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow_10458_6632",
  result: "effect3_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 7.89626
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8.73967
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0361867 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect3_dropShadow_10458_6632",
  result: "effect4_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 12.1833
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8.82975
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0380395 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect4_dropShadow_10458_6632",
  result: "effect5_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 19.0111
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8.39254
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0410845 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect5_dropShadow_10458_6632",
  result: "effect6_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 31.5615
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10.2522
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0476106 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect6_dropShadow_10458_6632",
  result: "effect7_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 63.0613
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 20.4636
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.07 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect7_dropShadow_10458_6632",
  result: "effect8_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect8_dropShadow_10458_6632",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter5_dddddddd_10458_6632",
  x: 968.073,
  y: 426.54,
  width: 202.796,
  height: 156.022,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1.25696
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3.22138
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0241386 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2.85592
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5.83206
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0310556 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_10458_6632",
  result: "effect2_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4.9706
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 7.71546
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0342799 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow_10458_6632",
  result: "effect3_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 7.89626
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8.73967
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0361867 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect3_dropShadow_10458_6632",
  result: "effect4_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 12.1833
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8.82975
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0380395 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect4_dropShadow_10458_6632",
  result: "effect5_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 19.0111
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8.39254
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0410845 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect5_dropShadow_10458_6632",
  result: "effect6_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 31.5615
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10.2522
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0476106 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect6_dropShadow_10458_6632",
  result: "effect7_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 63.0613
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 20.4636
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.07 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect7_dropShadow_10458_6632",
  result: "effect8_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect8_dropShadow_10458_6632",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter6_dddddddd_10458_6632",
  x: 1038.07,
  y: 477.54,
  width: 187.679,
  height: 156.022,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1.25696
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3.22138
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0241386 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2.85592
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5.83206
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0310556 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_10458_6632",
  result: "effect2_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4.9706
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 7.71546
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0342799 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow_10458_6632",
  result: "effect3_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 7.89626
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8.73967
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0361867 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect3_dropShadow_10458_6632",
  result: "effect4_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 12.1833
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8.82975
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0380395 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect4_dropShadow_10458_6632",
  result: "effect5_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 19.0111
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8.39254
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0410845 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect5_dropShadow_10458_6632",
  result: "effect6_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 31.5615
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10.2522
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0476106 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect6_dropShadow_10458_6632",
  result: "effect7_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 63.0613
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 20.4636
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.07 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect7_dropShadow_10458_6632",
  result: "effect8_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect8_dropShadow_10458_6632",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter7_dddddddd_10458_6632",
  x: 1187.07,
  y: 460.54,
  width: 248.147,
  height: 156.022,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1.25696
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3.22138
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0241386 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2.85592
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5.83206
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0310556 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_10458_6632",
  result: "effect2_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4.9706
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 7.71546
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0342799 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect2_dropShadow_10458_6632",
  result: "effect3_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 7.89626
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8.73967
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0361867 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect3_dropShadow_10458_6632",
  result: "effect4_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 12.1833
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8.82975
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0380395 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect4_dropShadow_10458_6632",
  result: "effect5_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 19.0111
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 8.39254
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0410845 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect5_dropShadow_10458_6632",
  result: "effect6_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 31.5615
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10.2522
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.0476106 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect6_dropShadow_10458_6632",
  result: "effect7_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 63.0613
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 20.4636
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.0784314 0 0 0 0 0 0 0 0 0 0.258824 0 0 0 0.07 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect7_dropShadow_10458_6632",
  result: "effect8_dropShadow_10458_6632"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect8_dropShadow_10458_6632",
  result: "shape"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_10458_6632"
}, /*#__PURE__*/React.createElement("rect", {
  width: 1920,
  height: 1080,
  fill: "white"
})));
function SvgGlobalFootPrintBgImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalFootPrintBgImage);
export default __webpack_public_path__ + "static/media/globalFootPrintBgImage.403ecefa.svg";
export { ForwardRef as ReactComponent };